// before 20-5-2025

// import { Skeleton, useMediaQuery, useTheme } from '@mui/material';
// import React, { useEffect, useState, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// // import PublishIcon from '@mui/icons-material/Publish';
// import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import { useLocation } from 'react-router-dom';
// // import DataUsageIcon from '@mui/icons-material/DataUsage'; // ✅ أيقونة البيانات
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
// import DataUsageIcon from '@mui/icons-material/DataUsage';
// import { Getalldatasearch_For_Admin } from '../Redux/Actions/All_Leads_For_Admin_Action';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Box,
//   CircularProgress,
//   Chip,
//   Pagination,
//   Stack,
//   Card,
//   CardContent,
//   Avatar,
//   TextField,
//   MenuItem,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Checkbox,
//   FormControlLabel,
//   Switch,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Divider,
//   Snackbar,
//   Alert,
//   Tooltip,
//   Grid,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import SettingsIcon from '@mui/icons-material/Settings';
// import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import SevereColdIcon from '@mui/icons-material/SevereCold';
// import CheckIcon from '@mui/icons-material/Check';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import moment from 'moment';
// import { ClientTablee } from '../Component/ClientTablee';
// import { AssignLeadsModal } from './AssignLeadsModal';
// import { ClientTable2 } from '../Component/ClientTable2';
// import { Form, Modal, Spinner } from 'react-bootstrap';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import { UpdateClientAction } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import CloseIcon from '@mui/icons-material/Close';
// import { ShowAllCommentsForoneuser } from '../Component/ShowAllCommentsForoneuser';
// import { ShowClientsActions } from '../Component/ShowClientsActions';
// import { Link } from 'react-router-dom';
// import { LeadDuplicationModal } from './LeadDuplicationModal';
// import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
// import FilterListIcon from '@mui/icons-material/FilterList';

// // استيراد مكتبة السحب والإفلات
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import QuickFilterModal from './QuickFilterModal';
// import XLSX from '../utils/excelUtils';
// import axios from 'axios';
// import { db_url } from '../Api/BaseUrl';
// import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';
// import { Transfere_Leads_TO_Data_Center_Action } from '../Redux/Actions/CrmDataAction';
// import { ShowUserSheet } from './ShowUserSheet';
// import { ShoweetingShwwtForAdmin } from './ShoweetingShwwtForAdmin';

// // PhoneCell Component
// const PhoneCell = React.memo(({ user, mode }) => {
//   const [showFullNumber, setShowFullNumber] = useState(false);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'left',
//         gap: 0.5,
//       }}
//       onMouseEnter={() => setShowFullNumber(true)}
//       onMouseLeave={() => setShowFullNumber(false)}
//     >
//       {/* Phone Number - Show first 5 digits normally, full number on hover */}
//       {user.phone && (
//         <Typography
//           variant="body2"
//           sx={{
//             cursor: 'pointer',
//             padding: '4px 8px',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//             transition: 'all 0.2s ease-in-out',
//             fontFamily: 'monospace',
//             fontWeight: '500',
//             minHeight: '32px',
//             display: 'flex',
//             alignItems: 'left',
//             justifyContent: 'left',
//             minWidth: '80px',
//             '&:hover': {
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//             },
//           }}
//         >
//           {showFullNumber ? user.phone : `${user.phone.substring(0, 5)}...`}
//         </Typography>
//       )}

//       {/* Icons Container */}
//       <Box sx={{ display: 'flex', alignItems: 'left', gap: 1 }}>
//         {/* WhatsApp Icon */}
//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               const whatsappUrl = `https://wa.me/${user.phone.replace(/\D/g, '')}`;
//               window.open(whatsappUrl, '_blank');
//             }
//           }}
//           sx={{
//             color: '#25D366',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(37, 211, 102, 0.1)' : 'rgba(37, 211, 102, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(37, 211, 102, 0.2)' : 'rgba(37, 211, 102, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.189-1.248-6.189-3.515-8.452" />
//           </svg>
//         </IconButton>

//         {/* Phone Icon */}
//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               window.open(`tel:${user.phone}`);
//             }
//           }}
//           sx={{
//             color: '#1976d2',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
//           </svg>
//         </IconButton>
//       </Box>
//     </Box>
//   );
// });

// export const AllLeads_For_Admins_Page = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const location = useLocation();

//   const dispatch = useDispatch();
//   const [loadinggetdtaa, setloadinggetdata] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(25);
//   const [goToPageDialog, setGoToPageDialog] = useState(false);
//   const [pageInput, setPageInput] = useState('');
//   const [tableSettingsOpen, setTableSettingsOpen] = useState(false);
//   const [message, setMessage] = useState('');
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [expandedRows, setExpandedRows] = useState({});
//   // في الـ component state أضيف:
//   const [hoveredLeadId, setHoveredLeadId] = useState(null);
//   const [loadingComments, setLoadingComments] = useState(false);
//   const [comments, setComments] = useState([]);
//   // 🔄 إضافة الـ refs للإدارة الذكية للطلبات
//   const isFetchingRef = useRef(false);
//   const currentStageRef = useRef('');
//   const pendingRequestRef = useRef(null);
//   const initialLoadDoneRef = useRef(false);

//   // get all information about logged user
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // Assign & Transfer States
//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [openassign, setOpenassign] = useState(false);

//   // 🔍 نأخذ الـ search من localStorage اللي بيتحكم فيه الـ navbar
//   const [searchQuery, setSearchQuery] = useState(localStorage.getItem('mainsearchstorage') || '');

//   // 📋 Selection State
//   const [selectedLeads, setSelectedLeads] = useState(() => {
//     const saved = localStorage.getItem('selectedleeds');
//     return saved ? JSON.parse(saved) : [];
//   });
//   const [selectAll, setSelectAll] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   // 📊 Default table configuration
//   const defaultTableConfig = {
//     columns: [
//       { key: 'selection', label: '', visible: true, width: 60 },
//       { key: 'duplicate', label: 'Duplicate', visible: true, width: 120 },
//       { key: 'name', label: 'Name', visible: true, width: 180 },
//       { key: 'phone', label: 'Phone', visible: true, width: 140 },
//       { key: 'developer', label: 'Developer', visible: true, width: 120 },
//       { key: 'project', label: 'Project', visible: true, width: 150 },
//       { key: 'campaign', label: 'Campaign', visible: true, width: 150 },
//       { key: 'Channal', label: 'Channal', visible: true, width: 150 },
//       { key: 'sales', label: 'Sales', visible: true, width: 150 },
//       { key: 'lastComment', label: 'Last Comment', visible: true, width: 80 }, // ⬅️ الجديدة
//       { key: 'stage', label: 'Stage', visible: true, width: 180 },
//       { key: 'status', label: 'Status', visible: true, width: 100 },
//       { key: 'Creation_date', label: 'Creation Date', visible: true, width: 180 },
//       { key: 'AddedBy', label: 'Added By', visible: true, width: 200 },
//       { key: 'actions', label: 'Actions', visible: true, width: 120 },
//     ],
//     columnOrder: [
//       'selection',
//       'duplicate',
//       'name',
//       'phone',
//       'developer',
//       'project',
//       'campaign',
//       'Channal',
//       'sales',
//       'lastComment',
//       'stage',
//       'status',
//       'Creation_date',
//       'AddedBy',
//       'actions',
//     ],
//     whiteHeaders: true,
//   };

//   // 📊 Table customization state - Load from localStorage
//   const [tableConfig, setTableConfig] = useState(() => {
//     const savedConfig = localStorage.getItem('leadsTableConfig');
//     return savedConfig ? JSON.parse(savedConfig) : defaultTableConfig;
//   });

//   // 💾 Save table config to localStorage whenever it changes
//   useEffect(() => {
//     localStorage.setItem('leadsTableConfig', JSON.stringify(tableConfig));
//   }, [tableConfig]);

//   // 💾 Save selected leads to localStorage
//   useEffect(() => {
//     localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads));
//   }, [selectedLeads]);

//   // 🔔 Show/hide snackbar based on selection
//   useEffect(() => {
//     setSnackbarOpen(selectedLeads.length > 0);
//   }, [selectedLeads]);

//   // Assign & Transfer Functions
//   const handleAssignClick = () => {
//     if (selectedLeads?.length === 0) {
//       console.log('Please select at least one Lead for assignment.');
//       return;
//     }
//     localStorage.setItem('action', 'Assign');
//     setShowAssignModal(true);
//     setOpenassign(false);
//   };

//   const handleTransferClick = () => {
//     if (selectedLeads?.length === 0) {
//       console.log('Please select at least one Lead for transfer.');
//       return;
//     }

//     const selectedLeadsData =
//       resleads?.data?.filter((lead) => selectedLeads.includes(lead._id)) || [];
//     const allAreTransfer = selectedLeadsData.every((lead) => lead.stage?.name === 'Transfer');

//     if (!allAreTransfer) {
//       console.log('This icon is for Transfer Leads only.');
//       return;
//     }

//     localStorage.setItem('action', 'Transfer');
//     setShowAssignModal(true);
//     setOpenassign(false);
//   };

//   const handleCloseAssignModal = () => {
//     setShowAssignModal(false);
//   };

//   const handleCloseassign = () => {
//     setOpenassign(false);
//   };

//   const [showmoredelete, setshowmoredelete] = useState(false);

//   const handleClosemoredelete = () => {
//     setshowmoredelete(false);
//   };

//   const handleShowmoredelete = () => {
//     setshowmoredelete(true);
//   };

//   const searchParams2 = new URLSearchParams(location.search);
//   const duplicates2 = searchParams2.get('duplicates');
//   const ignoreduplicate2 = searchParams2.get('ignoreduplicate');
//   const handleignoreupdate = async () => {
//     if (selectedLeads?.length === 0) {
//       Notify('error', 'Please select at least one Lead to ignore duplicate.', 'error');
//       return;
//     }

//     try {
//       // حفظ الباراميترات الحالية قبل التحديث
//       const searchParams = new URLSearchParams(location.search);
//       const currentStage = searchParams.get('stage');
//       const currentDuplicates = searchParams.get('duplicates');
//       const currentIgnoreDuplicate = searchParams.get('ignoreduplicate');

//       // تنفيذ عملية ignore لجميع الـ leads المحددة
//       const ignorePromises = selectedLeads?.map((leadId) =>
//         dispatch(
//           UpdateClientAction(leadId, {
//             ignoredublicate: 'false',
//           }),
//         ),
//       );

//       await Promise.all(ignorePromises);

//       Notify('success', 'Leads ignored duplicate successfully', 'success');

//       // 🔄 إعادة تحميل البيانات بنفس الباراميترات الحالية
//       // مع التأكد من إعادة تحميل الصفحة الأولى
//       setCurrentPage(1);

//       // استدعاء get_all_Leads بنفس الفلاتر الحالية
//       get_all_Leads(
//         1, // الصفحة الأولى
//         itemsPerPage,
//         searchQuery,
//         currentStage,
//         currentDuplicates,
//         appliedFilters, // 🔥 أضف appliedFilters هنا أيضاً
//       );

//       // مسح الـ selection بعد العملية
//       setSelectedLeads([]);
//       setSelectAll(false);
//     } catch (error) {
//       console.error('Error ignoring duplicates:', error);
//       Notify('error', 'Failed to ignore duplicates', 'error');
//     }
//   };
//   // Action buttons for Snackbar

//   // داخل الكومبوننت الرئيسي، أضف هذه الـ states
//   const [openDataCenterModal, setOpenDataCenterModal] = useState(false);
//   const [confirmationCount, setConfirmationCount] = useState('');
//   const [transferLoading, setTransferLoading] = useState(false);
//   const [transferLoading2, setTransferLoading2] = useState(true);

//   const [transferError, setTransferError] = useState('');
//   const [importAsDataCenter, setImportAsDataCenter] = useState(false);

//   // دالة فتح الـ modal
//   const handleTransferToDataCenter = () => {
//     if (selectedLeads.length === 0) {
//       alert('Please select at least one lead to transfer to Data Center');
//       return;
//     }

//     setTransferError('');
//     setConfirmationCount('');
//     setOpenDataCenterModal(true);
//   };

//   // دالة التأكيد والتحويل
//   const confirmTransferToDataCenter = async () => {
//     // التحقق من الرقم
//     if (!confirmationCount || isNaN(confirmationCount)) {
//       setTransferError('Please enter a valid number');
//       return;
//     }

//     const enteredCount = parseInt(confirmationCount);
//     const selectedCount = selectedLeads.length;

//     if (enteredCount !== selectedCount) {
//       setTransferError(`Please enter exactly ${selectedCount}`);
//       return;
//     }

//     console.log('🔍 [COMPONENT] selectedLeads:', selectedLeads);
//     console.log('🔍 [COMPONENT] selectedLeads type:', typeof selectedLeads[0]);

//     // 🔥 الحل: إذا كانت selectedLeads هي array من strings (IDs)
//     const leadIds = [...selectedLeads]; // أنشئ نسخة جديدة

//     console.log('🔍 [COMPONENT] leadIds:', leadIds);

//     try {
//       setTransferLoading(true);
//       setTransferLoading2(true);
//       setTransferError('');

//       console.log('🚀 [COMPONENT] Dispatching action...');

//       // استدعاء الـ Action
//       await dispatch(Transfere_Leads_TO_Data_Center_Action(leadIds));
//       setTransferLoading(false);
//       setTransferLoading2(false);
//     } catch (error) {
//       console.error('❌ [COMPONENT] Error caught:', error);

//       let errorMessage = 'Transfer failed';

//       if (error.response?.data?.message) {
//         errorMessage = error.response.data.message;
//       } else if (error.message) {
//         errorMessage = error.message;
//       }

//       setTransferError(errorMessage);
//     } finally {
//       setTransferLoading(false);
//       setTransferLoading2(false);
//     }
//   };

//   const restransferetodatacenter = useSelector(
//     (state) => state.All_CrmDataCenter_Reducer.tranceferetodatacenter,
//   );
//   console.log(restransferetodatacenter, 'result 1254');

//   useEffect(() => {
//     if (transferLoading2 === false) {
//       if (restransferetodatacenter && restransferetodatacenter?.status === 200) {
//         Notify('success', 'Leads Transfered To Data Center Successfully', 'success');
//         setOpenDataCenterModal(false);
//         setSelectedLeads([]);
//         setConfirmationCount('');
//         get_all_Leads(1, itemsPerPage, searchQuery);
//       } else {
//         setTransferError(restransferetodatacenter.message || 'Transfer failed');
//       }
//     }
//   }, [transferLoading2]);

//   const action = (
//     <React.Fragment>
//       {/* زر Ignore Duplicate - يظهر فقط في صفحة الـ duplicates */}
//       {duplicates2 === 'true' && ignoreduplicate2 === 'true' && (
//         <Tooltip title="Ignore Duplicate Leads">
//           <IconButton
//             size="small"
//             onClick={handleignoreupdate}
//             sx={{
//               color: '#9c27b0', // لون بنفسجي
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(156, 39, 176, 0.1)' : 'rgba(156, 39, 176, 0.1)',
//               '&:hover': {
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.2)',
//               },
//               marginRight: 1,
//             }}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19 13H5v-2h14v2z" />
//             </svg>
//           </IconButton>
//         </Tooltip>
//       )}

//       {/* زر Transfer To Data Center - بأيقونة مناسبة للـ Data Center */}
//       <Tooltip title="Transfer To Data Center">
//         <IconButton
//           size="small"
//           onClick={handleTransferToDataCenter} // ⚠️ غير هذا الـ handler
//           sx={{
//             color: '#2196f3', // لون أزرق للـ Data Center
//             backgroundColor:
//               mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(33, 150, 243, 0.2)' : 'rgba(33, 150, 243, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <CloudUploadIcon fontSize="small" /> {/* أيقونة مناسبة للـ Data */}
//           {/* أو استخدم: <CloudUploadIcon fontSize="small" /> */}
//         </IconButton>
//       </Tooltip>

//       <Tooltip title="Assign Leads">
//         <IconButton
//           size="small"
//           onClick={handleAssignClick}
//           sx={{
//             color: '#4caf50',
//             backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <PersonAddIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Tooltip title="Transfer Leads">
//         <IconButton
//           size="small"
//           onClick={handleTransferClick}
//           sx={{
//             color: '#ff9800',
//             backgroundColor: mode === 'dark' ? 'rgba(255, 152, 0, 0.1)' : 'rgba(255, 152, 0, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(255, 152, 0, 0.2)' : 'rgba(255, 152, 0, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <TransferWithinAStationIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Tooltip title="Delete Leads">
//         <IconButton
//           size="small"
//           onClick={handleShowmoredelete}
//           sx={{
//             color: '#d32f2f',
//             backgroundColor: mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <DeleteOutlineOutlinedIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Button
//         size="small"
//         onClick={() => setSelectedLeads([])}
//         sx={{
//           color: 'white',
//           '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
//         }}
//         className="mx-2"
//       >
//         Clear
//       </Button>
//     </React.Fragment>
//   );

//   // 🔍 دالة ذكية للبحث تعتمد على نوع الـ input
//   const getSearchQuery = (search) => {
//     if (!search) return '';

//     const cleanSearch = search.trim();

//     // إذا كان إيميل واضح
//     if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanSearch)) {
//       return `email=${encodeURIComponent(cleanSearch)}`;
//     }

//     // إذا كان رقم تليفون
//     if (/^\+?[\d\s\-\(\)]+$/.test(cleanSearch)) {
//       return `keyword=${encodeURIComponent(cleanSearch)}`;
//     }

//     // أي شيء آخر نستخدم keyword علشان يدور في name و phone
//     return `keyword=${encodeURIComponent(cleanSearch)}`;
//   };

//   const [appliedFilters, setAppliedFilters] = useState({});

//   const handleApplyFilters = (filters) => {
//     console.log('🎯 Received filters:', filters);
//     setAppliedFilters(filters);
//     setCurrentPage(1);

//     // البحث باستخدام الفلاتر الجديدة
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates, filters);
//   };

//   // 🎯 دالة التحميل الرئيسية المعدلة
//   // 🎯 دالة التحميل الرئيسية المعدلة مع دعم oldstage
//   const get_all_Leads = async (
//     page = 1,
//     limit = itemsPerPage,
//     search = '',
//     stage = '',
//     duplicates = '',
//     filters = {},
//   ) => {
//     setloadinggetdata(true);

//     let query = `leadisactive=true&limit=${limit}&page=${page}&sort=-date&data=false&transferefromdata=true`;

//     // 🔍 إضافة الـ search إذا موجود
//     if (search) {
//       const searchParam = getSearchQuery(search);
//       console.log('🔍 Using keyword search:', searchParam);
//       query += `&${searchParam}`;
//     }

//     // 🎯 إضافة الـ stage ID إذا موجود في الـ URL (current stage)
//     if (stage) {
//       query += `&stage=${encodeURIComponent(stage)}`;
//       console.log('🎯 Filtering by current stage ID:', stage);
//     }

//     // 🔄 إضافة الـ duplicates إذا موجود في الـ URL
//     // 🔄 إضافة الـ duplicates إذا موجود في الـ URL
//     if (duplicates === 'true') {
//       // 🔥 أضف ignoreduplicate مع duplicates
//       query += `&duplicates=true&ignoreduplicate=true`;
//       console.log('🔄 Loading duplicates with ignoreduplicate flag');
//     }

//     // 🎛️ إضافة الفلاتر من الـ QuickFilterModal
//     if (filters && Object.keys(filters).length > 0) {
//       console.log('🎛️ Applying quick filters:', filters);

//       // معالجة كل نوع من الفلاتر

//       // الفلاتر النصية (budget)
//       if (filters.budget) {
//         query += `&budget=${encodeURIComponent(filters.budget)}`;
//       }

//       // فلاتر المصفوفات (stage, sales, channel, etc.)
//       const arrayFilters = [
//         'stage',
//         'sales',
//         'chanel',
//         'campaign',
//         'project',
//         'developer',
//         'addby',
//       ];

//       arrayFilters.forEach((filterKey) => {
//         if (filters[filterKey] && filters[filterKey].length > 0) {
//           // إرسال الـ IDs للمصفوفات
//           const ids = filters[filterKey]
//             .map((item) => item.id || item._id)
//             .filter((id) => id)
//             .join(',');

//           if (ids) {
//             query += `&${filterKey}=${encodeURIComponent(ids)}`;
//           }
//         }
//       });

//       // 🔥🔥🔥 إضافة الـ Old Stage إذا كان مختار
//       if (filters.oldstage && filters.oldstage.length > 0) {
//         const oldStageIds = filters.oldstage
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (oldStageIds) {
//           query += `&oldstage=${encodeURIComponent(oldStageIds)}`;
//           console.log('📜 Adding oldstage filter:', oldStageIds);
//         }
//       }

//       // 🔥🔥🔥 إضافة الـ Assigned From إذا كان مختار
//       if (filters.assignedFrom && filters.assignedFrom.length > 0) {
//         const assignedFromIds = filters.assignedFrom
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (assignedFromIds) {
//           query += `&assignedFrom=${encodeURIComponent(assignedFromIds)}`;
//           console.log('👤 Adding assignedFrom filter:', assignedFromIds);
//         }
//       }

//       // 🔥🔥🔥 إضافة الـ Assigned To إذا كان مختار
//       if (filters.assignedTo && filters.assignedTo.length > 0) {
//         const assignedToIds = filters.assignedTo
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (assignedToIds) {
//           query += `&assignedTo=${encodeURIComponent(assignedToIds)}`;
//           console.log('🎯 Adding assignedTo filter:', assignedToIds);
//         }
//       }

//       // فلاتر التاريخ
//       if (filters.createdAt) {
//         if (filters.createdAt.from) {
//           query += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
//         }
//         if (filters.createdAt.to) {
//           query += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
//         }
//       }

//       // 🔥🔥🔥 إضافة فلتر Stage Date Range إذا كان مختار
//       if (filters.stagedateupdated) {
//         if (filters.stagedateupdated.from) {
//           query += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
//           console.log('📅 Adding stageDateFrom filter:', filters.stagedateupdated.from);
//         }
//         if (filters.stagedateupdated.to) {
//           query += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
//           console.log('📅 Adding stageDateTo filter:', filters.stagedateupdated.to);
//         }
//       }
//     }

//     console.log('📦 Final query:', query);

//     try {
//       await dispatch(Getalldatasearch_For_Admin(query));
//     } catch (error) {
//       console.error('❌ Search failed:', error);
//     } finally {
//       setloadinggetdata(false);
//     }
//   };

//   // 🔄 تحديث الـ effect الرئيسي لدعم الفلاتر
//   // 🔄 تحديث الـ effect الرئيسي لدعم الفلاتر والـ oldstage
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');
//     const newStage = stage || duplicates || 'all';

//     console.log('🎯 تحقق من تغيير الـ URL:', {
//       oldStage: currentStageRef.current,
//       newStage: newStage,
//       searchQuery: searchQuery,
//       appliedFilters: appliedFilters, // 🔥 الفلاتر المطبقة
//     });

//     if (currentStageRef.current !== newStage || !initialLoadDoneRef.current) {
//       console.log('🔄 تغيير في الـ URL - إعادة التحميل');

//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current);
//         pendingRequestRef.current = null;
//       }

//       setCurrentPage(1);
//       currentStageRef.current = newStage;

//       pendingRequestRef.current = setTimeout(() => {
//         get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates, appliedFilters);
//         initialLoadDoneRef.current = true;
//       }, 300);
//     }

//     return () => {
//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current);
//       }
//     };
//   }, [location.search, searchQuery, appliedFilters]); // 🔥 أضف appliedFilters هنا
//   // 🔍 استماع لتغييرات الـ search من الـ navbar
//   useEffect(() => {
//     const handleSearchUpdate = () => {
//       const newSearch = localStorage.getItem('mainsearchstorage') || '';
//       setSearchQuery(newSearch);
//       setCurrentPage(1);

//       const searchParams = new URLSearchParams(location.search);
//       const stage = searchParams.get('stage');
//       const duplicates = searchParams.get('duplicates');

//       get_all_Leads(1, itemsPerPage, newSearch, stage, duplicates);
//     };

//     window.addEventListener('mainsearchupdated', handleSearchUpdate);

//     return () => {
//       window.removeEventListener('mainsearchupdated', handleSearchUpdate);
//     };
//   }, [itemsPerPage, location.search]);

//   // التحميل الأولي
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//     currentStageRef.current = stage || duplicates || 'all';
//   }, []);

//   const handledeleteallselectedleads = async () => {
//     if (selectedLeads?.length === 0) {
//       Notify('error', 'Please select at least one Lead to delete.', 'error');
//       return;
//     }

//     const deletePromises = selectedLeads?.map((leadId) =>
//       dispatch(
//         UpdateClientAction(leadId, {
//           leadisactive: 'false',
//         }),
//       ),
//     );

//     await Promise.all(deletePromises);

//     Notify('success', 'Leads deleted successfully', 'success');
//     handleClosemoredelete();

//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');
//     setSelectedLeads([]);
//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//   };

//   const resleads = useSelector((state) => state.All_Leads_For_Admin_Reducer.AllLeads);
//   // ==========================================================================
//   // 📋 Selection Functions
//   // const handleSelectLead = (leadId) => {
//   //   setSelectedLeads(prev => {
//   //     if (prev.includes(leadId)) {
//   //       return prev.filter(id => id !== leadId);
//   //     } else {
//   //       return [...prev, leadId];
//   //     }
//   //   });
//   // };

//   // const handleSelectAll = () => {
//   //   if (selectAll) {
//   //     setSelectedLeads([]);
//   //     setSelectAll(false);
//   //   } else {
//   //     const allLeadIds = resleads?.data?.map(lead => lead._id) || [];
//   //     setSelectedLeads(allLeadIds);
//   //     setSelectAll(true);
//   //   }
//   // };
//   // ================================================================
//   // ===================================================================
//   const handleSelectLead = (leadId) => {
//     // نحفظ موقع الـ scroll الحالي
//     const currentScroll = window.scrollY || document.documentElement.scrollTop;

//     setSelectedLeads((prev) => {
//       if (prev.includes(leadId)) {
//         return prev.filter((id) => id !== leadId);
//       } else {
//         return [...prev, leadId];
//       }
//     });

//     // نرجع لنفس المكان بعد الـ update
//     setTimeout(() => {
//       window.scrollTo(0, currentScroll);
//     }, 10);
//   };

//   // 3. نفس الشيء في handleSelectAll
//   const handleSelectAll = () => {
//     const currentScroll = window.scrollY || document.documentElement.scrollTop;

//     if (selectAll) {
//       setSelectedLeads([]);
//       setSelectAll(false);
//     } else {
//       const allLeadIds = resleads?.data?.map((lead) => lead._id) || [];
//       setSelectedLeads(allLeadIds);
//       setSelectAll(true);
//     }

//     setTimeout(() => {
//       window.scrollTo(0, currentScroll);
//     }, 10);
//   };

//   const isLeadSelected = (leadId) => {
//     return selectedLeads.includes(leadId);
//   };

//   const handleClearSelection = () => {
//     setSelectedLeads([]);
//     setSelectAll(false);
//   };

//   // 📄 Pagination Functions المعدلة
//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(value, itemsPerPage, searchQuery, stage, duplicates, appliedFilters);
//   };

//   const handleItemsPerPageChange = (event) => {
//     const newLimit = event.target.value;
//     setItemsPerPage(newLimit);
//     setCurrentPage(1); // نرجع للصفحة الأولى عند تغيير الـ limit
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, newLimit, searchQuery, stage, duplicates, appliedFilters);
//   };

//   const handleOpenGoToPage = () => {
//     setPageInput('');
//     setGoToPageDialog(true);
//   };

//   const handleCloseGoToPage = () => {
//     setGoToPageDialog(false);
//   };

//   const handleGoToPage = () => {
//     const pageNum = parseInt(pageInput);
//     if (pageNum && pageNum >= 1 && pageNum <= resleads?.pagination?.NumberOfPages) {
//       setCurrentPage(pageNum);
//       const searchParams = new URLSearchParams(location.search);
//       const stage = searchParams.get('stage');
//       const duplicates = searchParams.get('duplicates');
//       get_all_Leads(pageNum, itemsPerPage, searchQuery, stage, duplicates);
//       setGoToPageDialog(false);
//     }
//   };

//   // 🔄 دالة التحديث اليدوي الشامل
//   const handleRefreshData = () => {
//     console.log('🔄 تحديث يدوي شامل');

//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     // reset كامل
//     setCurrentPage(1);
//     isFetchingRef.current = false;
//     initialLoadDoneRef.current = false;
//     currentStageRef.current = stage || duplicates || 'all';
//     setSelectedLeads([]);
//     setSelectAll(false);

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//   };

//   const downloadExcelTemplate = () => {
//     // إنشاء البيانات الأساسية للقالب
//     const templateData = [
//       {
//         name: 'Ahmed Hassan',
//         phone: '+971501234567',
//         email: 'ahmed@email.com',
//         project_name: 'Dubai Hills',
//         sales_name: 'Mohamed Ali',
//         chanel_name: '008 | A',
//         communication_way: 'Call',
//         stage_name: 'Follow UP',
//         campaign_name: 'Summer Campaign',
//         addby_name: 'Joun',
//         updatedby_name: 'Joun',
//         budget: '1500000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-15',
//         dayonly: '2024-03-15',
//         last_stage_date_updated: '2024-03-15',
//         creation_date: '2024-01-10',
//         Last_Date_Assigned: '2024-03-01',
//         // الحقول الجديدة للأسئلة والإجابات
//         question1_text: 'How did you hear about us?',
//         question1_answer: 'Facebook',
//         question2_text: 'Preferred budget range?',
//         question2_answer: '1.5M - 2M AED',
//         question3_text: 'Interested in payment plan?',
//         question3_answer: 'Yes',
//         question4_text: 'Preferred location?',
//         question4_answer: 'Dubai Hills',
//         question5_text: 'Ready to proceed?',
//         question5_answer: 'Need more information',
//       },
//       {
//         name: 'Sarah Johnson',
//         phone: '+971502345678',
//         email: 'sarah@email.com',
//         project_name: 'Palm Jumeirah',
//         sales_name: 'Fatima Ahmed',
//         chanel_name: '005 |A',
//         communication_way: 'Whatsapp',
//         stage_name: 'Pending',
//         campaign_name: 'Luxury Homes',
//         addby_name: 'Johan De',
//         updatedby_name: 'Johan De',
//         budget: '2800000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-10',
//         dayonly: '2024-03-10',
//         last_stage_date_updated: '2024-03-10',
//         creation_date: '2024-01-25',
//         Last_Date_Assigned: '2024-02-15',
//         // الحقول الجديدة للأسئلة والإجابات
//         question1_text: 'How did you hear about us?',
//         question1_answer: 'Instagram',
//         question2_text: 'Preferred budget range?',
//         question2_answer: '2.5M - 3M AED',
//         question3_text: 'Interested in payment plan?',
//         question3_answer: 'Yes, flexible',
//         question4_text: 'Preferred location?',
//         question4_answer: 'Palm Jumeirah',
//         question5_text: 'Ready to proceed?',
//         question5_answer: 'Need to discuss with family',
//       },
//     ];

//     // إنشاء ورقة Excel
//     const ws = XLSX.utils.json_to_sheet(templateData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Leads Template');

//     // تنزيل الملف
//     XLSX.writeFile(wb, 'Leads_Import_Template.xlsx');

//     // إذا لم يكن XLSX متاحاً، عرض رسالة
//     console.log('Template downloaded successfully');

//     // يمكنك أيضاً استخدام:
//     // window.open('/api/download-template', '_blank');
//   };

//   const [openimport2, setopenimport2] = useState(false);
//   const [fileimport2, setFileimport2] = useState(null);
//   const [previewData, setPreviewData] = useState([]);
//   const [loadingimprt2, setLoadingimort2] = useState(false);
//   const [resultimport2, setResultimport2] = useState(null);
//   const [errorimport2, setErrorimport2] = useState(null);

//   const handleOpenimport2 = () => setopenimport2(true);
//   const handleCloseimport2 = () => {
//     setopenimport2(false);
//     setFileimport2(null);
//     setPreviewData([]);
//     setResultimport2(null);
//     setErrorimport2(null);
//   };

//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setFileimport2(file);
//     setResultimport2(null);
//     setErrorimport2(null);

//     const reader = new FileReader();
//     reader.onload = async (e) => {
//       const data = e.target.result;
//       const workbook = await XLSX.readAsync(data);
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const json = XLSX.utils.sheet_to_json(sheet);
//       setPreviewData(json);
//     };
//     reader.readAsBinaryString(file);
//   }; //     const file = e.target.files[0];
//   //     if (!file) return;

//   //     setFileimport2(file);
//   //     setResultimport2(null);
//   //     setErrorimport2(null);

//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       const data = e.target.result;
//   //       const workbook = XLSX.read(data, { type: 'binary' });
//   //       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//   //       const json = XLSX.utils.sheet_to_json(sheet);
//   //       setPreviewData(json);
//   //     };
//   //     reader.readAsBinaryString(file);
//   //   };
//   // const [loadingimprt2, setLoadingimprt2] = useState(false); // نفس الاسم في كلا الجانبين
//   const [activeTab, setActiveTab] = useState('settings');
//   const [isDataCenterImport, setIsDataCenterImport] = useState(true);

//   const onUploadimportleads2 = async () => {
//     if (!fileimport2) {
//       Notify('warning', 'Please select an Excel file first', 'warning');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', fileimport2);
//     // أضف قيمة الـ Switch
//     formData.append('importInDataCenter', isDataCenterImport);

//     setLoadingimort2(true);
//     try {
//       const res = await axios.post(`${db_url}api/v1/users/import-leads`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       setResultimport2(res.data);

//       // إظهار رسالة نجاح
//       Notify(
//         'success',
//         `✅ ${res.data.insertedCount} leads imported successfully to ${isDataCenterImport ? 'Data Center' : 'Original Leads'}!`,
//         'success',
//       );

//       // إغلاق الـ Modal بعد ثانيتين
//       setTimeout(() => {
//         handleCloseimport2();
//       }, 2000);
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || err.message || 'Import failed';
//       setErrorimport2(errorMsg);
//       Notify('error', `❌ Import failed: ${errorMsg}`, 'error');
//     }
//     setLoadingimort2(false);
//     get_all_Leads(1, itemsPerPage, searchQuery);
//   };

//   const [filteredUsers, setFilteredUsers] = useState([]);

//   // في useEffect عندما البيانات تتحمل
//   useEffect(() => {
//     if (resleads?.data) {
//       setFilteredUsers(resleads.data);
//     }
//   }, [resleads]);

//   const exportFilteredToExcel = () => {
//     // استخدام الـ filteredUsers أو resleads.data
//     const usersToExport = filteredUsers.length > 0 ? filteredUsers : resleads?.data || [];

//     if (usersToExport.length === 0) {
//       Notify('warning', 'No data to export.', 'warning');
//       return;
//     }

//     // معالجة البيانات قبل التصدير
//     const dataToExport = usersToExport.map((user) => ({
//       // "ID": user._id,
//       Name: user.name || '',
//       Email: user.email || '',
//       Phone: user.phone || '',
//       'Phone 2': user.phonenumber2 || '',
//       WhatsApp: user.whatsappnumber || '',
//       Project: user.project?.name || 'N/A',
//       Developer: user.project?.developer?.name || 'N/A',
//       Campaign: user.campaign?.CampainName || 'N/A',
//       Channel: user.chanel?.name || 'N/A',
//       'Sales Person': user.sales?.name || 'N/A',
//       Stage: user.stage?.name || 'N/A',
//       'Stage Date': user.stagedateupdated
//         ? moment(user.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//         : '',
//       Status: user.leadisactive === 'true' ? 'Active' : 'Inactive',
//       Notes: user.notes || '',
//       Budget: user.budget || '',
//       'Assigned To': user.sales?.name || '',
//       'Assigned From': user.assignfrom?.name || '',
//       'Added By': user.addby?.name || 'N/A',
//       'Creation Date': user.date
//         ? moment(user.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//         : '',
//       'Last Comment': user.lastComment?.firstcomment?.text || '',
//       'Action Plan': user.lastComment?.secondcomment?.text || '',
//       'Comment Date': user.lastComment?.firstcomment?.date
//         ? moment(user.lastComment.firstcomment.date).format('DD/MM/YYYY h:mm A')
//         : '',
//     }));

//     // إعداد الـ Excel
//     const ws = XLSX.utils.json_to_sheet(dataToExport);
//     const wb = XLSX.utils.book_new();

//     // تحديد عرض الأعمدة
//     const wscols = [
//       { wch: 25 }, // ID
//       { wch: 20 }, // Name
//       { wch: 25 }, // Email
//       { wch: 15 }, // Phone
//       { wch: 15 }, // Phone 2
//       { wch: 15 }, // WhatsApp
//       { wch: 20 }, // Project
//       { wch: 20 }, // Developer
//       { wch: 20 }, // Campaign
//       { wch: 15 }, // Channel
//       { wch: 20 }, // Sales Person
//       { wch: 15 }, // Stage
//       { wch: 20 }, // Stage Date
//       { wch: 10 }, // Status
//       { wch: 30 }, // Notes
//       { wch: 15 }, // Budget
//       { wch: 20 }, // Assigned To
//       { wch: 20 }, // Assigned From
//       { wch: 20 }, // Added By
//       { wch: 20 }, // Creation Date
//       { wch: 40 }, // Last Comment
//       { wch: 40 }, // Action Plan
//       { wch: 20 }, // Comment Date
//     ];

//     ws['!cols'] = wscols;

//     XLSX.utils.book_append_sheet(wb, ws, 'Filtered Leads Data');

//     // إنشاء اسم للملف مع التاريخ
//     const fileName = `Leads_Export_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//     XLSX.writeFile(wb, fileName);

//     Notify('success', `Exported ${usersToExport.length} leads to Excel!`, 'success');
//   };

//   const exportFilteredLeadsWithAllComments = async () => {
//     // التأكد من وجود بيانات لتصديرها
//     // if (!resleads?.data || resleads.data.length === 0) {
//     //   Notify("warning", "No leads to export.", "warning");
//     //   return;
//     // }

//     Notify('info', 'Preparing data... This may take a moment.', 'info');

//     try {
//       // 1. جلب جميع الإجراءات (التي تحتوي على التعليقات) مرة واحدة
//       const response = await axios.get(`${db_url}api/v1/Action`);
//       const allActions = response.data.data;

//       // 2. معالجة البيانات لتضمين التعليقات
//       const dataToExport = resleads.data.map((lead) => {
//         // البحث عن الإجراءات الخاصة بهذا الـ lead
//         const leadActions = allActions.filter((action) => action.leed?._id === lead._id);

//         // تجميع كل التعليقات الخاصة بالـ lead من جميع الإجراءات
//         const allLeadComments = leadActions.flatMap((action) => action.Comments || []);

//         // ترتيب التعليقات من الأقدم إلى الأحدث
//         const sortedComments = allLeadComments.sort(
//           (a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt),
//         );

//         // 3. تنسيق جميع التعليقات في نص واحد قابل للقراءة
//         const formattedComments = sortedComments
//           .map((comment, index) => {
//             const commentDate = moment(comment.stageDate || comment.createdAt).format(
//               'DD/MM/YYYY h:mm A',
//             );
//             const stageName = comment.stage?.name || 'N/A';
//             const salesName = comment.sales?.name || 'N/A';
//             const firstComment = comment.firstcomment?.text || 'No text';
//             const secondComment = comment.secondcomment?.text || 'No text';

//             return `(${index + 1}) [${commentDate}] - [Stage: ${stageName}] - [By: ${salesName}]\nComment: ${firstComment}\nNext Action: ${secondComment}\n------------------`;
//           })
//           .join('\n\n'); // فصل بين كل تعليق والآخر بأسطر فارغة

//         // 4. إرجاع كائن جديد يحتوي على بيانات الـ lead والتعليقات المنسقة
//         return {
//           // "ID": lead._id,
//           Name: lead.name || '',
//           Email: lead.email || '',
//           Phone: lead.phone || '',
//           Project: lead.project?.name || 'N/A',
//           Developer: lead.project?.developer?.name || 'N/A',
//           Campaign: lead.campaign?.CampainName || 'N/A',
//           Channel: lead.chanel?.name || 'N/A',
//           'Sales Person': lead.sales?.name || 'N/A',
//           Stage: lead.stage?.name || 'N/A',
//           'Stage Date': lead.stagedateupdated
//             ? moment(lead.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//             : '',
//           Status: lead.leadisactive === 'true' ? 'Active' : 'Inactive',
//           Notes: lead.notes || '',
//           Budget: lead.budget || '',
//           'Assigned To': lead.sales?.name || '',
//           'Assigned From': lead.assignfrom?.name || '',
//           'Added By': lead.addby?.name || 'N/A',
//           'Creation Date': lead.date
//             ? moment(lead.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//             : '',
//           'Total Comments': sortedComments.length,
//           'All Comments': formattedComments || 'No Comments Found',
//         };
//       });

//       // 5. تصدير البيانات إلى ملف Excel
//       const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads with All Comments');

//       // ضبط عرض الأعمدة تلقائيًا
//       const wscols = [
//         { wch: 25 }, // ID
//         { wch: 20 }, // Name
//         { wch: 25 }, // Email
//         { wch: 15 }, // Phone
//         { wch: 20 }, // Project
//         { wch: 20 }, // Developer
//         { wch: 20 }, // Campaign
//         { wch: 15 }, // Channel
//         { wch: 20 }, // Sales Person
//         { wch: 15 }, // Stage
//         { wch: 20 }, // Stage Date
//         { wch: 10 }, // Status
//         { wch: 30 }, // Notes
//         { wch: 15 }, // Budget
//         { wch: 20 }, // Assigned To
//         { wch: 20 }, // Assigned From
//         { wch: 20 }, // Added By
//         { wch: 20 }, // Creation Date
//         { wch: 10 }, // Total Comments
//         { wch: 100 }, // All Comments - عرض كبير
//       ];

//       worksheet['!cols'] = wscols;

//       const fileName = `Leads_With_All_Comments_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//       XLSX.writeFile(workbook, fileName);

//       Notify(
//         'success',
//         `Exported ${resleads.data.length} leads with all comments successfully!`,
//         'success',
//       );
//     } catch (error) {
//       console.error('Export with all comments failed:', error);
//       Notify('error', 'Failed to export data. Please check the console.', 'error');
//     }
//   };

//   // 📊 Table customization functions
//   const toggleColumnVisibility = (columnKey) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, visible: !col.visible } : col,
//       ),
//     }));
//   };

//   const updateColumnWidth = (columnKey, newWidth) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, width: Math.max(80, newWidth) } : col,
//       ),
//     }));
//   };

//   const resetToDefault = () => {
//     setTableConfig(defaultTableConfig);
//   };

//   const handleDragEnd = (result) => {
//     if (!result.destination) return;

//     const items = Array.from(tableConfig.columnOrder);
//     const [reorderedItem] = items.splice(result.source.index, 1);
//     items.splice(result.destination.index, 0, reorderedItem);

//     setTableConfig((prev) => ({
//       ...prev,
//       columnOrder: items,
//     }));
//   };

//   const toggleHeaderColors = () => {
//     setTableConfig((prev) => ({
//       ...prev,
//       whiteHeaders: !prev.whiteHeaders,
//     }));
//   };

//   const [showActions, setShowActions] = useState(false);
//   const [duplicationModal, setDuplicationModal] = useState({
//     open: false,
//     leadId: null,
//     leadName: '',
//   });

//   // دالة علشان تجيب الكومنتس عند الـ hover
//   const handleCommentHover = async (leadId) => {
//     setHoveredLeadId(leadId);
//     setLoadingComments(true);

//     try {
//       // هنا ممكن تجيب الكومنتس من الـ API إذا محتاج
//       // أو تستخدم البيانات اللي موجودة في lastComment
//       setLoadingComments(false);
//     } catch (error) {
//       console.error('Error loading comments:', error);
//       setLoadingComments(false);
//     }
//   };

//   const handleCommentLeave = () => {
//     setHoveredLeadId(null);
//     setComments([]);
//   };

//   const [sheetOpen, setSheetOpen] = useState(false);

//   const getVisibleColumns = () => {
//     return tableConfig.columnOrder
//       .map((key) => tableConfig.columns.find((col) => col.key === key))
//       .filter((col) => col && col.visible);
//   };

//   // Styled components for better UI
//   const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
//     },
//     '&:hover': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
//     },
//   }));

//   const StatusChip = ({ active }) => (
//     <Chip
//       label={active === 'true' ? 'Active' : 'Inactive'}
//       color={active === 'true' ? 'success' : 'default'}
//       size="small"
//     />
//   );

//   // Function to get initials for avatar
//   const getInitials = (name) => {
//     if (!name) return '?';
//     return name
//       .split(' ')
//       .map((n) => n[0])
//       .join('')
//       .toUpperCase()
//       .substring(0, 2);
//   };

//   // دالة مساعدة لألوان الـ Roles
//   const getRoleColor = (role) => {
//     if (!role) return 'default';

//     const roleColors = {
//       admin: 'error',
//       superadmin: 'error',
//       manager: 'warning',
//       supervisor: 'info',
//       sales: 'success',
//       user: 'default',
//       agent: 'primary',
//     };

//     return roleColors[role.toLowerCase()] || 'default';
//   };

//   // Custom cell renderers
//   const renderCell = (col, user) => {
//     switch (col.key) {
//       case 'selection':
//         return (
//           <Checkbox
//             checked={isLeadSelected(user._id)}
//             onChange={() => handleSelectLead(user._id)}
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#000',
//               '&.Mui-checked': {
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//               },
//             }}
//           />
//         );

//       case 'duplicate':
//         return (
//           <Box sx={{ textAlign: 'center', padding: '8px 4px' }}>
//             <Box
//               onClick={() => {
//                 console.log('Opening duplication modal for:', user._id, user.name);
//                 setDuplicationModal({
//                   open: true,
//                   leadId: user._id,
//                   leadName: user.name,
//                 });
//               }}
//               sx={{
//                 color: '#0f7687',
//                 border: '1px solid #0f7687',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(15, 118, 135, 0.1)' : 'rgba(15, 118, 135, 0.05)',
//                 padding: '4px 8px',
//                 borderRadius: '16px',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 cursor: 'pointer',
//                 display: 'inline-block',
//                 transition: 'all 0.2s ease-in-out',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(15, 118, 135, 0.2)' : 'rgba(15, 118, 135, 0.1)',
//                 },
//               }}
//             >
//               {user.totalSubmissions
//                 ? `${user.totalSubmissions} Register${user.totalSubmissions > 1 ? 's' : ''}`
//                 : '0 Registers'}
//             </Box>
//           </Box>
//         );

//       case 'name':
//         return (
//           <Box
//             sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
//             onClick={() => setSelectedLead(user)}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 width: 40,
//                 height: 40,
//               }}
//             >
//               {getInitials(user.name)}
//             </Avatar>
//             <Box>
//               <Typography variant="body1" fontWeight="medium">
//                 {user.name}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {user.email}
//               </Typography>
//             </Box>
//           </Box>
//         );

//       case 'phone':
//         return <PhoneCell user={user} mode={mode} />;

//       case 'project':
//         return (
//           <Typography variant="body2" fontWeight="medium">
//             {user.project?.name || 'N/A'}
//           </Typography>
//         );

//       case 'developer':
//         return <Typography variant="body2">{user?.project?.developer?.name || 'N/A'}</Typography>;

//       // case 'campaign':
//       //   return (
//       //     <Typography variant="body2">
//       //       {user.campaign?.CampainName || 'N/A'}
//       //     </Typography>
//       //   );

//       case 'campaign':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//             {/* Campaign Name */}
//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: user.campaign?.redirectLink ? '500' : 'normal',
//                 color: user.campaign?.redirectLink ? '#1976d2' : 'inherit',
//               }}
//             >
//               {user.campaign?.CampainName || 'N/A'}
//             </Typography>

//             {/* Icons Row - Only shown if there's a redirect link */}
//             {user.campaign?.redirectLink && (
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 {/* Copy Link Icon */}
//                 <Tooltip title="Copy Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigator.clipboard.writeText(user.campaign.redirectLink);
//                       Notify('success', 'Campaign link copied to clipboard', 'success');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '24px',
//                       height: '24px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#1976d2',
//                         backgroundColor: 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     <ContentCopyIcon sx={{ fontSize: '16px' }} />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Open Link Icon */}
//                 <Tooltip title="Open Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       window.open(user.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '24px',
//                       height: '24px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#2e7d32',
//                         backgroundColor: 'rgba(46, 125, 50, 0.1)',
//                       },
//                     }}
//                   >
//                     <OpenInNewIcon sx={{ fontSize: '16px' }} />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Optional: Show truncated link */}
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: '#666',
//                     ml: 0.5,
//                     flex: 1,
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     whiteSpace: 'nowrap',
//                   }}
//                   title={user.campaign.redirectLink}
//                 >
//                   {user.campaign.redirectLink.length > 30
//                     ? `${user.campaign.redirectLink.substring(0, 30)}...`
//                     : user.campaign.redirectLink}
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//         );
//         return (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="body2">{user.campaign?.CampainName || 'N/A'}</Typography>

//             {user.campaign?.redirectLink && (
//               <>
//                 {/* Copy Link Icon */}
//                 <Tooltip title="Copy Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigator.clipboard.writeText(user.campaign.redirectLink);
//                       // يمكنك إضافة notifcation هنا
//                       Notify('success', 'Link copied to clipboard', 'success');
//                     }}
//                     sx={{
//                       padding: '4px',
//                       color: '#1976d2',
//                       '&:hover': {
//                         backgroundColor: 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     <ContentCopyIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Open Link Icon */}
//                 <Tooltip title="Open Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       window.open(user.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                     }}
//                     sx={{
//                       padding: '4px',
//                       color: '#2e7d32',
//                       '&:hover': {
//                         backgroundColor: 'rgba(46, 125, 50, 0.1)',
//                       },
//                     }}
//                   >
//                     <OpenInNewIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//               </>
//             )}
//           </Box>
//         );

//       case 'Channal':
//         return <Typography variant="body2">{user.chanel?.name || 'N/A'}</Typography>;

//       //       // case 'sales':
//       //         return (
//       //           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//       //             {/* Sales Name with Loading */}
//       //             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//       //    <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//       //   {user?.assigntype === true
//       //     ? (
//       //       <Box component="span" sx={{ fontWeight: 'bold', color: 'red' }}>
//       //         Team: {user.sales?.name || 'N/A'}
//       //       </Box>
//       //     )
//       //     : user.sales?.name || 'N/A'
//       //   }
//       // </Typography>

//       //               {/* Loading dots when assign is true */}
//       //               {user.assign === true && (
//       //                 <Box sx={{ display: 'flex', gap: 0.5 }}>
//       //                   {[1, 2, 3].map((dot) => (
//       //                     <Box
//       //                       key={dot}
//       //                       sx={{
//       //                         width: 4,
//       //                         height: 4,
//       //                         borderRadius: '50%',
//       //                         backgroundColor: '#1976d2',
//       //                         animation: 'pulse 1.4s ease-in-out infinite',
//       //                         animationDelay: `${dot * 0.16}s`,
//       //                         '@keyframes pulse': {
//       //                           '0%, 80%, 100%': {
//       //                             transform: 'scale(0.8)',
//       //                             opacity: 0.5,
//       //                           },
//       //                           '40%': {
//       //                             transform: 'scale(1)',
//       //                             opacity: 1,
//       //                           }
//       //                         }
//       //                       }}
//       //                     />
//       //                   ))}
//       //                 </Box>
//       //               )}
//       //             </Box>

//       //             {/* Date */}
//       //             {user.lastdateassign && (
//       //               <Typography
//       //                 variant="caption"
//       //                 sx={{
//       //                   color: '#666',
//       //                   fontSize: '11px'
//       //                 }}
//       //               >
//       //                 {moment(user.lastdateassign)
//       //                   .tz(moment.tz.guess())
//       //                   .format('DD/MM/YYYY h:mm A')}
//       //               </Typography>
//       //             )}
//       //           </Box>
//       //         );

//       case 'sales':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {/* Sales Name with Loading */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                 {user?.assigntype === true ? (
//                   <Tooltip
//                     title={
//                       <Box sx={{ p: 0.5 }}>
//                         <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
//                           Team Information
//                         </Typography>
//                         <Box sx={{ mt: 0.5 }}>
//                           <Typography variant="body2">
//                             <strong>Team:</strong> {user.sales?.name || 'N/A'}
//                           </Typography>
//                           <Typography variant="body2">
//                             <strong>Team Leader:</strong>{' '}
//                             {user.sales?.teamleader?.name || user.teamleader || 'Not Assigned'}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     }
//                     arrow
//                     placement="top"
//                     componentsProps={{
//                       tooltip: {
//                         sx: {
//                           backgroundColor: 'background.paper',
//                           color: 'text.primary',
//                           border: '1px solid',
//                           borderColor: 'divider',
//                           maxWidth: 250,
//                         },
//                       },
//                     }}
//                   >
//                     <Box
//                       component="span"
//                       sx={{
//                         fontWeight: 'bold',
//                         color: 'red',
//                         cursor: 'help',
//                         borderBottom: '1px dotted',
//                         borderColor: 'grey.400',
//                         '&:hover': {
//                           borderColor: 'primary.main',
//                         },
//                       }}
//                     >
//                       Team: {user.sales?.teamleader?.name || 'N/A'}
//                     </Box>
//                   </Tooltip>
//                 ) : (
//                   <Tooltip
//                     title={`Team Leader: ${user.sales?.teamleader?.name || 'N/A'}`}
//                     arrow
//                     placement="top"
//                   >
//                     <span style={{ cursor: 'default' }}>{user.sales?.name || 'N/A'}</span>
//                   </Tooltip>
//                 )}
//               </Typography>

//               {/* Loading dots when assign is true */}
//               {user.assign === true && (
//                 <Tooltip title="Processing assignment...">
//                   <Box sx={{ display: 'flex', gap: 0.5, cursor: 'help' }}>
//                     {[1, 2, 3].map((dot) => (
//                       <Box
//                         key={dot}
//                         sx={{
//                           width: 4,
//                           height: 4,
//                           borderRadius: '50%',
//                           backgroundColor: '#1976d2',
//                           animation: 'pulse 1.4s ease-in-out infinite',
//                           animationDelay: `${dot * 0.16}s`,
//                           '@keyframes pulse': {
//                             '0%, 80%, 100%': {
//                               transform: 'scale(0.8)',
//                               opacity: 0.5,
//                             },
//                             '40%': {
//                               transform: 'scale(1)',
//                               opacity: 1,
//                             },
//                           },
//                         }}
//                       />
//                     ))}
//                   </Box>
//                 </Tooltip>
//               )}
//             </Box>

//             {/* Date */}
//             {user.lastdateassign && (
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: '#666',
//                   fontSize: '11px',
//                 }}
//               >
//                 {moment(user.lastdateassign).tz(moment.tz.guess()).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );
//       // في دالة renderCell أضيف case جديدة:
//       // case 'lastComment':
//       //   return (
//       //     <TableCell
//       //       key={col.key}
//       //       sx={{
//       //         width: `${col.width}px`,
//       //         minWidth: `${col.width}px`,
//       //         maxWidth: `${col.width}px`,
//       //         verticalAlign: 'top',
//       //         textAlign: 'left',
//       //         padding: '4px 8px'
//       //       }}
//       //       onMouseEnter={() => handleCommentHover(user._id)}
//       //       onMouseLeave={handleCommentLeave}
//       //     >
//       //       <Tooltip
//       //         title={
//       //           hoveredLeadId === user._id ? (
//       //             loadingComments ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 Loading...
//       //               </div>
//       //             ) : !user.lastComment ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 No Comments
//       //               </div>
//       //             ) : (
//       //               <div style={{
//       //                 width: "450px",
//       //                 maxWidth: '90vw',
//       //                 padding: '20px',
//       //                 background: mode === 'dark' ? '#1e1e1e' : '#fff',
//       //                 borderRadius: '12px',
//       //                 color: mode === 'dark' ? '#fff' : '#333',
//       //                 fontSize: '14px',
//       //                 lineHeight: '1.5',
//       //                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                 boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//       //               }}>
//       //                 {/* Header - Sales Info + Stage */}
//       //                 <div style={{
//       //                   display: 'flex',
//       //                   justifyContent: 'space-between',
//       //                   alignItems: 'flex-start',
//       //                   marginBottom: '16px',
//       //                   paddingBottom: '12px',
//       //                   borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//       //                 }}>
//       //                   {/* Sales Info - Avatar with first 2 letters */}
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     alignItems: 'center',
//       //                     gap: '12px'
//       //                   }}>
//       //                     <Avatar
//       //                       sx={{
//       //                         width: 40,
//       //                         height: 40,
//       //                         bgcolor: '#102dff',
//       //                         fontSize: '14px',
//       //                         fontWeight: 'bold'
//       //                       }}
//       //                     >
//       //                       {user.lastComment.sales?.name ?
//       //                         user.lastComment.sales.name.substring(0, 2).toUpperCase()
//       //                         : '?'
//       //                       }
//       //                     </Avatar>
//       //                     <div>
//       //                       <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}>
//       //                         {user.lastComment.sales?.name || "Unknown Sales"}
//       //                       </div>
//       //                       <div style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}>
//       //                         {user.lastComment.sales?.role || "Sales"}
//       //                       </div>
//       //                     </div>
//       //                   </div>

//       //                   {/* Stage on the right - under sales name */}
//       //                   {(user.lastComment.stage || user.stage) && (
//       //                     <div style={{
//       //                       textAlign: 'right'
//       //                     }}>

//       //                       <div style={{
//       //                         fontWeight: '600',
//       //                         color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                         fontSize: '14px'
//       //                       }}>
//       //                         {/* نستخدم الـ stage من lastComment أو من الـ user نفسه */}
//       //                        Stage: {user.lastComment.stage?.name|| user.stage?.name|| "Undefined"}
//       //                       </div>
//       //                     {(user.lastComment.stageDate) && (
//       //   <div style={{
//       //     fontSize: '11px',
//       //     color: mode === 'dark' ? '#999' : '#888',
//       //     marginTop: '2px'
//       //   }}>
//       // <span>
//       //   SD : | {
//       //     new Date(user.lastComment.stageDate).toLocaleString('en-US', {
//       //       year: 'numeric',
//       //       month: '2-digit',
//       //       day: '2-digit',
//       //       hour: '2-digit',
//       //       minute: '2-digit',
//       //       hour12: true
//       //     })
//       //   }
//       // </span>
//       //   </div>
//       // )}
//       //                     </div>
//       //                   )}
//       //                 </div>

//       //                 {/* Comment Date - Only if exists - 12 hour format */}
//       //                 {user.lastComment.firstcomment?.date && (
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     justifyContent: 'center',
//       //                     alignItems: 'center',
//       //                     gap: '6px',
//       //                     fontSize: '12px',
//       //                     color: mode === 'dark' ? '#ccc' : '#666',
//       //                     marginBottom: '16px',
//       //                     padding: '6px 12px',
//       //                     background: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//       //                     borderRadius: '6px'
//       //                   }}>
//       //                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                       <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//       //                       <line x1="16" y1="2" x2="16" y2="6"></line>
//       //                       <line x1="8" y1="2" x2="8" y2="6"></line>
//       //                       <line x1="3" y1="10" x2="21" y2="10"></line>
//       //                     </svg>
//       //                     {new Date(user.lastComment.firstcomment.date).toLocaleDateString() + ' • ' +
//       //                      new Date(user.lastComment.firstcomment.date).toLocaleTimeString('en-US', {
//       //                        hour: '2-digit',
//       //                        minute: '2-digit',
//       //                        hour12: true
//       //                      })}
//       //                   </div>
//       //                 )}

//       //                 {/* First Comment (Comment) */}
//       //                 {user.lastComment.firstcomment?.text && user.lastComment.firstcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '16px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //                       </svg>
//       //                       Comment
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {user.lastComment.firstcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 {/* Second Comment (Action Plan) */}
//       //                 {user.lastComment.secondcomment?.text && user.lastComment.secondcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '12px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//       //                         <polyline points="14,2 14,8 20,8"></polyline>
//       //                         <line x1="16" y1="13" x2="8" y2="13"></line>
//       //                         <line x1="16" y1="17" x2="8" y2="17"></line>
//       //                         <polyline points="10,9 9,9 8,9"></polyline>
//       //                       </svg>
//       //                       Action Plan
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {user.lastComment.secondcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 {/* Last Updated */}
//       //                 <div style={{
//       //                   fontSize: '11px',
//       //                   color: mode === 'dark' ? '#999' : '#888',
//       //                   textAlign: 'center',
//       //                   marginTop: '16px',
//       //                   paddingTop: '12px',
//       //                   borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                   display: 'flex',
//       //                   alignItems: 'center',
//       //                   justifyContent: 'center',
//       //                   gap: '6px'
//       //                 }}>
//       //                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                     <circle cx="12" cy="12" r="10"></circle>
//       //                     <polyline points="12,6 12,12 16,14"></polyline>
//       //                   </svg>
//       //                   Last updated: {user.lastComment.actionUpdatedAt ?
//       //                     new Date(user.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//       //                       year: 'numeric',
//       //                       month: '2-digit',
//       //                       day: '2-digit'
//       //                     })
//       //                     : 'Unknown'
//       //                   }
//       //                 </div>
//       //               </div>
//       //             )
//       //           ) : null
//       //         }
//       //         arrow
//       //         placement="left-start"
//       //         componentsProps={{
//       //           tooltip: {
//       //             sx: {
//       //               backgroundColor: 'transparent',
//       //               padding: 0,
//       //               m: 0,
//       //               boxShadow: 'none',
//       //               border: 'none',
//       //               overflow: 'visible',
//       //               maxWidth: 'none'
//       //             }
//       //           }
//       //         }}
//       //       >
//       //         <IconButton
//       //           size="small"
//       //           sx={{
//       //             color: user.lastComment ?
//       //               (mode === 'dark' ? '#90caf9' : '#102dff') :
//       //               (mode === 'dark' ? '#666' : '#ccc'),
//       //             '&:hover': {
//       //               backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//       //             }
//       //           }}
//       //         >
//       //           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //             <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //           </svg>
//       //           {user.lastComment && (
//       //             <Box
//       //               sx={{
//       //                 position: 'absolute',
//       //                 top: 4,
//       //                 right: 4,
//       //                 width: 6,
//       //                 height: 6,
//       //                 borderRadius: '50%',
//       //                 backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //               }}
//       //             />
//       //           )}
//       //         </IconButton>
//       //       </Tooltip>
//       //     </TableCell>
//       //   );
//       case 'lastComment':
//         return (
//           <Box
//             onMouseEnter={() => handleCommentHover(user._id)}
//             onMouseLeave={handleCommentLeave}
//             sx={{
//               width: '100%',
//               height: '100%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               cursor: 'pointer',
//             }}
//           >
//             <Tooltip
//               title={
//                 <div
//                   style={{
//                     width: '450px',
//                     maxWidth: '90vw',
//                     padding: '20px',
//                     background: mode === 'dark' ? '#1e1e1e' : '#fff',
//                     borderRadius: '12px',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     fontSize: '14px',
//                     lineHeight: '1.5',
//                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                     boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
//                   }}
//                 >
//                   {/* حالة التحميل */}
//                   {loadingComments ? (
//                     <Box sx={{ textAlign: 'center', py: 3 }}>
//                       <CircularProgress
//                         size={24}
//                         sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                       />
//                       <Typography sx={{ mt: 2, color: mode === 'dark' ? '#ccc' : '#666' }}>
//                         Loading comments...
//                       </Typography>
//                     </Box>
//                   ) : !user.lastComment ? (
//                     <Box sx={{ textAlign: 'center', py: 3 }}>
//                       <svg
//                         width="48"
//                         height="48"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke={mode === 'dark' ? '#666' : '#999'}
//                       >
//                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                       </svg>
//                       <Typography
//                         sx={{ mt: 2, color: mode === 'dark' ? '#ccc' : '#666', fontWeight: '500' }}
//                       >
//                         No Comments Yet
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{ color: mode === 'dark' ? '#999' : '#888' }}
//                       >
//                         No comments have been added to this lead
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <>
//                       {/* Header - Sales Info + Stage */}
//                       <div
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'flex-start',
//                           marginBottom: '16px',
//                           paddingBottom: '12px',
//                           borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                         }}
//                       >
//                         {/* Sales Info - Avatar with first 2 letters */}
//                         <div
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '12px',
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               bgcolor: '#102dff',
//                               fontSize: '14px',
//                               fontWeight: 'bold',
//                             }}
//                           >
//                             {user.lastComment.sales?.name
//                               ? user.lastComment.sales.name.substring(0, 2).toUpperCase()
//                               : '?'}
//                           </Avatar>
//                           <div>
//                             <div
//                               style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}
//                             >
//                               {user.lastComment.sales?.name || 'Unknown Sales'}
//                             </div>
//                             <div
//                               style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}
//                             >
//                               {user.lastComment.sales?.role || 'Sales'}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Stage on the right - under sales name */}
//                         {(user.lastComment.stage || user.stage) && (
//                           <div
//                             style={{
//                               textAlign: 'right',
//                             }}
//                           >
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                               }}
//                             >
//                               Stage:{' '}
//                               {user.lastComment.stage?.name || user.stage?.name || 'Undefined'}
//                             </div>
//                             {user.lastComment.stageDate && (
//                               <div
//                                 style={{
//                                   fontSize: '11px',
//                                   color: mode === 'dark' ? '#999' : '#888',
//                                   marginTop: '2px',
//                                 }}
//                               >
//                                 <span>
//                                   SD : |{' '}
//                                   {new Date(user.lastComment.stageDate).toLocaleString('en-US', {
//                                     year: 'numeric',
//                                     month: '2-digit',
//                                     day: '2-digit',
//                                     hour: '2-digit',
//                                     minute: '2-digit',
//                                     hour12: true,
//                                   })}
//                                 </span>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </div>

//                       {/* Comment Date - Only if exists - 12 hour format */}
//                       {user.lastComment.firstcomment?.date && (
//                         <div
//                           style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             gap: '6px',
//                             fontSize: '12px',
//                             color: mode === 'dark' ? '#ccc' : '#666',
//                             marginBottom: '16px',
//                             padding: '6px 12px',
//                             background:
//                               mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                             borderRadius: '6px',
//                           }}
//                         >
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                           >
//                             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//                             <line x1="16" y1="2" x2="16" y2="6"></line>
//                             <line x1="8" y1="2" x2="8" y2="6"></line>
//                             <line x1="3" y1="10" x2="21" y2="10"></line>
//                           </svg>
//                           {new Date(user.lastComment.firstcomment.date).toLocaleDateString() +
//                             ' • ' +
//                             new Date(user.lastComment.firstcomment.date).toLocaleTimeString(
//                               'en-US',
//                               {
//                                 hour: '2-digit',
//                                 minute: '2-digit',
//                                 hour12: true,
//                               },
//                             )}
//                         </div>
//                       )}

//                       {/* First Comment (Comment) */}
//                       {user.lastComment.firstcomment?.text &&
//                         user.lastComment.firstcomment.text !== '-' && (
//                           <div style={{ marginBottom: '16px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                               </svg>
//                               Comment
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {user.lastComment.firstcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Second Comment (Action Plan) */}
//                       {user.lastComment.secondcomment?.text &&
//                         user.lastComment.secondcomment.text !== '-' && (
//                           <div style={{ marginBottom: '12px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                                 <polyline points="14,2 14,8 20,8"></polyline>
//                                 <line x1="16" y1="13" x2="8" y2="13"></line>
//                                 <line x1="16" y1="17" x2="8" y2="17"></line>
//                                 <polyline points="10,9 9,9 8,9"></polyline>
//                               </svg>
//                               Action Plan
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {user.lastComment.secondcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Last Updated */}
//                       <div
//                         style={{
//                           fontSize: '11px',
//                           color: mode === 'dark' ? '#999' : '#888',
//                           textAlign: 'center',
//                           marginTop: '16px',
//                           paddingTop: '12px',
//                           borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           gap: '6px',
//                         }}
//                       >
//                         <svg
//                           width="12"
//                           height="12"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                         >
//                           <circle cx="12" cy="12" r="10"></circle>
//                           <polyline points="12,6 12,12 16,14"></polyline>
//                         </svg>
//                         Last updated:{' '}
//                         {user.lastComment.actionUpdatedAt
//                           ? new Date(user.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//                               year: 'numeric',
//                               month: '2-digit',
//                               day: '2-digit',
//                             })
//                           : 'Unknown'}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               }
//               arrow
//               placement="left-start"
//               componentsProps={{
//                 tooltip: {
//                   sx: {
//                     backgroundColor: 'transparent',
//                     padding: 0,
//                     m: 0,
//                     boxShadow: 'none',
//                     border: 'none',
//                     overflow: 'visible',
//                     maxWidth: 'none',
//                   },
//                 },
//               }}
//             >
//               <IconButton
//                 size="small"
//                 sx={{
//                   color: user.lastComment
//                     ? mode === 'dark'
//                       ? '#90caf9'
//                       : '#102dff'
//                     : mode === 'dark'
//                       ? '#666'
//                       : '#ccc',
//                   '&:hover': {
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//                   },
//                 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                 </svg>
//                 {user.lastComment && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 4,
//                       right: 4,
//                       width: 6,
//                       height: 6,
//                       borderRadius: '50%',
//                       backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                     }}
//                   />
//                 )}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );

//       case 'stage':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
//             {user.stage?.name && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 {user.stage.name === 'Done Deal' ? (
//                   <span style={{ fontSize: '18px' }}>🎉</span>
//                 ) : user.stage.name === 'Pending' ? (
//                   <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Fresh' ? (
//                   <CheckIcon sx={{ fontSize: '18px', color: '#4caf50' }} />
//                 ) : user.stage.name === 'Not Interested' ? (
//                   <Box
//                     sx={{
//                       fontSize: '18px',
//                       color: '#333',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       backgroundColor: '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     -
//                   </Box>
//                 ) : user.stage.name === 'EOI' ? (
//                   <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Reservation' ? (
//                   <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Transfer' ? (
//                   <TransferWithinAStationIcon sx={{ color: 'red', fontSize: '18px' }} />
//                 ) : (
//                   <Box
//                     sx={{
//                       backgroundColor: moment(user.stagedateupdated).isBefore(moment())
//                         ? '#CC5500'
//                         : 'royalblue',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       color: '#fff',
//                     }}
//                   ></Box>
//                 )}
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#fff' : '#666' }}>
//                   {user?.stage?.name}
//                 </Typography>
//               </Box>
//             )}
//             {user.stagedateupdated && (
//               <Typography variant="caption" sx={{ color: '#666', fontSize: '11px' }}>
//                 {moment(user.stagedateupdated).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );

//       case 'status':
//         return <StatusChip active={user.leadisactive} />;

//       case 'Creation_date':
//         return (
//           <Box>
//             <Typography variant="body2">{new Date(user.createdAt).toLocaleDateString()}</Typography>
//             <Typography variant="caption" display="block" color="text.secondary">
//               {new Date(user.createdAt).toLocaleTimeString([], {
//                 hour: '2-digit',
//                 minute: '2-digit',
//               })}
//             </Typography>
//           </Box>
//         );

//       case 'AddedBy':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   fontSize: '0.8rem',
//                   bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 }}
//               >
//                 {getInitials(user.addby?.name)}
//               </Avatar>
//               <Box>
//                 <Typography variant="body2" fontWeight="medium">
//                   {user.addby?.name || 'N/A'}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {user.addby?.role || 'No Role'}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         );

//       case 'actions':
//         return <ClientTable2 user={user} allusers={get_all_Leads} />;

//       default:
//         return <Typography variant="body2">{user[col.key] || 'N/A'}</Typography>;
//     }
//   };

//   // state للـ Quick Filter Modal
//   const [quickFilterOpen, setQuickFilterOpen] = useState(false);

//   // دوال فتح وإغلاق الـ Modal
//   const handleQuickFilterOpen = () => setQuickFilterOpen(true);
//   const handleQuickFilterClose = () => setQuickFilterOpen(false);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         minHeight: '100vh',
//         marginTop: isSmallScreen ? '120px' : isMediumScreen ? '30px' : '50px',
//         marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//         padding: isSmallScreen ? '10px' : '20px',
//         backgroundColor: mode === 'dark' ? '#121212' : '#fff',
//         position: 'relative',
//       }}
//       className="startPage"
//     >
//       <Dialog
//         open={openDataCenterModal}
//         onClose={() => !transferLoading && setOpenDataCenterModal(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             backgroundColor: '#1976d2',
//             color: 'white',
//             py: 2,
//           }}
//         >
//           <Box display="flex" alignItems="center">
//             <DataUsageIcon sx={{ mr: 1.5 }} />
//             <Typography variant="h6" fontWeight="bold">
//               Transfer to Data Center
//             </Typography>
//           </Box>
//           <IconButton
//             onClick={() => !transferLoading && setOpenDataCenterModal(false)}
//             sx={{ color: 'white' }}
//             disabled={transferLoading}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ pt: 3, pb: 2 }}>
//           <Box sx={{ mb: 3 }}>
//             <Alert severity="warning" icon={<WarningAmberIcon />} sx={{ mb: 2 }}>
//               <Typography fontWeight="bold">⚠️ Important: This action cannot be undone!</Typography>
//             </Alert>

//             <Typography variant="body1" sx={{ mb: 2 }}>
//               You are about to transfer{' '}
//               <strong style={{ color: '#1976d2' }}>{selectedLeads.length} leads</strong> to the Data
//               Center.
//             </Typography>

//             <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//               This will move all selected leads to the central data repository. Please verify that
//               this is the correct action.
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25, 118, 210, 0.05)',
//               p: 2,
//               borderRadius: 1,
//               mb: 3,
//             }}
//           >
//             <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
//               Security Verification
//             </Typography>
//             <Typography variant="body2" sx={{ mb: 2 }}>
//               To confirm this operation, please type the exact number of selected leads in the box
//               below:
//             </Typography>

//             <TextField
//               fullWidth
//               type="number"
//               label={`Type "${selectedLeads.length}" to confirm`}
//               value={confirmationCount}
//               onChange={(e) => {
//                 setConfirmationCount(e.target.value);
//                 setTransferError('');
//               }}
//               error={!!transferError}
//               helperText={transferError || 'Enter the exact number of selected leads'}
//               disabled={transferLoading}
//               InputProps={{
//                 inputProps: {
//                   min: 0,
//                   max: selectedLeads.length,
//                 },
//               }}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
//                 },
//               }}
//             />
//           </Box>

//           {transferLoading && (
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2 }}>
//               <CircularProgress size={24} sx={{ mr: 2 }} />
//               <Typography variant="body2">Transferring leads to Data Center...</Typography>
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button
//             onClick={() => setOpenDataCenterModal(false)}
//             disabled={transferLoading}
//             sx={{
//               color: mode === 'dark' ? '#ccc' : '#666',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//               },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={confirmTransferToDataCenter}
//             disabled={
//               transferLoading ||
//               !confirmationCount ||
//               parseInt(confirmationCount) !== selectedLeads.length
//             }
//             startIcon={transferLoading ? <CircularProgress size={16} /> : <DataUsageIcon />}
//             sx={{
//               backgroundColor: '#1976d2',
//               '&:hover': {
//                 backgroundColor: '#1565c0',
//               },
//               '&:disabled': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.26)',
//               },
//             }}
//           >
//             {transferLoading ? 'Transferring...' : 'Confirm Transfer'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Modals */}
//       {/* {selectedLead && (
//         <ShowClientsActions 
//           user={selectedLead} 
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )} */}

//       {/* ShowUserSheet Dialog */}
//       <ShoweetingShwwtForAdmin open={sheetOpen} onClose={() => setSheetOpen(false)} />

//       {selectedLead && (
//         <ShowClientsActionsAdvanced
//           user={selectedLead}
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )}

//       <LeadDuplicationModal
//         open={duplicationModal.open}
//         onClose={() => setDuplicationModal({ open: false, leadId: null, leadName: '' })}
//         leadId={duplicationModal.leadId}
//         leadName={duplicationModal.leadName}
//       />

//       {/* Quick Filter Modal */}
//       <QuickFilterModal
//         open={quickFilterOpen}
//         onClose={handleQuickFilterClose}
//         onApplyFilters={handleApplyFilters}
//       />

//       {/* Delete All Selected Leads Modal */}
//       <Modal
//         style={{ zIndex: '20000' }}
//         show={showmoredelete}
//         onHide={handleClosemoredelete}
//         centered
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//             borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//             padding: '20px 24px',
//           }}
//         >
//           <Modal.Title
//             style={{
//               fontWeight: '600',
//               fontSize: '1.25rem',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px',
//             }}
//           >
//             <DeleteOutlineIcon style={{ fontSize: '28px', color: '#d32f2f' }} />
//             Delete Selected Leads
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body
//           style={{
//             color: mode === 'dark' ? '#e0e0e0' : '#424242',
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//             padding: '24px',
//           }}
//         >
//           <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//             <h5
//               style={{
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 fontWeight: '500',
//                 marginBottom: '16px',
//               }}
//             >
//               Confirm Deletion
//             </h5>
//             <p style={{ fontSize: '16px', marginBottom: '20px' }}>
//               Are you sure you want to delete{' '}
//               <strong style={{ color: '#d32f2f' }}>{selectedLeads.length}</strong> selected lead(s)?
//             </p>

//             <div
//               style={{
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.05)',
//                 padding: '12px 16px',
//                 borderRadius: '8px',
//                 border: '1px solid #d32f2f',
//                 marginBottom: '16px',
//               }}
//             >
//               <span
//                 style={{
//                   color: '#d32f2f',
//                   fontWeight: '500',
//                   fontSize: '14px',
//                 }}
//               >
//                 ⚠️ This action cannot be undone
//               </span>
//             </div>
//           </div>

//           <hr
//             style={{
//               border: 'none',
//               height: '1px',
//               backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0',
//               margin: '20px 0',
//             }}
//           />

//           <div
//             className="d-flex justify-content-between align-items-center"
//             style={{
//               color: mode === 'dark' ? '#e0e0e0' : '#424242',
//               backgroundColor: 'transparent',
//             }}
//           >
//             <Button
//               style={{
//                 background: 'transparent',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 border: '2px solid',
//                 borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 borderRadius: '8px',
//                 padding: '8px 20px',
//                 fontWeight: '500',
//                 transition: 'all 0.3s ease',
//               }}
//               onMouseOver={(e) => {
//                 e.target.style.background =
//                   mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)';
//               }}
//               onMouseOut={(e) => {
//                 e.target.style.background = 'transparent';
//               }}
//               onClick={handleClosemoredelete}
//             >
//               <CloseIcon style={{ marginRight: '8px', fontSize: '18px' }} />
//               Cancel
//             </Button>

//             <Button
//               style={{
//                 background: '#102dff',
//                 color: '#fff',
//                 border: '2px solid #102dff',
//                 borderRadius: '8px',
//                 padding: '8px 24px',
//                 fontWeight: '500',
//                 transition: 'all 0.3s ease',
//                 boxShadow: '0 2px 8px rgba(31, 7, 173, 0.3)',
//               }}
//               onMouseOver={(e) => {
//                 e.target.style.background = '#1f34d7ff';
//                 e.target.style.boxShadow = '0 4px 12px rgba(31, 7, 173, 0.3)';
//               }}
//               onMouseOut={(e) => {
//                 e.target.style.background = '#102dff';
//                 e.target.style.boxShadow = '0 2px 8px rgba(31, 7, 173, 0.3)';
//               }}
//               type="submit"
//               onClick={handledeleteallselectedleads}
//             >
//               <DeleteOutlineIcon style={{ marginRight: '8px', fontSize: '18px' }} />
//               Delete {selectedLeads.length} Lead(s)
//             </Button>
//           </div>

//           {message && (
//             <div className="d-flex justify-content-center flex-wrap" style={{ marginTop: '16px' }}>
//               <p
//                 style={{
//                   color: '#d32f2f',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.05)',
//                   padding: '12px 16px',
//                   borderRadius: '8px',
//                   border: '1px solid #d32f2f',
//                   fontWeight: '500',
//                   textAlign: 'center',
//                   width: '100%',
//                   margin: 0,
//                 }}
//               >
//                 {message}
//               </p>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>

//       {/* <Modal show={openimport2} onHide={handleCloseimport2} centered>
//   <Modal.Header closeButton>
//     <Modal.Title>Import Leads</Modal.Title>
//   </Modal.Header>
//   <Modal.Body>
//     <Form.Group controlId="formFile" className="mb-3">
//       <Form.Label style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007bff' }}>
//         Choose Excel File From Your PC
//       </Form.Label>
// <Form.Control type="file" accept=".xlsx,.xls" onChange={handleFileSelect} />
//     </Form.Group>

//     {fileimport2 && (
//       <p className="text-muted">📎 Selected File: <strong>{fileimport2.name}</strong></p>
//     )}

//     {previewData.length > 0 && (
//       <div style={{ maxHeight: 150, overflowY: 'auto', border: '1px solid #ccc', padding: 10 }}>
//         <strong>Preview First Two Record:</strong>
//         <pre>{JSON.stringify(previewData.slice(0, 2), null, 2)}</pre>
//       </div>
//     )}

//     <Button
//       variant="primary"
//       onClick={onUploadimportleads2}
//       disabled={loadingimprt2 || !fileimport2}
//       className="w-100 mt-3"
//     >
//       {loadingimprt2 ? <Spinner animation="border" size="sm" /> : 'Upload Excel File'}
//     </Button>

//     {resultimport2 && (
//       <Alert variant="success" className="mt-3">
//         <pre>{JSON.stringify(resultimport2, null, 2)}</pre>
//       </Alert>
//     )}

//     {errorimport2 && (
//       <Alert variant="danger" className="mt-3">
//         <pre>{JSON.stringify(errorimport2, null, 2)}</pre>
//       </Alert>
//     )}
//   </Modal.Body>
//   <Modal.Footer>
//     <Button variant="secondary" onClick={handleCloseimport2}>
//       Close
//     </Button>
//   </Modal.Footer>
// </Modal> */}

//       <Modal show={openimport2} onHide={handleCloseimport2} centered size="lg">
//         <Modal.Header
//           closeButton
//           style={{
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//             borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//           }}
//         >
//           <Modal.Title
//             style={{
//               color: mode === 'dark' ? '#fff' : '#000',
//               fontWeight: '600',
//             }}
//           >
//             <CloudUploadIcon style={{ marginRight: '10px', verticalAlign: 'middle' }} />
//             Import Leads from Excel
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body
//           style={{
//             backgroundColor: mode === 'dark' ? '#121212' : '#fff',
//             padding: '0',
//           }}
//         >
//           {/* التبويبات */}
//           <div
//             style={{
//               borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//               padding: '0 20px',
//             }}
//           >
//             <div className="nav nav-tabs border-0">
//               <div className="nav-item">
//                 <button
//                   className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('settings')}
//                   style={{
//                     border: 'none',
//                     backgroundColor: 'transparent',
//                     color:
//                       activeTab === 'settings'
//                         ? mode === 'dark'
//                           ? '#90caf9'
//                           : '#1976d2'
//                         : mode === 'dark'
//                           ? '#999'
//                           : '#666',
//                     fontWeight: '500',
//                     padding: '12px 16px',
//                     borderBottom: activeTab === 'settings' ? '2px solid' : 'none',
//                     borderBottomColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   }}
//                 >
//                   ⚙️ Import Settings
//                 </button>
//               </div>
//               <div className="nav-item">
//                 <button
//                   className={`nav-link ${activeTab === 'template' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('template')}
//                   style={{
//                     border: 'none',
//                     backgroundColor: 'transparent',
//                     color:
//                       activeTab === 'template'
//                         ? mode === 'dark'
//                           ? '#90caf9'
//                           : '#1976d2'
//                         : mode === 'dark'
//                           ? '#999'
//                           : '#666',
//                     fontWeight: '500',
//                     padding: '12px 16px',
//                     borderBottom: activeTab === 'template' ? '2px solid' : 'none',
//                     borderBottomColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   }}
//                 >
//                   📋 Excel Template
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* محتوى التبويب الأول: Settings */}
//           {activeTab === 'settings' && (
//             <div style={{ padding: '20px' }}>
//               {/* 🔘 Switch للـ Import in Data Center */}
//               <div className="mb-4">
//                 <div
//                   style={{
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                     padding: '15px',
//                     borderRadius: '8px',
//                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                   }}
//                 >
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div>
//                       <h6
//                         style={{
//                           fontWeight: '600',
//                           color: mode === 'dark' ? '#fff' : '#000',
//                           marginBottom: '5px',
//                         }}
//                       >
//                         Import Destination
//                       </h6>
//                       <p
//                         style={{
//                           color: mode === 'dark' ? '#aaa' : '#666',
//                           fontSize: '14px',
//                           margin: 0,
//                         }}
//                       >
//                         Choose where to import the leads
//                       </p>
//                     </div>
//                     <div className="d-flex align-items-center">
//                       <span
//                         style={{
//                           marginRight: '10px',
//                           fontSize: '14px',
//                           fontWeight: '500',
//                           color:
//                             mode === 'dark'
//                               ? isDataCenterImport
//                                 ? '#4caf50'
//                                 : '#ff9800'
//                               : isDataCenterImport
//                                 ? '#2e7d32'
//                                 : '#f57c00',
//                         }}
//                       >
//                         {isDataCenterImport ? 'Data Center' : 'Original Leads'}
//                       </span>
//                       <Form.Check
//                         type="switch"
//                         id="import-destination-switch"
//                         checked={isDataCenterImport}
//                         onChange={(e) => setIsDataCenterImport(e.target.checked)}
//                         style={{ transform: 'scale(1.3)' }}
//                       />
//                     </div>
//                   </div>

//                   {/* Visual Indicator */}
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       padding: '10px 15px',
//                       backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.05)',
//                       borderRadius: '6px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                       <div
//                         style={{
//                           width: '12px',
//                           height: '12px',
//                           borderRadius: '50%',
//                           backgroundColor: isDataCenterImport ? '#4caf50' : '#ff9800',
//                           marginRight: '10px',
//                         }}
//                       ></div>
//                       <div>
//                         <strong
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#000',
//                             fontSize: '14px',
//                           }}
//                         >
//                           {isDataCenterImport
//                             ? 'Importing in Data Center'
//                             : 'Importing in Original Leads'}
//                         </strong>
//                         <div
//                           style={{
//                             color: mode === 'dark' ? '#aaa' : '#666',
//                             fontSize: '13px',
//                           }}
//                         >
//                           {isDataCenterImport
//                             ? '✓ Leads will be marked as "this in data" (transferefromdata: false)'
//                             : '✓ Leads will be marked as "transferred from data" (transferefromdata: true)'}
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={{
//                         backgroundColor: isDataCenterImport
//                           ? mode === 'dark'
//                             ? 'rgba(76, 175, 80, 0.2)'
//                             : 'rgba(76, 175, 80, 0.1)'
//                           : mode === 'dark'
//                             ? 'rgba(255, 152, 0, 0.2)'
//                             : 'rgba(255, 152, 0, 0.1)',
//                         color: isDataCenterImport ? '#4caf50' : '#ff9800',
//                         padding: '4px 10px',
//                         borderRadius: '12px',
//                         fontSize: '12px',
//                         fontWeight: '600',
//                         border: `1px solid ${isDataCenterImport ? '#4caf50' : '#ff9800'}`,
//                       }}
//                     >
//                       {isDataCenterImport ? 'Data Center' : 'Transferred'}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* File Upload Section */}
//               <div className="mb-4">
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: mode === 'dark' ? '#fff' : '#000',
//                     marginBottom: '15px',
//                   }}
//                 >
//                   📁 Upload Excel File
//                 </h6>

//                 <div
//                   style={{
//                     border: '2px dashed',
//                     borderColor: mode === 'dark' ? '#444' : '#ddd',
//                     borderRadius: '8px',
//                     padding: '30px',
//                     textAlign: 'center',
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
//                     transition: 'all 0.3s',
//                     cursor: 'pointer',
//                     '&:hover': {
//                       borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(144, 202, 249, 0.05)' : 'rgba(25, 118, 210, 0.05)',
//                     },
//                   }}
//                 >
//                   <CloudUploadIcon
//                     style={{
//                       fontSize: '48px',
//                       color: mode === 'dark' ? '#666' : '#999',
//                       marginBottom: '15px',
//                     }}
//                   />

//                   <div style={{ marginBottom: '15px' }}>
//                     <input
//                       type="file"
//                       id="excel-file-input"
//                       accept=".xlsx,.xls"
//                       onChange={handleFileSelect}
//                       style={{ display: 'none' }}
//                     />
//                     <label
//                       htmlFor="excel-file-input"
//                       style={{
//                         backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                         color: '#fff',
//                         padding: '10px 20px',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontWeight: '500',
//                         display: 'inline-block',
//                         transition: 'all 0.3s',
//                         '&:hover': {
//                           backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0',
//                         },
//                       }}
//                     >
//                       Browse Files
//                     </label>
//                   </div>

//                   <div
//                     style={{
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       fontSize: '14px',
//                     }}
//                   >
//                     <div>Supported formats: .xlsx, .xls</div>
//                     <div>Max file size: 10MB</div>
//                   </div>
//                 </div>
//               </div>

//               {/* Selected File Preview */}
//               {fileimport2 && (
//                 <div className="mb-4">
//                   <div
//                     style={{
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//                       padding: '15px',
//                       borderRadius: '8px',
//                       border:
//                         mode === 'dark'
//                           ? '1px solid rgba(25, 118, 210, 0.3)'
//                           : '1px solid rgba(25, 118, 210, 0.2)',
//                     }}
//                   >
//                     <div className="d-flex justify-content-between align-items-center mb-2">
//                       <div>
//                         <strong style={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}>
//                           📎 Selected File
//                         </strong>
//                         <div style={{ fontSize: '13px', color: mode === 'dark' ? '#aaa' : '#666' }}>
//                           Ready for import to{' '}
//                           <strong>{isDataCenterImport ? 'Data Center' : 'Original Leads'}</strong>
//                         </div>
//                       </div>
//                       <span
//                         style={{
//                           backgroundColor: isDataCenterImport
//                             ? 'rgba(76, 175, 80, 0.2)'
//                             : 'rgba(255, 152, 0, 0.2)',
//                           color: isDataCenterImport ? '#4caf50' : '#ff9800',
//                           padding: '2px 8px',
//                           borderRadius: '12px',
//                           fontSize: '12px',
//                           fontWeight: '600',
//                         }}
//                       >
//                         {isDataCenterImport ? 'Data Center' : 'Transferred'}
//                       </span>
//                     </div>

//                     <div
//                       style={{
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.8)',
//                         padding: '12px',
//                         borderRadius: '6px',
//                       }}
//                     >
//                       <div className="d-flex align-items-center">
//                         <div
//                           style={{
//                             backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                             color: '#fff',
//                             width: '36px',
//                             height: '36px',
//                             borderRadius: '6px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: '12px',
//                             fontSize: '20px',
//                           }}
//                         >
//                           📄
//                         </div>
//                         <div style={{ flex: 1 }}>
//                           <div
//                             style={{
//                               fontWeight: '500',
//                               color: mode === 'dark' ? '#fff' : '#000',
//                               fontSize: '14px',
//                             }}
//                           >
//                             {fileimport2.name}
//                           </div>
//                           <div
//                             style={{
//                               fontSize: '12px',
//                               color: mode === 'dark' ? '#aaa' : '#666',
//                             }}
//                           >
//                             Size: {(fileimport2.size / 1024).toFixed(2)} KB • Type:{' '}
//                             {fileimport2.type || 'Excel'} • Rows: {previewData.length || 0}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Preview Data */}
//               {/* {previewData.length > 0 && (
//           <div className="mb-4">
//             <h6 style={{ 
//               fontWeight: '600', 
//               color: mode === 'dark' ? '#fff' : '#000',
//               marginBottom: '15px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between'
//             }}>
//               <span>🔍 Data Preview (First 3 rows)</span>
//               <span style={{ 
//                 fontSize: '13px',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//                 padding: '2px 8px',
//                 borderRadius: '12px'
//               }}>
//                 {previewData.length} total rows
//               </span>
//             </h6>
            
//             <div style={{ 
//               maxHeight: '200px',
//               overflowY: 'auto',
//               border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//               borderRadius: '6px'
//             }}>
//               <table className="table table-sm mb-0" style={{ 
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff'
//               }}>
//                 <thead style={{ 
//                   backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
//                   position: 'sticky',
//                   top: 0
//                 }}>
//                   <tr>
//                     {Object.keys(previewData[0] || {}).slice(0, 8).map((key) => (
//                       <th key={key} style={{ 
//                         fontSize: '12px',
//                         color: mode === 'dark' ? '#ccc' : '#666',
//                         padding: '8px',
//                         whiteSpace: 'nowrap'
//                       }}>
//                         {key}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {previewData.slice(0, 3).map((row, index) => (
//                     <tr key={index} style={{ 
//                       borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #f0f0f0'
//                     }}>
//                       {Object.values(row).slice(0, 8).map((value, i) => (
//                         <td key={i} style={{ 
//                           fontSize: '12px',
//                           padding: '8px',
//                           color: mode === 'dark' ? '#e0e0e0' : '#333',
//                           maxWidth: '150px',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap'
//                         }}>
//                           {value === null || value === undefined || value === '' ? 
//                             <span style={{ 
//                               color: mode === 'dark' ? '#666' : '#999',
//                               fontStyle: 'italic'
//                             }}>—</span> : 
//                             String(value)
//                           }
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )} */}
//               {previewData.length > 0 && (
//                 <div className="mt-3">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#4caf50' : '#28a745',
//                       fontSize: '15px',
//                     }}
//                   >
//                     ✅ Data Preview (First 2 rows):
//                   </strong>
//                   <div
//                     style={{
//                       maxHeight: 200,
//                       overflowY: 'auto',
//                       border: '1px solid',
//                       borderColor: mode === 'dark' ? '#4caf50' : '#28a745',
//                       padding: 10,
//                       backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.05)' : '#f8fff9',
//                       borderRadius: '4px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <table
//                       className="table table-sm table-striped mb-0"
//                       style={{
//                         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'transparent',
//                       }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             backgroundColor:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'transparent',
//                           }}
//                         >
//                           {Object.keys(previewData[0] || {}).map((key) => (
//                             <th
//                               key={key}
//                               className="text-nowrap"
//                               style={{
//                                 color: mode === 'dark' ? '#fff' : '#000',
//                                 fontSize: '12px',
//                               }}
//                             >
//                               {key}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {previewData.slice(0, 2).map((row, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                             }}
//                           >
//                             {Object.values(row).map((value, i) => (
//                               <td
//                                 key={i}
//                                 className="text-nowrap"
//                                 style={{
//                                   color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                                   fontSize: '12px',
//                                 }}
//                               >
//                                 {value === null || value === undefined || value === '' ? (
//                                   <span
//                                     style={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontStyle: 'italic',
//                                     }}
//                                   >
//                                     empty
//                                   </span>
//                                 ) : (
//                                   String(value)
//                                 )}
//                               </td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                       display: 'block',
//                       marginTop: '8px',
//                     }}
//                   >
//                     Showing {Math.min(previewData.length, 2)} of {previewData.length} rows
//                     {previewData.length > 2 && ' - Full data will be imported'}
//                   </small>
//                 </div>
//               )}

//               {/* Upload Button */}
//               <div>
//                 <button
//                   className="w-100 py-2"
//                   onClick={onUploadimportleads2}
//                   disabled={loadingimprt2 || !fileimport2}
//                   style={{
//                     backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontWeight: '600',
//                     fontSize: '16px',
//                     padding: '12px',
//                     cursor: loadingimprt2 || !fileimport2 ? 'not-allowed' : 'pointer',
//                     opacity: loadingimprt2 || !fileimport2 ? 0.6 : 1,
//                     transition: 'all 0.3s',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '10px',
//                     '&:hover:not(:disabled)': {
//                       backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
//                     },
//                   }}
//                 >
//                   {loadingimprt2 ? (
//                     <>
//                       <span className="spinner-border spinner-border-sm" role="status"></span>
//                       Importing to {isDataCenterImport ? 'Data Center' : 'Original Leads'}...
//                     </>
//                   ) : (
//                     <>
//                       <CloudUploadIcon />
//                       Import {previewData.length} Leads to{' '}
//                       {isDataCenterImport ? 'Data Center' : 'Original Leads'}
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* محتوى التبويب الثاني: Template */}
//           {activeTab === 'template' && (
//             <div style={{ padding: '20px' }}>
//               {/* ✅ قسم معاينة قالب Excel */}
//               <div
//                 className="mb-4 p-3 border rounded"
//                 style={{
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                   borderColor: mode === 'dark' ? '#333' : '#dee2e6',
//                 }}
//               >
//                 <div className="d-flex justify-content-between align-items-center mb-2">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       fontSize: '16px',
//                     }}
//                   >
//                     📋 Excel Template Preview
//                   </strong>
//                   <Button
//                     variant="outline-primary"
//                     size="sm"
//                     onClick={downloadExcelTemplate}
//                     style={{
//                       borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       '&:hover': {
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     Download Template
//                   </Button>
//                 </div>

//                 <small
//                   className="d-block mb-2"
//                   style={{
//                     color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                   }}
//                 >
//                   Your Excel file should have these columns (first row as headers):
//                 </small>

//                 <div
//                   style={{
//                     maxHeight: 250,
//                     overflowY: 'auto',
//                     backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : '#f8f9fa',
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? '#444' : '#dee2e6',
//                     borderRadius: '4px',
//                     padding: '10px',
//                     fontFamily: 'monospace',
//                     fontSize: '11px',
//                   }}
//                 >
//                   <table
//                     className="table table-sm table-bordered mb-0"
//                     style={{
//                       backgroundColor: mode === 'dark' ? '#1a1a1a' : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     <thead
//                       style={{
//                         backgroundColor: mode === 'dark' ? '#2d3748' : '#343a40',
//                         color: '#fff',
//                       }}
//                     >
//                       <tr>
//                         <th>name</th>
//                         <th>phone</th>
//                         <th>email</th>
//                         <th>project_name</th>
//                         <th>sales_name</th>
//                         <th>chanel_name</th>
//                         <th>communication_way</th>
//                         <th>stage_name</th>
//                         <th>campaign_name</th>
//                         <th>addby_name</th>
//                         <th>updatedby_name</th>
//                         <th>budget</th>
//                         <th>leedtype</th>
//                         {/* <th>isData</th> */}
//                         <th>stagedateupdated</th>
//                         <th>dayonly</th>
//                         <th>last_stage_date_updated</th>
//                         <th>creation_date</th>
//                         <th>Last_Date_Assigned</th>
//                         <th>question1_text</th>
//                         <th>question1_answer</th>
//                         <th>question2_text</th>
//                         <th>question2_answer</th>
//                         <th>question3_text</th>
//                         <th>question3_answer</th>
//                         <th>question4_text</th>
//                         <th>question4_answer</th>
//                         <th>question5_text</th>
//                         <th>question5_answer</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr
//                         style={{
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                         }}
//                       >
//                         <td>Ahmed Hassan</td>
//                         <td>+971501234567</td>
//                         <td>ahmed@email.com</td>
//                         <td>Dubai Hills</td>
//                         <td>Mohamed Ali</td>
//                         <td>008 | A</td>
//                         <td>Call</td>
//                         <td>Follow UP</td>
//                         <td>Summer Campaign</td>
//                         <td>Joun</td>
//                         <td>Joun</td>
//                         <td>1500000</td>
//                         <td>Cold</td>
//                         <td>2024-03-15</td>
//                         <td>2024-03-15</td>
//                         <td>2024-03-15</td>
//                         <td>2024-01-10</td>
//                         <td>2024-03-01</td>
//                         {/* قيم الحقول الجديدة */}
//                         <td>How did you hear about us?</td>
//                         <td>Facebook</td>
//                         <td>Preferred budget range?</td>
//                         <td>1.5M - 2M AED</td>
//                         <td>Interested in payment plan?</td>
//                         <td>Yes</td>
//                         <td>Preferred location?</td>
//                         <td>Dubai Hills</td>
//                         <td>Ready to proceed?</td>
//                         <td>Need more information</td>
//                       </tr>
//                       <tr
//                         style={{
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                         }}
//                       >
//                         <td>Sarah Johnson</td>
//                         <td>+971502345678</td>
//                         <td>sarah@email.com</td>
//                         <td>Palm Jumeirah</td>
//                         <td>Fatima Ahmed</td>
//                         <td>005 |A</td>
//                         <td>Whatsapp</td>
//                         <td>Pending</td>
//                         <td>Luxury Homes</td>
//                         <td>Johan De</td>
//                         <td>Johan De</td>
//                         <td>2800000</td>
//                         <td>Cold</td>
//                         <td>2024-03-10</td>
//                         <td>2024-03-10</td>
//                         <td>2024-03-10</td>
//                         <td>2024-01-25</td>
//                         <td>2024-02-15</td>
//                         {/* قيم الحقول الجديدة */}
//                         <td>How did you hear about us?</td>
//                         <td>Instagram</td>
//                         <td>Preferred budget range?</td>
//                         <td>2.5M - 3M AED</td>
//                         <td>Interested in payment plan?</td>
//                         <td>Yes, flexible</td>
//                         <td>Preferred location?</td>
//                         <td>Palm Jumeirah</td>
//                         <td>Ready to proceed?</td>
//                         <td>Need to discuss with family</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>

//                 <div className="mt-2">
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                     }}
//                   >
//                     <strong>📌 Important Notes:</strong>
//                     <ul className="mb-0 ps-3" style={{ marginTop: '8px' }}>
//                       <li>
//                         Keep the <strong>exact column names</strong> as shown above (case-sensitive)
//                       </li>
//                       <li>
//                         <strong>project_name, sales_name, chanel_name, stage_name</strong> must
//                         match existing names in the system
//                       </li>
//                       <li>
//                         <strong>Dates format:</strong> YYYY-MM-DD (e.g., 2024-03-15)
//                       </li>
//                       <li>
//                         <strong>Phone numbers:</strong> Include country code (e.g., +971501234567)
//                       </li>
//                       <li>
//                         <strong>isData:</strong> Use "true" for data center leads or "false" for
//                         original leads
//                       </li>
//                       <li>
//                         <strong>leedtype:</strong> Use "Cold" for cold leads
//                       </li>
//                       <li>
//                         <strong>Questions fields:</strong> question1_text to question5_text and
//                         question1_answer to question5_answer are optional text fields
//                       </li>
//                     </ul>
//                   </small>
//                 </div>
//               </div>

//               {/* File Upload Section */}
//               <div className="mb-4">
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: mode === 'dark' ? '#fff' : '#000',
//                     marginBottom: '15px',
//                   }}
//                 >
//                   📁 Test Upload with Template
//                 </h6>

//                 <Form.Group controlId="formFile">
//                   <Form.Label
//                     style={{
//                       textDecoration: 'underline',
//                       cursor: 'pointer',
//                       color: mode === 'dark' ? '#90caf9' : '#007bff',
//                       marginBottom: '10px',
//                       display: 'block',
//                     }}
//                   >
//                     Choose Excel File From Your PC
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept=".xlsx,.xls"
//                     onChange={handleFileSelect}
//                     style={{
//                       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       borderColor: mode === 'dark' ? '#444' : '#ced4da',
//                     }}
//                   />
//                   <Form.Text
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                     }}
//                   >
//                     Supported formats: .xlsx, .xls (Max size: 10MB)
//                   </Form.Text>
//                 </Form.Group>
//               </div>

//               {fileimport2 && (
//                 <div
//                   className="alert alert-info d-flex align-items-center"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(13, 110, 253, 0.1)' : '#d1ecf1',
//                     borderColor: mode === 'dark' ? 'rgba(13, 110, 253, 0.3)' : '#bee5eb',
//                     color: mode === 'dark' ? '#90caf9' : '#0c5460',
//                   }}
//                 >
//                   <div className="me-2">📎</div>
//                   <div>
//                     <strong>Selected File:</strong> {fileimport2.name}
//                     <small
//                       className="d-block"
//                       style={{
//                         color:
//                           mode === 'dark' ? 'rgba(144, 202, 249, 0.8)' : 'rgba(12, 84, 96, 0.8)',
//                       }}
//                     >
//                       Size: {(fileimport2.size / 1024).toFixed(2)} KB | Type: {fileimport2.type} |
//                       Last Modified: {new Date(fileimport2.lastModified).toLocaleDateString()}
//                     </small>
//                   </div>
//                 </div>
//               )}

//               {previewData.length > 0 && (
//                 <div className="mt-3">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#4caf50' : '#28a745',
//                       fontSize: '15px',
//                     }}
//                   >
//                     ✅ Data Preview (First 2 rows):
//                   </strong>
//                   <div
//                     style={{
//                       maxHeight: 200,
//                       overflowY: 'auto',
//                       border: '1px solid',
//                       borderColor: mode === 'dark' ? '#4caf50' : '#28a745',
//                       padding: 10,
//                       backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.05)' : '#f8fff9',
//                       borderRadius: '4px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <table
//                       className="table table-sm table-striped mb-0"
//                       style={{
//                         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'transparent',
//                       }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             backgroundColor:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'transparent',
//                           }}
//                         >
//                           {Object.keys(previewData[0] || {}).map((key) => (
//                             <th
//                               key={key}
//                               className="text-nowrap"
//                               style={{
//                                 color: mode === 'dark' ? '#fff' : '#000',
//                                 fontSize: '12px',
//                               }}
//                             >
//                               {key}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {previewData.slice(0, 2).map((row, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                             }}
//                           >
//                             {Object.values(row).map((value, i) => (
//                               <td
//                                 key={i}
//                                 className="text-nowrap"
//                                 style={{
//                                   color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                                   fontSize: '12px',
//                                 }}
//                               >
//                                 {value === null || value === undefined || value === '' ? (
//                                   <span
//                                     style={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontStyle: 'italic',
//                                     }}
//                                   >
//                                     empty
//                                   </span>
//                                 ) : (
//                                   String(value)
//                                 )}
//                               </td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                       display: 'block',
//                       marginTop: '8px',
//                     }}
//                   >
//                     Showing {Math.min(previewData.length, 2)} of {previewData.length} rows
//                     {previewData.length > 2 && ' - Full data will be imported'}
//                   </small>
//                 </div>
//               )}

//               {/* Upload Button in Template Tab */}
//               {/* <div className="mt-4">
//           <Button
//             variant="primary"
//             onClick={onUploadimportleads2}
//             disabled={loadingimprt2 || !fileimport2}
//             className="w-100 py-2"
//             style={{
//               backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//               borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//               fontWeight: '600',
//               '&:hover:not(:disabled)': {
//                 backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0'
//               }
//             }}
//           >
//             {loadingimprt2 ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 Uploading & Processing...
//               </>
//             ) : '📤 Upload Excel File'}
//           </Button>
//         </div> */}

//               {/* Import Results */}
//               {resultimport2 && (
//                 <Alert
//                   variant="success"
//                   className="mt-3"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.1)' : '#d4edda',
//                     borderColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.3)' : '#c3e6cb',
//                     color: mode === 'dark' ? '#a5d6a7' : '#155724',
//                   }}
//                 >
//                   <div className="d-flex align-items-center">
//                     <div className="me-2">✅</div>
//                     <div>
//                       <strong>Import Completed Successfully!</strong>
//                       <div className="mt-2">
//                         <div className="mb-1">
//                           <span className="badge bg-success me-2">
//                             Imported: {resultimport2.importedCount || 0}
//                           </span>
//                           <span className="badge bg-warning me-2">
//                             Skipped: {resultimport2.skippedCount || 0}
//                           </span>
//                           <span className="badge bg-danger">
//                             Errors: {resultimport2.errors?.length || 0}
//                           </span>
//                         </div>

//                         {resultimport2.errors && resultimport2.errors.length > 0 && (
//                           <div className="mt-2">
//                             <strong>Error Details:</strong>
//                             <div
//                               className="mt-1 small"
//                               style={{ maxHeight: '100px', overflowY: 'auto' }}
//                             >
//                               {resultimport2.errors.slice(0, 5).map((error, i) => (
//                                 <div
//                                   key={i}
//                                   className="border-start border-3 border-danger ps-2 mb-1"
//                                   style={{
//                                     color: mode === 'dark' ? '#f44336' : '#721c24',
//                                   }}
//                                 >
//                                   <strong>Row {error.row}:</strong> {error.message}
//                                 </div>
//                               ))}
//                               {resultimport2.errors.length > 5 && (
//                                 <div
//                                   style={{
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                                   }}
//                                 >
//                                   ... and {resultimport2.errors.length - 5} more errors
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         )}

//                         {resultimport2.message && (
//                           <div
//                             className="mt-2"
//                             style={{
//                               color: mode === 'dark' ? '#a5d6a7' : '#155724',
//                             }}
//                           >
//                             <small>{resultimport2.message}</small>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </Alert>
//               )}

//               {errorimport2 && (
//                 <Alert
//                   variant="danger"
//                   className="mt-3"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(244, 67, 54, 0.1)' : '#f8d7da',
//                     borderColor: mode === 'dark' ? 'rgba(244, 67, 54, 0.3)' : '#f5c6cb',
//                     color: mode === 'dark' ? '#f44336' : '#721c24',
//                   }}
//                 >
//                   <div className="d-flex align-items-center">
//                     <div className="me-2">❌</div>
//                     <div>
//                       <strong>Import Failed!</strong>
//                       <div className="mt-1">
//                         {typeof errorimport2 === 'string'
//                           ? errorimport2
//                           : errorimport2.message || JSON.stringify(errorimport2, null, 2)}
//                       </div>
//                     </div>
//                   </div>
//                 </Alert>
//               )}
//             </div>
//           )}
//         </Modal.Body>
//         {/* <Modal.Footer style={{ 
//     backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//     borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//   }}>
//     <Button variant="secondary" onClick={handleCloseimport2} style={{
//       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : '#6c757d',
//       borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : '#6c757d',
//       color: '#fff'
//     }}>
//       Close
//     </Button>
//   </Modal.Footer> */}
//       </Modal>

//       {/* Header Section */}
//       {/* Header Section */}
//       {/* Header Section */}
//       <Box
//         className="my-3"
//         sx={{
//           mb: 4,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           gap: 2,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             sx={{
//               fontWeight: 'bold',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//             }}
//           >
//             Leads Management
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{
//               color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//             }}
//           >
//             Manage and track all leads in the system
//           </Typography>
//         </Box>

//         {/* Buttons Container */}
//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//           {/* Create New Lead Button - بنفس ستايل Table Settings */}
//           <Link to={`/addclient`} style={{ textDecoration: 'none' }}>
//             <Button
//               variant="outlined"
//               startIcon={<AddCircleOutlineOutlinedIcon />}
//               sx={{
//                 minWidth: 'auto',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#1976d2',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                   borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//                 },
//               }}
//             >
//               Create New Lead
//             </Button>
//           </Link>

//           <Button
//             variant="outlined"
//             startIcon={<AddCircleOutlineOutlinedIcon />}
//             onClick={() => setSheetOpen(true)} // ✅ فتح الـ Dialog عند الضغط
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Your Sheet
//           </Button>

//           <Button
//             variant="outlined"
//             startIcon={<CloudUploadIcon />}
//             onClick={handleOpenimport2}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Import Leads
//           </Button>

//           {/* Quick Filter Button - الجديد */}
//           <Button
//             variant="outlined"
//             startIcon={<FilterListIcon />}
//             onClick={handleQuickFilterOpen}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Quick Filter
//           </Button>

//           {/* Refresh Button - بنفس ستايل Table Settings */}
//           <Button
//             variant="outlined"
//             startIcon={<SwapHorizIcon />}
//             onClick={handleRefreshData}
//             disabled={loadinggetdtaa}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//               '&:disabled': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               },
//             }}
//           >
//             {loadinggetdtaa ? 'Refreshing...' : 'Refresh Data'}
//           </Button>

//           {/* Table Settings Button */}
//           <Button
//             variant="outlined"
//             startIcon={<SettingsIcon />}
//             onClick={() => setTableSettingsOpen(true)}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Table Settings
//           </Button>
//         </Box>
//       </Box>

//       {/* 🔍 عرض حالة البحث الحالي */}
//       {searchQuery && (
//         <Box
//           sx={{
//             mt: 2,
//             p: 2,
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//             borderRadius: 2,
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
//           >
//             <SearchIcon fontSize="small" />
//             <strong>Searching:</strong> "{searchQuery}"
//             {resleads?.pagination && (
//               <Chip
//                 label={`${resleads.pagination.totalItems} results`}
//                 size="small"
//                 color="primary"
//                 variant="outlined"
//               />
//             )}
//             <Button
//               size="small"
//               variant="outlined"
//               onClick={() => {
//                 localStorage.setItem('mainsearchstorage', '');
//                 window.dispatchEvent(new Event('mainsearchupdated'));
//               }}
//               sx={{ ml: 'auto' }}
//             >
//               Clear Search
//             </Button>
//           </Typography>
//           <Typography variant="caption" sx={{ display: 'block', mt: 1, fontFamily: 'monospace' }}>
//             Using keyword search in name, email, and phone
//           </Typography>
//         </Box>
//       )}

//       {/* Stats Cards */}
//       {resleads?.pagination && (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Total Leads
//               </Typography>
//               <Typography variant="h5" component="div">
//                 {resleads.pagination.totalAllLeads}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Active Leads
//               </Typography>
//               <Typography variant="h5" component="div" color="success.main">
//                 {resleads.pagination.totalLeadsActive}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Inactive Leads
//               </Typography>
//               <Typography variant="h5" component="div" color="text.secondary">
//                 {resleads.pagination.totalLeadsInactive}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Active Percentage
//               </Typography>
//               <Typography variant="h5" component="div" color="primary.main">
//                 {resleads.pagination.activePercentage}%
//               </Typography>
//             </CardContent>
//           </Card>
//         </Box>
//       )}

//       {loadinggetdtaa ? (
//         <Box
//           sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}
//         >
//           <CircularProgress />
//         </Box>
//       ) : (
//         <>
//           <TableContainer
//             component={Paper}
//             sx={{
//               borderRadius: 2,
//               boxShadow:
//                 mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
//               flexGrow: 1,
//               mb: 2,
//               overflow: 'auto',
//             }}
//           >
//             <Table sx={{ minWidth: 650 }} aria-label="leads table" size="small">
//               <TableHead
//                 sx={{
//                   backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//                 }}
//               >
//                 <TableRow>
//                   {getVisibleColumns().map((col) => (
//                     <TableCell
//                       key={col.key}
//                       sx={{
//                         color: tableConfig.whiteHeaders
//                           ? 'white'
//                           : mode === 'dark'
//                             ? 'white'
//                             : 'primary.contrastText',
//                         fontWeight: 'bold',
//                         width: `${col.width}px`,
//                         minWidth: `${col.width}px`,
//                         maxWidth: `${col.width}px`,
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         fontSize: '0.875rem',
//                       }}
//                     >
//                       {col.key === 'selection' ? (
//                         <Checkbox
//                           checked={selectAll}
//                           onChange={handleSelectAll}
//                           sx={{
//                             color: 'white',
//                             '&.Mui-checked': {
//                               color: 'white',
//                             },
//                           }}
//                         />
//                       ) : (
//                         col.label
//                       )}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {resleads?.data?.length > 0 ? (
//                   resleads.data.map((lead) => (
//                     <StyledTableRow key={lead._id}>
//                       {getVisibleColumns().map((col) => (
//                         <TableCell
//                           key={col.key}
//                           sx={{
//                             width: `${col.width}px`,
//                             minWidth: `${col.width}px`,
//                             maxWidth: `${col.width}px`,
//                             verticalAlign: 'top',
//                             overflow: 'hidden',
//                           }}
//                         >
//                           {renderCell(col, lead)}
//                         </TableCell>
//                       ))}
//                     </StyledTableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={getVisibleColumns().length} align="center" sx={{ py: 4 }}>
//                       <Typography variant="h6" color="text.secondary">
//                         {searchQuery ? 'No results found for your search' : 'No leads available'}
//                       </Typography>
//                       {searchQuery && (
//                         <Button
//                           variant="outlined"
//                           onClick={() => {
//                             localStorage.setItem('mainsearchstorage', '');
//                             window.dispatchEvent(new Event('mainsearchupdated'));
//                           }}
//                           sx={{ mt: 2 }}
//                         >
//                           Clear Search
//                         </Button>
//                       )}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           {/* Fixed Pagination Container at Bottom */}
//           {resleads?.data?.length > 0 && (
//             <Paper
//               elevation={3}
//               sx={{
//                 position: 'sticky',
//                 bottom: 0,
//                 left: 0,
//                 right: 0,
//                 zIndex: 1000,
//                 p: 2,
//                 borderRadius: 2,
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                 mt: 2,
//               }}
//             >
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   flexDirection: isSmallScreen ? 'column' : 'row',
//                   gap: 2,
//                   flexWrap: 'wrap',
//                 }}
//               >
//                 {/* Items Per Page Selector */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Items per page:
//                   </Typography>
//                   <TextField
//                     select
//                     value={itemsPerPage}
//                     onChange={handleItemsPerPageChange}
//                     size="small"
//                     sx={{ minWidth: 80 }}
//                   >
//                     <MenuItem value={25}>25</MenuItem>
//                     <MenuItem value={50}>50</MenuItem>
//                     <MenuItem value={100}>100</MenuItem>
//                     <MenuItem value={250}>250</MenuItem>
//                   </TextField>
//                 </Box>

//                 {/* Page Info - نعرض الصفحة الحالية فقط إذا فيه أكثر من صفحة */}
//                 {resleads.pagination?.NumberOfPages > 1 && (
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Page {currentPage} of {resleads.pagination.NumberOfPages}
//                     </Typography>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       onClick={handleOpenGoToPage}
//                       startIcon={<SearchIcon />}
//                       sx={{ ml: 1 }}
//                     >
//                       Go to Page
//                     </Button>
//                   </Box>
//                 )}

//                 {/* Pagination Component - نعرضه فقط إذا فيه أكثر من صفحة */}
//                 {resleads.pagination?.NumberOfPages > 1 ? (
//                   <Pagination
//                     count={resleads.pagination.NumberOfPages}
//                     page={currentPage}
//                     onChange={handlePageChange}
//                     color="primary"
//                     size={isSmallScreen ? 'small' : 'medium'}
//                     showFirstButton
//                     showLastButton
//                   />
//                 ) : (
//                   <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
//                     📄 Single Page
//                   </Typography>
//                 )}

//                 {/* Results Info */}
//                 <Typography variant="body2" color="text.secondary">
//                   Showing <strong>{resleads.data.length}</strong> of{' '}
//                   <strong>{resleads.pagination?.totalItems || resleads.data.length}</strong> results
//                   {(searchQuery || Object.keys(appliedFilters).length > 0) && (
//                     <Chip
//                       label="Filtered"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 1 }}
//                     />
//                   )}
//                 </Typography>
//               </Box>
//             </Paper>
//           )}
//         </>
//       )}

//       {/* Selection Snackbar */}
//       <Snackbar
//         open={snackbarOpen}
//         onClose={handleCloseassign}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//         message={`${selectedLeads.length} lead(s) selected`}
//         action={action}
//         sx={{
//           '& .MuiSnackbar-root': {
//             position: 'fixed',
//           },
//         }}
//       />

//       {/* AssignLeadsModal */}
//       {showAssignModal && (
//         <AssignLeadsModal
//           show={showAssignModal}
//           onHide={handleCloseAssignModal}
//           refreshData={handleRefreshData}
//         />
//       )}

//       {/* Go to Page Dialog */}
//       <Dialog open={goToPageDialog} onClose={handleCloseGoToPage} maxWidth="xs" fullWidth>
//         <DialogTitle>Go to Page</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Page Number"
//             type="number"
//             fullWidth
//             variant="outlined"
//             value={pageInput}
//             onChange={(e) => setPageInput(e.target.value)}
//             inputProps={{
//               min: 1,
//               max: resleads?.pagination?.NumberOfPages,
//             }}
//             helperText={`Enter a page number between 1 and ${resleads?.pagination?.NumberOfPages}`}
//             onKeyPress={(e) => {
//               if (e.key === 'Enter') {
//                 handleGoToPage();
//               }
//             }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseGoToPage}>Cancel</Button>
//           <Button
//             onClick={handleGoToPage}
//             variant="contained"
//             disabled={
//               !pageInput ||
//               parseInt(pageInput) < 1 ||
//               parseInt(pageInput) > resleads?.pagination?.NumberOfPages
//             }
//           >
//             Go
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Table Settings Drawer */}
//       <Drawer
//         anchor="right"
//         open={tableSettingsOpen}
//         onClose={() => setTableSettingsOpen(false)}
//         PaperProps={{
//           sx: {
//             width: isSmallScreen ? '100%' : 400,
//             backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//             backgroundImage: 'none',
//             marginTop: '25px',
//           },
//         }}
//       >
//         <Box sx={{ p: 3 }}>
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#000000',
//               fontWeight: 'bold',
//             }}
//           >
//             🛠️ Table Columns Settings
//           </Typography>

//           {/* Export Buttons Section */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.9)',
//                 fontWeight: '600',
//                 mb: 1,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//               }}
//             >
//               <SystemUpdateAltIcon fontSize="small" />
//               Export Options
//             </Typography>

//             {/* Export Leads Data To Excel Sheet */}
//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={exportFilteredToExcel}
//               sx={{
//                 mb: 1,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#fff',
//                 },
//               }}
//             >
//               Export Leads Data To Excel With Last Comment
//             </Button>

//             {/* Export Leads To Excel with Last Comments */}
//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={exportFilteredLeadsWithAllComments}
//               disabled={!resleads?.data?.length}
//               sx={{
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#fff',
//                 },
//                 '&:disabled': {
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                 },
//               }}
//             >
//               Export with All Comments
//             </Button>
//           </Box>

//           <Divider
//             sx={{
//               my: 2,
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//             }}
//           />

//           <Typography
//             variant="body2"
//             sx={{
//               mb: 3,
//               color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//               fontSize: '0.875rem',
//             }}
//           >
//             Drag to reorder, toggle visibility, and adjust column widths
//           </Typography>

//           <Divider
//             sx={{
//               mb: 3,
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//             }}
//           />

//           {/* Column Reordering Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography
//               variant="subtitle1"
//               gutterBottom
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : '#ffff',
//                 fontWeight: '600',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//               }}
//             >
//               📋 Column Order & Visibility
//             </Typography>

//             <DragDropContext onDragEnd={handleDragEnd}>
//               <Droppable droppableId="columns">
//                 {(provided) => (
//                   <List
//                     {...provided.droppableProps}
//                     ref={provided.innerRef}
//                     sx={{
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                       borderRadius: 2,
//                       p: 1,
//                     }}
//                   >
//                     {tableConfig.columnOrder.map((columnKey, index) => {
//                       const column = tableConfig.columns.find((col) => col.key === columnKey);
//                       if (!column) return null;

//                       return (
//                         <Draggable key={column.key} draggableId={column.key} index={index}>
//                           {(provided, snapshot) => (
//                             <ListItem
//                               ref={provided.innerRef}
//                               {...provided.draggableProps}
//                               {...provided.dragHandleProps}
//                               sx={{
//                                 border: '1px solid',
//                                 borderColor:
//                                   mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                                 borderRadius: 2,
//                                 mb: 1,
//                                 backgroundColor: snapshot.isDragging
//                                   ? mode === 'dark'
//                                     ? 'rgba(144, 202, 249, 0.2)'
//                                     : 'rgba(25, 118, 210, 0.1)'
//                                   : mode === 'dark'
//                                     ? 'rgba(255,255,255,0.03)'
//                                     : 'rgba(255,255,255,0.8)',
//                                 transition: 'all 0.2s ease',
//                                 '&:hover': {
//                                   backgroundColor:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
//                                   borderColor:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                                 },
//                               }}
//                             >
//                               <ListItemIcon sx={{ minWidth: 40 }}>
//                                 <Checkbox
//                                   checked={column.visible}
//                                   onChange={() => toggleColumnVisibility(column.key)}
//                                   icon={<VisibilityOffIcon />}
//                                   checkedIcon={<VisibilityIcon />}
//                                   sx={{
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                     '&.Mui-checked': {
//                                       color: '#4caf50',
//                                     },
//                                   }}
//                                 />
//                               </ListItemIcon>

//                               <ListItemText
//                                 primary={
//                                   <Typography
//                                     sx={{
//                                       color: column.visible
//                                         ? mode === 'dark'
//                                           ? '#ffffff'
//                                           : '#000000'
//                                         : mode === 'dark'
//                                           ? 'rgba(255,255,255,0.4)'
//                                           : 'rgba(0,0,0,0.4)',
//                                       fontWeight: '500',
//                                       fontSize: '0.9rem',
//                                       textDecoration: column.visible ? 'none' : 'line-through',
//                                     }}
//                                   >
//                                     {column.label}
//                                   </Typography>
//                                 }
//                                 secondary={
//                                   <Typography
//                                     sx={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontSize: '0.75rem',
//                                     }}
//                                   >
//                                     Width: {column.width}px
//                                   </Typography>
//                                 }
//                                 sx={{ flex: 1 }}
//                               />

//                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 {/* Width Control */}
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={column.width}
//                                   onChange={(e) =>
//                                     updateColumnWidth(column.key, parseInt(e.target.value) || 100)
//                                   }
//                                   sx={{
//                                     width: 70,
//                                     '& .MuiInputBase-input': {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                       fontSize: '0.8rem',
//                                       padding: '6px 8px',
//                                       textAlign: 'center',
//                                     },
//                                     '& .MuiOutlinedInput-notchedOutline': {
//                                       borderColor:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.3)'
//                                           : 'rgba(0,0,0,0.3)',
//                                     },
//                                     '&:hover .MuiOutlinedInput-notchedOutline': {
//                                       borderColor: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                   inputProps={{
//                                     min: 60,
//                                     max: 400,
//                                     style: {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                 />

//                                 {/* Drag Handle */}
//                                 <DragIndicatorIcon
//                                   sx={{
//                                     cursor: 'grab',
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                     '&:hover': {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                 />
//                               </Box>
//                             </ListItem>
//                           )}
//                         </Draggable>
//                       );
//                     })}
//                     {provided.placeholder}
//                   </List>
//                 )}
//               </Droppable>
//             </DragDropContext>
//           </Box>

//           {/* Action Buttons */}
//           <Box sx={{ display: 'flex', gap: 1, flexDirection: isSmallScreen ? 'column' : 'row' }}>
//             <Button
//               variant="outlined"
//               fullWidth
//               onClick={resetToDefault}
//               startIcon={<SettingsIcon />}
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : 'rgba(255,255,255,0.7)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 '&:hover': {
//                   borderColor: mode === 'dark' ? '#ffffff' : '#000000',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//                 },
//               }}
//             >
//               Reset Defaults
//             </Button>

//             <Button
//               variant="contained"
//               fullWidth
//               onClick={() => setTableSettingsOpen(false)}
//               startIcon={<CheckIcon />}
//               sx={{
//                 backgroundColor: '#1976d2',
//                 '&:hover': {
//                   backgroundColor: '#1565c0',
//                 },
//               }}
//             >
//               Apply Changes
//             </Button>
//           </Box>

//           {/* Quick Stats */}
//           <Box
//             sx={{
//               mt: 3,
//               p: 2,
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//               borderRadius: 2,
//               border: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.2)',
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//                 fontWeight: '500',
//               }}
//             >
//               📊 Current Setup:
//             </Typography>
//             <Typography
//               variant="caption"
//               sx={{
//                 display: 'block',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.7)',
//               }}
//             >
//               {tableConfig.columns.filter((col) => col.visible).length} of{' '}
//               {tableConfig.columns.length} columns visible
//             </Typography>
//           </Box>
//         </Box>
//       </Drawer>
//     </Box>
//   );
// };




























// 20-5-2026
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, Pagination,
  Avatar, TextField, MenuItem, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, Checkbox, Tooltip,
  Drawer, Alert, Switch,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SevereColdIcon                from '@mui/icons-material/SevereCold';
import EditNoteIcon                   from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon         from '@mui/icons-material/AssignmentTurnedIn';
import AddIcon                        from '@mui/icons-material/Add';
import CloudUploadIcon                from '@mui/icons-material/CloudUpload';
import FilterListIcon                 from '@mui/icons-material/FilterList';
import RefreshIcon                    from '@mui/icons-material/Refresh';
import SettingsIcon                   from '@mui/icons-material/Settings';
import PersonAddIcon                  from '@mui/icons-material/PersonAdd';
import TransferWithinAStationIcon     from '@mui/icons-material/TransferWithinAStation';
import DeleteOutlineOutlinedIcon      from '@mui/icons-material/DeleteOutlineOutlined';
import CloseIcon                      from '@mui/icons-material/Close';
import SystemUpdateAltIcon            from '@mui/icons-material/SystemUpdateAlt';
import CheckIcon                      from '@mui/icons-material/Check';
import VisibilityIcon                 from '@mui/icons-material/Visibility';
import VisibilityOffIcon              from '@mui/icons-material/VisibilityOff';
import DataUsageIcon                  from '@mui/icons-material/DataUsage';
import CalendarViewWeekOutlinedIcon   from '@mui/icons-material/CalendarViewWeekOutlined';
import ModeEditOutlineOutlinedIcon    from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon       from '@mui/icons-material/RemoveRedEyeOutlined';
import moment                         from 'moment';
import { Getalldatasearch_For_Admin }             from '../Redux/Actions/All_Leads_For_Admin_Action';
import { UpdateClientAction }                     from '../Redux/Actions/UsersAction';
import { Transfere_Leads_TO_Data_Center_Action }  from '../Redux/Actions/CrmDataAction';
import { Notify }                                 from '../Utility/Notify';
import { ClientTable2 }                           from '../Component/ClientTable2';
import { AssignLeadsModal }                       from './AssignLeadsModal';
import { ShowClientsActionsAdvanced }             from './ShowClientsActionsAdvanced';
import { LeadDuplicationModal }                   from './LeadDuplicationModal';
import QuickFilterModal                           from './QuickFilterModal';
import { ShoweetingShwwtForAdmin }                from './ShoweetingShwwtForAdmin';
import XLSX                                       from '../utils/excelUtils';
import axios                                      from 'axios';
import { db_url }                                 from '../Api/BaseUrl';
import { DragDropContext, Droppable, Draggable }  from 'react-beautiful-dnd';
import { useSidebarWidth }                        from '../Utility/useSidebarWidth';
import { BulkEditDrawer } from './BulkEditDrawer';

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#1330A6',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
};

const SIDEBAR_COLLAPSED = 64;

// ─── Styled row ───────────────────────────────────────────────────────────────
const StyledRow = styled(TableRow)(() => ({
  '&:hover': { backgroundColor: 'rgba(26,62,207,0.03)' },
  '& td':    { borderBottom: `1px solid ${C.border}` },
}));

// ─── Stat card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, badge, highlight }) => (
  <Box sx={{
    bgcolor: highlight ? C.accent : C.white,
    border:  `1px solid ${highlight ? C.accent : C.border}`,
    borderRadius: '12px', p: 2.5,
    width: 160, minWidth: 160, height: 120, minHeight: 120,
    boxShadow: highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
    position: 'relative', overflow: 'hidden', flexShrink: 0,
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    {badge && (
      <Box sx={{ position:'absolute', top:10, right:10, bgcolor:C.success, color:'#fff', fontSize:'10px', fontWeight:700, px:'6px', py:'2px', borderRadius:'20px', fontFamily:"'DM Sans',sans-serif" }}>
        {badge}
      </Box>
    )}
    <Typography sx={{ fontSize:'11px', fontWeight:500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing:'0.06em', textTransform:'uppercase', fontFamily:"'DM Sans',sans-serif" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize:'26px', fontWeight:700, color: highlight ? '#fff' : C.text, fontFamily:"'DM Sans',sans-serif", lineHeight:1.2 }}>
      {value != null ? String(value) : '—'}
    </Typography>
    {highlight && <Box sx={{ height:'3px', width:'40px', bgcolor:'#F79009', borderRadius:'2px' }} />}
  </Box>
);

// ─── Action button ────────────────────────────────────────────────────────────
const ActionBtn = ({ icon, label, onClick, primary, disabled }) => (
  <Button onClick={onClick} disabled={disabled} startIcon={icon} size="small"
    sx={{
      fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'13px',
      borderRadius:'8px', textTransform:'none', px:'14px', py:'7px',
      ...(primary
        ? { bgcolor:C.accent, color:'#fff', border:'none', boxShadow:'0 2px 8px rgba(26,62,207,0.25)', '&:hover':{ bgcolor:C.accentDark } }
        : { bgcolor:C.white, color:C.text, border:`1px solid ${C.border}`, '&:hover':{ bgcolor:C.bg, borderColor:C.accent, color:C.accent } }
      ),
    }}
  >
    {label}
  </Button>
);

// ─── Phone cell ───────────────────────────────────────────────────────────────
const PhoneCell = ({ user }) => {
  const [show, setShow] = useState(false);
  return (
    <Box onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Typography sx={{ fontSize:'13px', color:C.text, mb:'4px' }}>
        {show ? user.phone : `${(user.phone||'').substring(0,6)}···`}
      </Typography>
      <Box sx={{ display:'flex', gap:'6px' }}>
        <IconButton size="small" onClick={() => window.open(`https://wa.me/${(user.phone||'').replace(/\D/g,'')}`, '_blank')}
          sx={{ width:26, height:26, bgcolor:'rgba(37,211,102,0.1)', color:'#25D366', '&:hover':{ bgcolor:'rgba(37,211,102,0.2)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </IconButton>
        <IconButton size="small" onClick={() => window.open(`tel:${user.phone}`)}
          sx={{ width:26, height:26, bgcolor:'rgba(26,62,207,0.08)', color:C.accent, '&:hover':{ bgcolor:'rgba(26,62,207,0.15)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
};

// ─── Actions menu ─────────────────────────────────────────────────────────────
const ActionsMenu = ({ user, allusers }) => {
  const [anchorEl,    setAnchorEl]    = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showDelete,  setShowDelete]  = useState(false);
  const open      = Boolean(anchorEl);
  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <ClientTable2 user={user} allusers={allusers} showPreview={showPreview} setShowPreview={setShowPreview} showDelete={showDelete} setShowDelete={setShowDelete} />

      <IconButton size="small" onClick={e => { e.stopPropagation(); setAnchorEl(e.currentTarget); }}
        sx={{ width:30, height:30, borderRadius:'8px', color:C.textMuted, '&:hover':{ bgcolor:C.accentSoft, color:C.accent }, transition:'all 0.15s' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/>
        </svg>
      </IconButton>

      {open && (
        <Box onClick={e => e.stopPropagation()} sx={{
          position:'fixed',
          top:  anchorEl ? anchorEl.getBoundingClientRect().bottom + 4 : 0,
          left: anchorEl ? Math.min(anchorEl.getBoundingClientRect().left - 160, window.innerWidth - 200) : 0,
          zIndex:9999, bgcolor:C.white, borderRadius:'12px', border:`1px solid ${C.border}`,
          boxShadow:'0 8px 32px rgba(16,24,40,0.14)', minWidth:200, py:'6px', overflow:'hidden',
        }}>
          <Box onClick={closeMenu} sx={{ position:'fixed', inset:0, zIndex:-1 }} />
          <Box sx={{ px:'8px', display:'flex', flexDirection:'column', gap:'2px' }}>
            <Box component="a" href={`#/updateclient/${user._id}`} onClick={closeMenu}
              sx={{ display:'flex', alignItems:'center', gap:'10px', px:'10px', py:'8px', borderRadius:'8px', color:C.text, textDecoration:'none', fontSize:'13px', fontFamily:"'DM Sans',sans-serif", fontWeight:500, '&:hover':{ bgcolor:C.accentSoft, color:C.accent } }}>
              <ModeEditOutlineOutlinedIcon sx={{ fontSize:'17px', color:'inherit' }} />
              Edit Lead
            </Box>
            <Box onClick={() => { closeMenu(); setShowPreview(true); }}
              sx={{ display:'flex', alignItems:'center', gap:'10px', px:'10px', py:'8px', borderRadius:'8px', color:C.text, fontSize:'13px', cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:500, '&:hover':{ bgcolor:'rgba(127,119,221,0.08)', color:'#7F77DD' } }}>
              <RemoveRedEyeOutlinedIcon sx={{ fontSize:'17px', color:'inherit' }} />
              Preview Lead
            </Box>
            {!window.location.hash.includes('AllLeadsnotactivated') && (
              <>
                <Box sx={{ height:'1px', bgcolor:C.border, mx:'4px', my:'4px' }} />
                <Box onClick={() => { closeMenu(); setShowDelete(true); }}
                  sx={{ display:'flex', alignItems:'center', gap:'10px', px:'10px', py:'8px', borderRadius:'8px', color:C.danger, fontSize:'13px', cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:500, '&:hover':{ bgcolor:'rgba(240,68,56,0.06)' } }}>
                  <DeleteOutlineOutlinedIcon sx={{ fontSize:'17px', color:'inherit' }} />
                  Delete Lead
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

// ─── Comment cell ─────────────────────────────────────────────────────────────
const CommentCell = ({ lead }) => {
  const [open, setOpen] = useState(false);
  const lc = lead.lastComment;
  const getInitials = (name) => !name ? '?' : name.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2);

  const tooltipContent = !lc ? (
    <Box sx={{ p:3, textAlign:'center', bgcolor:'#fff', borderRadius:'16px', minWidth:200, boxShadow:'0 8px 32px rgba(16,24,40,0.12)', border:`1px solid ${C.border}` }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <Typography sx={{ color:'#7B829A', fontSize:'13px', fontFamily:"'DM Sans',sans-serif", mt:1 }}>No comments yet</Typography>
    </Box>
  ) : (
    <Box sx={{ width:380, bgcolor:'#fff', borderRadius:'20px', overflow:'hidden', boxShadow:'0 20px 40px rgba(16,24,40,0.18)', border:`1px solid ${C.border}` }}>
      <Box sx={{ px:3, py:2, display:'flex', alignItems:'center', borderBottom:'1px solid #F0F2F8', bgcolor:'#FAFBFD' }}>
        <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
          <Box sx={{ width:44, height:44, borderRadius:'50%', background:'linear-gradient(135deg,#1A3ECF,#2E5AFF)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 4px 12px rgba(26,62,207,0.25)' }}>
            <Typography sx={{ color:'#fff', fontSize:'15px', fontWeight:700, fontFamily:"'DM Sans',sans-serif" }}>{getInitials(lc.sales?.name)}</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight:700, fontSize:'15px', color:'#1C2340', fontFamily:"'DM Sans',sans-serif", lineHeight:1.3, mb:0.5 }}>{lc.sales?.name||'Unknown'}</Typography>
            <Box sx={{ display:'flex', alignItems:'center', gap:1, flexWrap:'wrap' }}>
              {lc.stage?.name && (
                <Box sx={{ px:'10px', py:'3px', borderRadius:'30px', bgcolor:'#EEF1FD', display:'flex', alignItems:'center', gap:'4px' }}>
                  <Box sx={{ width:6, height:6, borderRadius:'50%', bgcolor:'#1A3ECF' }} />
                  <Typography sx={{ fontSize:'10px', fontWeight:700, color:'#1A3ECF', fontFamily:"'DM Sans',sans-serif", textTransform:'uppercase', letterSpacing:'0.06em' }}>{lc.stage.name}</Typography>
                </Box>
              )}
              {lc.firstcomment?.date && (
                <Box sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <Typography sx={{ fontSize:'11px', color:'#7B829A', fontFamily:"'DM Sans',sans-serif", fontWeight:500 }}>{moment(lc.firstcomment.date).format('DD/MM/YYYY h:mm A')}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      {lc.firstcomment?.text && lc.firstcomment.text !== '-' && (
        <Box sx={{ p:2.5, display:'flex', flexDirection:'column', gap:2 }}>
          <Box sx={{ bgcolor:'#F8F9FF', borderRadius:'14px', px:2, py:1.5, borderLeft:'3px solid #1A3ECF' }}>
            <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A3ECF" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
              <Typography sx={{ fontSize:'11px', fontWeight:700, color:'#1A3ECF', fontFamily:"'DM Sans',sans-serif", textTransform:'uppercase', letterSpacing:'0.05em' }}>Comment</Typography>
            </Box>
            <Typography sx={{ fontSize:'13px', color:'#2A3458', fontFamily:"'DM Sans',sans-serif", lineHeight:1.55 }}>{lc.firstcomment.text}</Typography>
          </Box>
          {lc.secondcomment?.text && lc.secondcomment.text !== '-' && (
            <Box sx={{ bgcolor:'#FFF8F0', borderRadius:'14px', px:2, py:1.5, borderLeft:'3px solid #F59E0B' }}>
              <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>
                <Typography sx={{ fontSize:'11px', fontWeight:700, color:'#F59E0B', fontFamily:"'DM Sans',sans-serif", textTransform:'uppercase', letterSpacing:'0.05em' }}>Next Plan</Typography>
              </Box>
              <Typography sx={{ fontSize:'13px', color:'#2A3458', fontFamily:"'DM Sans',sans-serif", lineHeight:1.55 }}>{lc.secondcomment.text}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} title={tooltipContent} placement="left-start" arrow={false}
      componentsProps={{ tooltip:{ sx:{ bgcolor:'transparent', p:0, m:0, boxShadow:'none', border:'none', maxWidth:'none', overflow:'visible' } } }}>
      <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} sx={{ display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
        <Box sx={{ width:36, height:36, borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center', bgcolor: lc ? 'rgba(26,62,207,0.08)' : 'rgba(123,130,154,0.08)', color: lc ? '#1A3ECF' : '#7B829A', position:'relative', transition:'all 0.2s', '&:hover':{ bgcolor: lc ? 'rgba(26,62,207,0.15)' : 'rgba(123,130,154,0.15)', transform:'scale(1.02)' } }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          {lc && <Box sx={{ position:'absolute', top:2, right:2, width:8, height:8, borderRadius:'50%', bgcolor:'#12B76A', border:'1.5px solid #fff' }} />}
        </Box>
      </Box>
    </Tooltip>
  );
};

// ─── Column config ────────────────────────────────────────────────────────────
const DEFAULT_COLS = [
  { key:'dup',         label:'Duplicate',     fieldId:'DUP_STATUS',  w:110, visible:true },
  { key:'name',        label:'Name',          fieldId:'CLIENT_NAME', w:200, visible:true },
  { key:'phone',       label:'Phone',         fieldId:'CONTACT_PH',  w:140, visible:true },
  { key:'project',     label:'Project',       fieldId:'ASSET_ID',    w:170, visible:true },
  { key:'channel',     label:'Channel',       fieldId:'SRC_CHAN',    w:130, visible:true },
  { key:'sales',       label:'Sales',         fieldId:'SALES_REP',   w:150, visible:true },
  { key:'stage',       label:'Stage',         fieldId:'STAGE_ID',    w:160, visible:true },
  { key:'lastComment', label:'Last Comment',  fieldId:'LAST_CMT',    w:60,  visible:true },
  { key:'addedBy',     label:'Added By',      fieldId:'ADDED_BY',    w:140, visible:true },
  { key:'createdAt',   label:'Creation Date', fieldId:'CREATE_DT',   w:160, visible:true },
  { key:'actions',     label:'Actions',       fieldId:'ACT_BTN',     w:60,  visible:true },
];

const getInitials = (n='') => (n||'').split(' ').filter(Boolean).map(w=>w[0]).join('').toUpperCase().slice(0,2)||'?';

// ─── Snackbar button helper ───────────────────────────────────────────────────
const SnBtn = ({ children, color, bg, onClick, title }) => (
  <button onClick={onClick} title={title} style={{
    display:'flex', alignItems:'center', gap:6,
    background:bg, border:'none', borderRadius:10, padding:'7px 13px',
    color, fontSize:12, fontWeight:600, cursor:'pointer',
    fontFamily:"'DM Sans',sans-serif", transition:'all 0.15s',
    whiteSpace:'nowrap', lineHeight:1,
  }}
    onMouseEnter={e => { e.currentTarget.style.filter='brightness(1.2)'; e.currentTarget.style.transform='translateY(-1px)'; }}
    onMouseLeave={e => { e.currentTarget.style.filter=''; e.currentTarget.style.transform=''; }}
  >
    {children}
  </button>
);

// ─── Main ─────────────────────────────────────────────────────────────────────
export const AllLeads_For_Admins_Page = () => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
  const dispatch = useDispatch();
  const location = useLocation();
  const sidebarW = useSidebarWidth();

  const resleads    = useSelector(s => s.All_Leads_For_Admin_Reducer.AllLeads);
  const restransfer = useSelector(s => s.All_CrmDataCenter_Reducer.tranceferetodatacenter);

  // ── state ──────────────────────────────────────────────────────────────────
  const [loading,       setLoading]       = useState(true);
  const [currentPage,   setCurrentPage]   = useState(1);
  const [itemsPerPage,  setItemsPerPage]  = useState(25);
  const [searchQuery,   setSearchQuery]   = useState(localStorage.getItem('mainsearchstorage')||'');
  const [selectedLeads, setSelectedLeads] = useState(() => { try { return JSON.parse(localStorage.getItem('selectedleeds')||'[]'); } catch { return []; } });
  const [selectAll,     setSelectAll]     = useState(false);
  const [selectedLead,  setSelectedLead]  = useState(null);
  const [appliedFilters,setAppliedFilters]= useState({});
  const [userlogin,     setUserlogin]     = useState(null);
  const [bulkEditOpen, setBulkEditOpen] = useState(false);


  const [colConfig, setColConfig] = useState(() => {
    try { const s = localStorage.getItem('leadsColConfig'); return s ? JSON.parse(s) : DEFAULT_COLS; } catch { return DEFAULT_COLS; }
  });
  useEffect(() => { localStorage.setItem('leadsColConfig', JSON.stringify(colConfig)); }, [colConfig]);

  // modals
  const [showAssign,   setShowAssign]   = useState(false);
  const [showDelete,   setShowDelete]   = useState(false);
  const [sheetOpen,    setSheetOpen]    = useState(false);
  const [quickFilter,  setQuickFilter]  = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [duplication,  setDuplication]  = useState({ open:false, leadId:null, leadName:'' });

  // DTC
  const [dtcOpen,     setDtcOpen]     = useState(false);
  const [dtcCount,    setDtcCount]    = useState('');
  const [dtcLoading,  setDtcLoading]  = useState(false);
  const [dtcLoading2, setDtcLoading2] = useState(true);
  const [dtcError,    setDtcError]    = useState('');

  // import
  const [importOpen,    setImportOpen]    = useState(false);
  const [activeTab,     setActiveTab]     = useState('settings');
  const [fileImport,    setFileImport]    = useState(null);
  const [previewData,   setPreviewData]   = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importResult,  setImportResult]  = useState(null);
  const [importError,   setImportError]   = useState(null);
  const [isDataCenter,  setIsDataCenter]  = useState(true);
  const [isOutsource,   setIsOutsource]   = useState(false); // ✅ جديد

  const currentStageRef    = useRef('');
  const pendingRef         = useRef(null);
  const initialLoadDoneRef = useRef(false);

  useEffect(() => { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); }, []);
  useEffect(() => { localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads)); }, [selectedLeads]);

  const toggleColVisibility = (key) => setColConfig(p => p.map(c => c.key===key ? {...c, visible:!c.visible} : c));
  const updateColWidth = (key, w) => setColConfig(p => p.map(c => c.key===key ? {...c, w:Math.max(60,Math.min(400,parseInt(w)||c.w))} : c));
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(colConfig);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setColConfig(items);
  };



  // ── check phones states ──
const [checkFile,     setCheckFile]    = useState(null);
const [checkPhones,   setCheckPhones]  = useState([]);
const [checkLoading,  setCheckLoading] = useState(false);
const [checkResults,  setCheckResults] = useState(null);
const [checkError,    setCheckError]   = useState(null);

  // ── load ───────────────────────────────────────────────────────────────────
  const getSearchQuery = (s) => {
    if (!s) return '';
    const c = s.trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) return `email=${encodeURIComponent(c)}`;
    return `keyword=${encodeURIComponent(c)}`;
  };

  const loadLeads = async (page=1, limit=itemsPerPage, search='', stage='', dups='', filters={}) => {
    setLoading(true);
    let q = `leadisactive=true&limit=${limit}&page=${page}&sort=-date&data=false&transferefromdata=true`;
    if (search) q += `&${getSearchQuery(search)}`;
    if (stage)  q += `&stage=${encodeURIComponent(stage)}`;
    if (dups==='true') q += `&duplicates=true&ignoreduplicate=true`;
    if (filters) {
      ['stage','sales','chanel','campaign','project','developer','addby'].forEach(k => {
        if (filters[k]?.length) { const ids = filters[k].map(i=>i.id||i._id).filter(Boolean).join(','); if (ids) q += `&${k}=${encodeURIComponent(ids)}`; }
      });
      if (filters.createdAt?.from)         q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
      if (filters.createdAt?.to)           q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
      if (filters.stagedateupdated?.from)  q += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
      if (filters.stagedateupdated?.to)    q += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
    }
    try { await dispatch(Getalldatasearch_For_Admin(q)); } catch(e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const stage = sp.get('stage'), dups = sp.get('duplicates'), key = stage||dups||'all';
    if (currentStageRef.current !== key || !initialLoadDoneRef.current) {
      if (pendingRef.current) clearTimeout(pendingRef.current);
      setCurrentPage(1); currentStageRef.current = key;
      pendingRef.current = setTimeout(() => { loadLeads(1, itemsPerPage, searchQuery, stage, dups, appliedFilters); initialLoadDoneRef.current = true; }, 300);
    }
    return () => { if (pendingRef.current) clearTimeout(pendingRef.current); };
  }, [location.search, searchQuery, appliedFilters]);

  useEffect(() => {
    const handler = () => {
      const v = localStorage.getItem('mainsearchstorage')||'';
      setSearchQuery(v); setCurrentPage(1);
      const sp = new URLSearchParams(location.search);
      loadLeads(1, itemsPerPage, v, sp.get('stage'), sp.get('duplicates'));
    };
    window.addEventListener('mainsearchupdated', handler);
    return () => window.removeEventListener('mainsearchupdated', handler);
  }, [itemsPerPage, location.search]);

  // ── selection ──────────────────────────────────────────────────────────────
  const toggleLead = (id) => { const y=window.scrollY; setSelectedLeads(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]); setTimeout(()=>window.scrollTo(0,y),10); };
  const toggleAll  = () => { const y=window.scrollY; if (selectAll){setSelectedLeads([]);setSelectAll(false);}else{setSelectedLeads(resleads?.data?.map(l=>l._id)||[]);setSelectAll(true);} setTimeout(()=>window.scrollTo(0,y),10); };

  const handleAssign   = () => { if (!selectedLeads.length) return; localStorage.setItem('action','Assign');   setShowAssign(true); };
  const handleTransfer = () => { if (!selectedLeads.length) return; localStorage.setItem('action','Transfer'); setShowAssign(true); };
  const handleDelete   = async () => {
    await Promise.all(selectedLeads.map(id => dispatch(UpdateClientAction(id, { leadisactive:'false' }))));
    Notify('success','Leads deleted','success');
    setShowDelete(false); setSelectedLeads([]);
    const sp = new URLSearchParams(location.search);
    loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'));
  };

  // ── DTC ────────────────────────────────────────────────────────────────────
  const confirmDTC = async () => {
    if (parseInt(dtcCount) !== selectedLeads.length) { setDtcError(`Enter exactly ${selectedLeads.length}`); return; }
    setDtcLoading(true); setDtcLoading2(true);
    try { await dispatch(Transfere_Leads_TO_Data_Center_Action([...selectedLeads])); }
    catch(e) { setDtcError(e.message||'Failed'); }
    finally { setDtcLoading(false); setDtcLoading2(false); }
  };
  useEffect(() => {
    if (!dtcLoading2 && restransfer?.status===200) {
      Notify('success','Transferred to Data Center','success');
      setDtcOpen(false); setSelectedLeads([]); setDtcCount('');
      loadLeads(1, itemsPerPage, searchQuery);
    }
  }, [dtcLoading2]);

  // ── import ─────────────────────────────────────────────────────────────────
  const handleFileSelect = (e) => {
    const f = e.target.files[0]; if (!f) return;
    setFileImport(f); setImportResult(null); setImportError(null);
    const reader = new FileReader();
    reader.onload = async (ev) => { const wb = await XLSX.readAsync(ev.target.result); setPreviewData(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])); };
    reader.readAsBinaryString(f);
  };
  const doImport = async () => {
    if (!fileImport) return;
    const fd = new FormData(); fd.append('file', fileImport); fd.append('importInDataCenter', isDataCenter); fd.append('outsource', isOutsource);
    setImportLoading(true);
    try {
      const res = await axios.post(`${db_url}api/v1/users/import-leads`, fd, { headers:{ 'Content-Type':'multipart/form-data' } });
      setImportResult(res.data);
      Notify('success', `${res.data.insertedCount||res.data.importedCount||0} leads imported!`, 'success');
      setTimeout(() => { setImportOpen(false); setFileImport(null); setPreviewData([]); setImportResult(null); }, 2000);
    } catch(err) { setImportError(err.response?.data?.message||err.message); }
    setImportLoading(false);
    loadLeads(1, itemsPerPage, searchQuery);
  };
  const downloadExcelTemplate = () => {
    const templateData = [
      { name:'Ahmed Hassan', phone:'+971501234567', email:'ahmed@email.com', project_name:'Dubai Hills', sales_name:'Mohamed Ali', chanel_name:'008 | A', communication_way:'Call', stage_name:'Follow UP', campaign_name:'Summer Campaign', addby_name:'Joun', updatedby_name:'Joun', budget:'1500000', leedtype:'Cold', stagedateupdated:'2024-03-15', dayonly:'2024-03-15', last_stage_date_updated:'2024-03-15', creation_date:'2024-01-10', Last_Date_Assigned:'2024-03-01', question1_text:'How did you hear about us?', question1_answer:'Facebook', question2_text:'Preferred budget range?', question2_answer:'1.5M - 2M AED', question3_text:'Interested in payment plan?', question3_answer:'Yes', question4_text:'Preferred location?', question4_answer:'Dubai Hills', question5_text:'Ready to proceed?', question5_answer:'Need more information' },
    ];
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Leads Template');
    XLSX.writeFile(wb, 'Leads_Import_Template.xlsx');
  };

  // ── export ─────────────────────────────────────────────────────────────────
  const exportExcel = () => {
    const data = (resleads?.data||[]).map(u => ({ Name:u.name||'', Email:u.email||'', Phone:u.phone||'', Project:u.project?.name||'', Channel:u.chanel?.name||'', Sales:u.sales?.name||'', Stage:u.stage?.name||'', 'Last Comment':u.lastComment?.firstcomment?.text||'', Created:u.date ? moment(u.date).format('DD/MM/YYYY') : '' }));
    const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Leads');
    XLSX.writeFile(wb, `Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
    Notify('success', `Exported ${data.length} leads`, 'success');
  };
  const exportAllComments = async () => {
    try {
      const response = await axios.get(`${db_url}api/v1/Action`);
      const allActions = response.data.data;
      const data = (resleads?.data||[]).map(lead => {
        const acts = allActions.filter(a => a.leed?._id===lead._id);
        const comments = acts.flatMap(a=>a.Comments||[]).sort((a,b)=>new Date(a.stageDate||a.createdAt)-new Date(b.stageDate||b.createdAt));
        const formatted = comments.map((c,i)=>`(${i+1}) [${moment(c.stageDate||c.createdAt).format('DD/MM/YYYY')}] Stage: ${c.stage?.name||'N/A'} | By: ${c.sales?.name||'N/A'}\nComment: ${c.firstcomment?.text||''}\nNext: ${c.secondcomment?.text||''}`).join('\n\n');
        return { Name:lead.name||'', Email:lead.email||'', Phone:lead.phone||'', Sales:lead.sales?.name||'', Stage:lead.stage?.name||'', 'All Comments':formatted||'No Comments' };
      });
      const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Leads');
      XLSX.writeFile(wb, `Leads_AllComments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success','Exported with all comments','success');
    } catch { Notify('error','Export failed','error'); }
  };

  const refresh = () => {
    setCurrentPage(1); setSelectedLeads([]); setSelectAll(false);
    const sp = new URLSearchParams(location.search);
    loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'));
  };

  const pagination = resleads?.pagination;

  // ── JSX ────────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ ml: isMobile ? `${SIDEBAR_COLLAPSED}px` : `${sidebarW}px`, mt:'64px', minHeight:'calc(100vh - 64px)', bgcolor:C.bg, transition:'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)' }}>
      <Box sx={{ p: isMobile ? 2 : 3.5 }}>

        {/* Header */}
        <Box sx={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:2, mb:3 }}>
          <Box>
            <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:800, fontSize: isMobile ? '28px' : '36px', color:C.text, lineHeight:1.15, letterSpacing:'-0.02em' }}>
              Leads<br />Management
            </Typography>
            <Typography sx={{ fontSize:'13.5px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", mt:1, maxWidth:340 }}>
              Visualizing your elite asset pipeline with real-time conversion intelligence.
            </Typography>
          </Box>
          <Box sx={{ display:'flex', gap:'12px', flexWrap:'wrap', alignItems:'stretch' }}>
            <StatCard label="Total Leads"  value={pagination?.totalAllLeads}    highlight   />
            <StatCard label="Active Leads" value={pagination?.totalLeadsActive} />
            <StatCard label="Trash"     value={pagination?.totalLeadsInactive} />
            {/* <StatCard label="Conv. Rate"   value={pagination?.activePercentage != null ? `${pagination.activePercentage}%` : null} highlight /> */}
          </Box>
        </Box>

        {/* Table card */}
        <Box sx={{ bgcolor:C.white, borderRadius:'12px', border:`1px solid ${C.border}`, boxShadow:C.shadow, overflow:'hidden' }}>

          {/* Toolbar */}
          <Box sx={{ px:2.5, py:2, display:'flex', alignItems:'center', gap:1.5, flexWrap:'wrap', borderBottom:`1px solid ${C.border}` }}>
            <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:'16px', color:C.text, flex:1 }}>Live Pipeline</Typography>
            <Tooltip title="Sheet view"><IconButton size="small" sx={{ color:C.textMuted,'&:hover':{color:C.accent} }} onClick={() => setSheetOpen(true)}><CalendarViewWeekOutlinedIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Filter"><IconButton size="small" sx={{ color:C.textMuted,'&:hover':{color:C.accent} }} onClick={() => setQuickFilter(true)}><FilterListIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Refresh"><IconButton size="small" sx={{ color:C.textMuted,'&:hover':{color:C.accent} }} onClick={refresh} disabled={loading}><RefreshIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Table settings"><IconButton size="small" sx={{ color:C.textMuted,'&:hover':{color:C.accent} }} onClick={() => setSettingsOpen(true)}><SettingsIcon fontSize="small" /></IconButton></Tooltip>
            <Box sx={{ width:'1px', height:'20px', bgcolor:C.border }} />
            <ActionBtn icon={<AddIcon />} label="New Lead" primary onClick={() => { window.location.hash='#/addclient'; }} />
            <ActionBtn icon={<CloudUploadIcon />} label="Import Leads" onClick={() => { setImportOpen(true); setActiveTab('settings'); setFileImport(null); setPreviewData([]); setImportResult(null); setImportError(null); }} />
          </Box>

          {/* Table */}
          <TableContainer sx={{ overflowX:'auto' }}>
            <Table size="small" sx={{ minWidth:700 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width:52, minWidth:52, py:'10px', px:'12px', borderBottom:`2px solid ${C.border}` }}>
                    <Checkbox size="small" checked={selectAll} onChange={toggleAll} sx={{ color:C.textMuted }} />
                  </TableCell>
                  {colConfig.filter(c=>c.visible).map(col => (
                    <TableCell key={col.key} sx={{ width:col.w, minWidth:col.w, py:'10px', px:'12px', fontFamily:"'DM Sans',sans-serif", fontSize:'11.5px', fontWeight:600, color:C.textMuted, letterSpacing:'0.05em', textTransform:'uppercase', borderBottom:`2px solid ${C.border}`, whiteSpace:'nowrap' }}>
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c=>c.visible).length+1} align="center" sx={{ py:6 }}><CircularProgress size={32} sx={{ color:C.accent }} /></TableCell></TableRow>
                ) : !resleads?.data?.length ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c=>c.visible).length+1} align="center" sx={{ py:6 }}><Typography sx={{ color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>No leads found</Typography></TableCell></TableRow>
                ) : resleads.data.map(lead => (
                  <StyledRow key={lead._id}>
                    <TableCell sx={{ px:'12px', py:'10px' }}>
                      <Checkbox size="small" checked={selectedLeads.includes(lead._id)} onChange={() => toggleLead(lead._id)} sx={{ color:C.textMuted,'&.Mui-checked':{color:C.accent} }} />
                    </TableCell>

                    {/* Duplicate */}
                    {colConfig.find(c=>c.key==='dup')?.visible && (
                      <TableCell sx={{ px:'12px' }}>
                        <Box onClick={() => setDuplication({ open:true, leadId:lead._id, leadName:lead.name })} sx={{ display:'inline-flex', alignItems:'center', gap:'5px', px:'10px', py:'4px', borderRadius:'20px', border:`1px solid ${C.border}`, fontSize:'12px', fontWeight:500, cursor:'pointer', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", '&:hover':{borderColor:C.accent,color:C.accent} }}>
                          <Box component="span" sx={{ width:22, height:22, borderRadius:'50%', bgcolor:C.accentSoft, color:C.accent, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', fontWeight:700 }}>{lead.totalSubmissions||0}</Box>
                          Reg.
                        </Box>
                      </TableCell>
                    )}

                    {/* Name */}
                    {colConfig.find(c=>c.key==='name')?.visible && (
                      <TableCell sx={{ px:'12px', cursor:'pointer' }} onClick={() => setSelectedLead(lead)}>
                        <Box sx={{ display:'flex', alignItems:'center', gap:'10px' }}>
                          <Avatar sx={{ width:34, height:34, fontSize:'12px', fontWeight:700, bgcolor:C.accentSoft, color:C.accent, fontFamily:"'DM Sans',sans-serif" }}>{getInitials(lead.name)}</Avatar>
                          <Box>
                            <Typography sx={{ fontSize:'13.5px', fontWeight:600, color:C.text, fontFamily:"'DM Sans',sans-serif", lineHeight:1.3 }}>{lead.name}</Typography>
                            <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{lead.email}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    )}

                    {/* Phone */}
                    {colConfig.find(c=>c.key==='phone')?.visible && <TableCell sx={{ px:'12px' }}><PhoneCell user={lead} /></TableCell>}

                    {/* Project */}
                    {colConfig.find(c=>c.key==='project')?.visible && <TableCell sx={{ px:'12px' }}><Typography sx={{ fontSize:'13px', fontWeight:500, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>{lead.project?.name||'—'}</Typography></TableCell>}

                    {/* Channel */}
                    {colConfig.find(c=>c.key==='channel')?.visible && <TableCell sx={{ px:'12px' }}><Typography sx={{ fontSize:'13px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{lead.chanel?.name||'—'}</Typography></TableCell>}

                    {/* Sales */}
                  {/* Sales */}
{colConfig.find(c=>c.key==='sales')?.visible && (
  <TableCell sx={{ px:'12px' }}>
    <Tooltip
      title={lead.assigntype === true
        ? `Team: ${lead.sales?.name||'N/A'} | Leader: ${lead.sales?.teamleader?.name||'N/A'}`
        : `Team Leader: ${lead.sales?.teamleader?.name||'N/A'}`
      }
      arrow placement="top"
    >
      <Box sx={{ display:'flex', alignItems:'center', gap:'8px', cursor:'default' }}>
        {/* Avatar */}
        <Avatar sx={{
          width:30, height:30, fontSize:'11px', fontWeight:700, flexShrink:0,
          fontFamily:"'DM Sans',sans-serif",
          bgcolor: lead.assigntype === true ? 'rgba(13,71,161,0.12)' : 'rgba(247,144,9,0.12)',
          color:   lead.assigntype === true ? C.accent : '#B54708',
        }}>
          {lead.assigntype === true ? 'T' : getInitials(lead.sales?.name)}
        </Avatar>

        <Box>
          {/* Name */}
          <Box sx={{ display:'flex', alignItems:'center', gap:'5px' }}>
            {lead.assigntype === true && (
              <Box sx={{
                fontSize:'9px', fontWeight:800, color:'#fff',
                bgcolor: C.accent, borderRadius:'4px',
                px:'4px', py:'1px', lineHeight:1.4,
                fontFamily:"'DM Sans',sans-serif", letterSpacing:'0.04em',
              }}>
                TL
              </Box>
            )}
            <Typography sx={{
              fontSize:'13px', fontWeight: lead.assigntype === true ? 700 : 500,
              color: lead.assigntype === true ? C.accent : C.text,
              fontFamily:"'DM Sans',sans-serif", lineHeight:1.3,
            }}>
              {lead.assigntype === true
                ? (lead.sales?.teamleader?.name || lead.sales?.name || '—')
                : (lead.sales?.name || '—')
              }
            </Typography>
          </Box>

          {/* Date */}
          {lead.lastdateassign && (
            <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
              {moment(lead.lastdateassign).format('DD/MM/YY HH:mm')}
            </Typography>
          )}


          {/* ✅ Assign indicator */}
{lead.assign === true && (
  <Box sx={{ display:'flex', alignItems:'center', gap:'4px', mt:'3px' }}>
    {[1,2,3].map(dot => (
      <Box key={dot} sx={{
        width:5, height:5, borderRadius:'50%', bgcolor:C.accent,
        animation:'pulse 1.4s ease-in-out infinite',
        animationDelay:`${dot * 0.16}s`,
        '@keyframes pulse': {
          '0%, 80%, 100%': { transform:'scale(0.8)', opacity:0.5 },
          '40%':            { transform:'scale(1)',   opacity:1   },
        },
      }}/>
    ))}
    <Typography sx={{ fontSize:'10px', color:C.accent, fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
      Pending
    </Typography>
  </Box>
)}
        </Box>
      </Box>
    </Tooltip>
  </TableCell>
)}

                    {/* Stage */}
                    {colConfig.find(c=>c.key==='stage')?.visible && (
                      <TableCell sx={{ px:'12px' }}>
                        {lead.stage?.name && (
                          <Box sx={{ display:'flex', alignItems:'center', gap:1, mb: lead.stagedateupdated ? '4px' : 0 }}>
                            {lead.stage.name==='Done Deal'       ? <span style={{fontSize:'18px',lineHeight:1}}>🎉</span>
                            :lead.stage.name==='Pending'         ? <SevereColdIcon sx={{color:'#9c27b0',fontSize:'18px',flexShrink:0}}/>
                            :lead.stage.name==='Fresh'           ? <CheckIcon sx={{fontSize:'18px',color:'#4caf50',flexShrink:0}}/>
                            :lead.stage.name==='Not Interested'  ? <Box sx={{fontSize:'16px',color:'#fff',borderRadius:'50%',width:'20px',height:'20px',bgcolor:'#555',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,flexShrink:0,lineHeight:1}}>—</Box>
                            :lead.stage.name==='EOI'             ? <EditNoteIcon sx={{color:'#9c27b0',fontSize:'18px',flexShrink:0}}/>
                            :lead.stage.name==='Reservation'     ? <AssignmentTurnedInIcon sx={{color:'#9c27b0',fontSize:'18px',flexShrink:0}}/>
                            :lead.stage.name==='Transfer'        ? <TransferWithinAStationIcon sx={{color:'#F04438',fontSize:'18px',flexShrink:0}}/>
// بعد ✅ — نفس منطق الـ default circle
:lead.stage.name==='No Answer' ? <Box sx={{
  width:18, height:18, borderRadius:'50%', flexShrink:0,
  bgcolor: lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment())
    ? '#CC5500'   // الوقت عدى → احمر
    : C.accent,   // الوقت لسه جاي → كحلي
}}/>                            // : <Box sx={{width:18,height:18,borderRadius:'50%',flexShrink:0, bgcolor: lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()) ? '#FF6B35' : C.accent}}/>}
                            : <Box sx={{
    width:18, height:18, borderRadius:'50%', flexShrink:0,
    bgcolor: lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment())
      ? '#CC5500'   // ✅ احمر/برتقالي — الوقت عدى
      : C.accent,   // ✅ كحلي — الوقت لسه ما عداش
  }}
/>}
                            <Box sx={{ display:'inline-flex', alignItems:'center', px:'8px', py:'3px', borderRadius:'20px',
                              bgcolor: lead.stage.name==='Done Deal' ? 'rgba(18,183,106,0.1)' : lead.stage.name==='Pending' ? 'rgba(156,39,176,0.08)' : lead.stage.name==='Transfer' ? 'rgba(240,68,56,0.08)' : lead.stage.name==='Not Interested' ? 'rgba(85,85,85,0.08)' : lead.stage.name==='Fresh' ? 'rgba(76,175,80,0.08)' : lead.stage.name==='No Answer' ? 'rgba(255,107,53,0.08)' :
  (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()))
    ? 'rgba(204,85,0,0.1)'
    : 'rgba(26,62,207,0.07)',
                              color:  lead.stage.name==='Done Deal' ? '#12B76A' : lead.stage.name==='Pending' ? '#9c27b0' : lead.stage.name==='Transfer' ? '#F04438' : lead.stage.name==='Not Interested' ? '#555' : lead.stage.name==='Fresh' ? '#4caf50' :  lead.stage.name==='No Answer' ? '#FF6B35' :
  (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()))
    ? '#CC5500'
    : C.accent,
                            }}>
                              <Typography sx={{ fontSize:'11.5px', fontWeight:600, fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' }}>{lead.stage.name}</Typography>
                            </Box>
                          </Box>
                        )}
                        {lead.stagedateupdated && (
                          <Typography sx={{ fontSize:'10.5px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", mt:'2px', display:'flex', alignItems:'center', gap:'3px' }}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            {moment(lead.stagedateupdated).format('DD/MM/YY HH:mm')}
                          </Typography>
                        )}
                      </TableCell>
                    )}

                    {/* Last Comment */}
                    {colConfig.find(c=>c.key==='lastComment')?.visible && <TableCell sx={{ px:'12px', textAlign:'center' }}><CommentCell lead={lead} /></TableCell>}

                    {/* Added By */}
                    {colConfig.find(c=>c.key==='addedBy')?.visible && (
                      <TableCell sx={{ px:'12px' }}>
                        <Box sx={{ display:'flex', alignItems:'center', gap:'8px' }}>
                          <Avatar sx={{ width:30, height:30, fontSize:'11px', fontWeight:700, bgcolor:'rgba(26,62,207,0.1)', color:C.accent, fontFamily:"'DM Sans',sans-serif", flexShrink:0 }}>{getInitials(lead.addby?.name)}</Avatar>
                          <Box>
                            <Typography sx={{ fontSize:'13px', fontWeight:500, color:C.text, fontFamily:"'DM Sans',sans-serif", lineHeight:1.3 }}>{lead.addby?.name||'—'}</Typography>
                            {lead.createdAt && <Typography sx={{ fontSize:'10px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{moment(lead.createdAt).format('DD/MM/YY')}</Typography>}
                          </Box>
                        </Box>
                      </TableCell>
                    )}

                    {/* Created At */}
                    {colConfig.find(c=>c.key==='createdAt')?.visible && (
                      <TableCell sx={{ px:'12px' }}>
                        <Typography sx={{ fontSize:'13px', color:C.text, fontFamily:"'DM Sans',sans-serif", fontWeight:500 }}>{lead.createdAt ? moment(lead.createdAt).format('DD/MM/YY') : '—'}</Typography>
                        <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{lead.createdAt ? moment(lead.createdAt).format('HH:mm') : ''}</Typography>
                      </TableCell>
                    )}

                    {/* Actions */}
                    {colConfig.find(c=>c.key==='actions')?.visible && <TableCell sx={{ px:'8px', textAlign:'center' }}><ActionsMenu user={lead} allusers={loadLeads} /></TableCell>}
                  </StyledRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && resleads?.data?.length > 0 && (
            <Box sx={{ px:2.5, py:1.5, display:'flex', alignItems:'center', justifyContent:'center', borderTop:`1px solid ${C.border}`, flexWrap:'wrap', gap:1.5, bgcolor:'#ece8e8', position:'fixed', bottom:0, borderRadius:'0px 25px 25px 0px', zIndex:10, boxShadow:'0 -2px 8px rgba(16,24,40,0.06)' }}>
              <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                <Typography sx={{ fontSize:'13px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' }}>Rows per page:</Typography>
                <TextField select value={itemsPerPage} onChange={e => { setItemsPerPage(e.target.value); setCurrentPage(1); const sp=new URLSearchParams(location.search); loadLeads(1,e.target.value,searchQuery,sp.get('stage'),sp.get('duplicates'),appliedFilters); }} size="small" sx={{ width:72,'& .MuiOutlinedInput-root':{borderRadius:'8px',fontSize:'13px'} }}>
                  {[25,50,100,250].map(n => <MenuItem key={n} value={n} sx={{ fontFamily:"'DM Sans',sans-serif", fontSize:'13px' }}>{n}</MenuItem>)}
                </TextField>
              </Box>
              <Typography sx={{ fontSize:'13px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
                Showing <Box component="span" sx={{ fontWeight:700, color:C.text }}>{resleads.data.length}</Box> of <Box component="span" sx={{ fontWeight:700, color:C.text }}>{pagination?.totalItems||resleads.data.length}</Box> results
              </Typography>
              {pagination?.NumberOfPages > 1 && (
                <Pagination count={pagination.NumberOfPages} page={currentPage} size="small" showFirstButton showLastButton
                  onChange={(_,v) => { setCurrentPage(v); const sp=new URLSearchParams(location.search); loadLeads(v,itemsPerPage,searchQuery,sp.get('stage'),sp.get('duplicates'),appliedFilters); window.scrollTo({top:0,behavior:'smooth'}); }}
                  sx={{ '& .MuiPaginationItem-root':{fontFamily:"'DM Sans',sans-serif",fontSize:'13px',borderRadius:'6px',color:C.textMuted},'& .Mui-selected':{bgcolor:`${C.accent} !important`,color:'#fff',fontWeight:700},'& .MuiPaginationItem-root:hover':{bgcolor:C.accentSoft} }}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* ════════════════════════════════════════════════════
          SNACKBAR — NEW DARK PILL DESIGN
      ════════════════════════════════════════════════════ */}
      {selectedLeads.length > 0 && (
        <>
          <style>{`
            @keyframes alSnackIn {
              from { opacity:0; transform:translateX(-50%) translateY(12px) scale(0.97); }
              to   { opacity:1; transform:translateX(-50%) translateY(0) scale(1); }
            }
          `}</style>
          <div style={{
            position:'fixed', bottom:88, left:'50%',
            transform:'translateX(-50%)',
            zIndex:1400,
            animation:'alSnackIn 0.26s cubic-bezier(0.34,1.2,0.64,1) both',
          }}>
            <div style={{
              display:'flex', alignItems:'center', gap:8,
              background:'#1C2340',
              borderRadius:18, padding:'9px 13px',
              boxShadow:'0 10px 40px rgba(16,24,40,0.32), 0 2px 8px rgba(0,0,0,0.18)',
              border:'1px solid rgba(255,255,255,0.09)',
              minWidth:480,
            }}>
              {/* Count badge */}
              <div style={{ display:'flex', alignItems:'center', gap:8, background:'rgba(255,255,255,0.07)', borderRadius:12, padding:'5px 12px', flexShrink:0 }}>
                <div style={{ width:26, height:26, borderRadius:'50%', background:'#0D47A1', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, color:'#fff' }}>
                  {selectedLeads.length}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:'rgba(255,255,255,0.85)', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' }}>
                  lead{selectedLeads.length!==1?'s':''} selected
                </span>
              </div>

              <div style={{ width:1, height:28, background:'rgba(255,255,255,0.1)', flexShrink:0 }}/>

              {/* Action buttons */}
              <div style={{ display:'flex', alignItems:'center', gap:4, flex:1 }}>

{/* Ignore Duplicate — يظهر بس في صفحة duplicates */}
{new URLSearchParams(location.search).get('duplicates') === 'true' &&
 new URLSearchParams(location.search).get('ignoreduplicate') === 'true' && (
  <SnBtn
    color="#CE93D8"
    bg="rgba(206,147,216,0.15)"
    title="Ignore Duplicate Leads"
    onClick={async () => {
      if (!selectedLeads.length) return;
      try {
        await Promise.all(
          selectedLeads.map(id =>
            dispatch(UpdateClientAction(id, { ignoredublicate: 'false' }))
          )
        );
        Notify('success', 'Leads ignored duplicate successfully', 'success');
        setSelectedLeads([]); setSelectAll(false); setCurrentPage(1);
        const sp = new URLSearchParams(location.search);
        loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters);
      } catch { Notify('error', 'Failed', 'error'); }
    }}
  >
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 13H5v-2h14v2z"/>
    </svg>
    Ignore Duplicate
  </SnBtn>
)}

                {/* Transfer to Data Center */}
                <SnBtn color="#90CAF9" bg="rgba(144,202,249,0.15)" onClick={() => setDtcOpen(true)} title="Transfer to Data Center">
                  <DataUsageIcon style={{fontSize:15}}/>
                  To Data Center
                </SnBtn>

                {/* Assign */}
                <SnBtn color="#A5D6A7" bg="rgba(165,214,167,0.15)" onClick={handleAssign} title="Assign leads">
                  <PersonAddIcon style={{fontSize:15}}/>
                  Assign
                </SnBtn>

                {/* Transfer */}
                <SnBtn color="#FFCC80" bg="rgba(255,204,128,0.15)" onClick={handleTransfer} title="Transfer leads">
                  <TransferWithinAStationIcon style={{fontSize:15}}/>
                  Transfer
                </SnBtn>


{/* Bulk Edit */}
<SnBtn color="#90CAF9" bg="rgba(144,202,249,0.15)" onClick={() => setBulkEditOpen(true)} title="Bulk edit selected leads">
  <ModeEditOutlineOutlinedIcon style={{fontSize:15}}/>
  Bulk Edit
</SnBtn>


                {/* Delete */}
                <SnBtn color="#EF9A9A" bg="rgba(239,154,154,0.15)" onClick={() => setShowDelete(true)} title="Delete leads">
                  <DeleteOutlineOutlinedIcon style={{fontSize:15}}/>
                  Delete
                </SnBtn>

              </div>

              <div style={{ width:1, height:28, background:'rgba(255,255,255,0.1)', flexShrink:0 }}/>

              {/* Clear */}
              <button
                onClick={() => { setSelectedLeads([]); setSelectAll(false); }}
                style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'5px 12px', color:'rgba(255,255,255,0.55)', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", transition:'color 0.15s', flexShrink:0 }}
                onMouseEnter={e => e.target.style.color='#fff'}
                onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.55)'}
              >
                Clear
              </button>
            </div>
          </div>
        </>
      )}

      {/* ── Modals ── */}
      {/* {selectedLead && <ShowClientsActionsAdvanced user={selectedLead} leadid={selectedLead._id} onClose={() => setSelectedLead(null)} />} */}
      {selectedLead && (
  <ShowClientsActionsAdvanced
    user={selectedLead}
    leadid={selectedLead._id}
    onClose={() => setSelectedLead(null)}
    onLeadUpdated={() => {
      const sp = new URLSearchParams(location.search);
      loadLeads(currentPage, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters);
    }}
  />
)}


<BulkEditDrawer
  open={bulkEditOpen}
  onClose={() => setBulkEditOpen(false)}
  selectedLeads={selectedLeads}
  onSuccess={() => {
    setSelectedLeads([]);
    setSelectAll(false);
    refresh();
  }}
/>
      <LeadDuplicationModal open={duplication.open} onClose={() => setDuplication({open:false,leadId:null,leadName:''})} leadId={duplication.leadId} leadName={duplication.leadName} />
      <QuickFilterModal open={quickFilter}  pageType="original" onClose={() => setQuickFilter(false)} onApplyFilters={f => { setAppliedFilters(f); setCurrentPage(1); const sp=new URLSearchParams(location.search); loadLeads(1,itemsPerPage,searchQuery,sp.get('stage'),sp.get('duplicates'),f); }} />
      <ShoweetingShwwtForAdmin open={sheetOpen} onClose={() => setSheetOpen(false)} />
      {showAssign && <AssignLeadsModal show={showAssign} onHide={() => setShowAssign(false)} refreshData={refresh} />}

      {/* Delete confirm */}
      <Dialog open={showDelete} onClose={() => setShowDelete(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>Delete {selectedLeads.length} lead(s)?</DialogTitle>
        <DialogContent><Alert severity="warning">This action cannot be undone.</Alert></DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDelete(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>

      {/* DTC modal */}
      <Dialog open={dtcOpen} onClose={() => !dtcLoading && setDtcOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor:C.accent, color:'#fff', fontFamily:"'DM Sans',sans-serif", fontWeight:700, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          Transfer to Data Center
          <IconButton onClick={() => setDtcOpen(false)} sx={{ color:'#fff' }} disabled={dtcLoading}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt:3 }}>
          <Alert severity="warning" sx={{ mb:2 }}>This action cannot be undone!</Alert>
          <Typography sx={{ mb:2, fontFamily:"'DM Sans',sans-serif" }}>Transfer <strong>{selectedLeads.length} leads</strong> to Data Center.</Typography>
          <TextField fullWidth type="number" label={`Type "${selectedLeads.length}" to confirm`} value={dtcCount} onChange={e => { setDtcCount(e.target.value); setDtcError(''); }} error={!!dtcError} helperText={dtcError} disabled={dtcLoading} />
          {dtcLoading && <Box sx={{ display:'flex', gap:1, mt:2, alignItems:'center' }}><CircularProgress size={18}/><Typography variant="body2">Transferring...</Typography></Box>}
        </DialogContent>
        <DialogActions sx={{ px:3, pb:3 }}>
          <Button onClick={() => setDtcOpen(false)} disabled={dtcLoading}>Cancel</Button>
          <Button variant="contained" onClick={confirmDTC} disabled={dtcLoading||parseInt(dtcCount)!==selectedLeads.length} sx={{ bgcolor:C.accent,'&:hover':{bgcolor:C.accentDark} }}>Confirm Transfer</Button>
        </DialogActions>
      </Dialog>

      {/* Import modal */}
      <Dialog open={importOpen} onClose={() => setImportOpen(false)} maxWidth="md" fullWidth PaperProps={{ sx:{ borderRadius:'16px', overflow:'hidden' } }}>
        <DialogTitle sx={{ bgcolor:C.accentDark, color:'#fff !important', fontFamily:"'DM Sans',sans-serif", fontWeight:700, display:'flex', alignItems:'center', justifyContent:'space-between', py:2 }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
            <CloudUploadIcon />
            <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:'17px', color:'#fff !important' }}>Import Leads from Excel</Typography>
          </Box>
          <IconButton onClick={() => setImportOpen(false)} sx={{ color:'#fff' }}><CloseIcon /></IconButton>
        </DialogTitle>
        <Box sx={{ borderBottom:`1px solid ${C.border}`, px:3, display:'flex', gap:0 }}>
          {[{id:'settings',label:'⚙️ Import Settings'},{id:'template',label:'📋 Excel Template'},{id:'checkDup', label:'🔍 Check Before Upload'}].map(tab => (
            <Box key={tab.id} onClick={() => setActiveTab(tab.id)} sx={{ py:1.5, px:2, cursor:'pointer', fontSize:'13px', fontWeight:600, fontFamily:"'DM Sans',sans-serif", color: activeTab===tab.id ? C.accent : C.textMuted, borderBottom: activeTab===tab.id ? `2px solid ${C.accent}` : '2px solid transparent', transition:'all 0.15s', '&:hover':{color:C.accent} }}>
              {tab.label}
            </Box>
          ))}
        </Box>
        <DialogContent sx={{ p:0 }}>
          {activeTab==='settings' && (
            <Box sx={{ p:3 }}>
              <Box sx={{ mb:3, p:2.5, border:`1px solid ${C.border}`, borderRadius:'12px', bgcolor:C.bg }}>
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
                  <Box>
                    <Typography sx={{ fontWeight:700, fontSize:'14px', color:C.text, fontFamily:"'DM Sans',sans-serif" }}>Import Destination</Typography>
                    <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", mt:'2px' }}>Choose where to import the leads</Typography>
                  </Box>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
                    <Typography sx={{ fontSize:'13px', fontWeight:600, color: isDataCenter ? C.success : C.warning, fontFamily:"'DM Sans',sans-serif" }}>{isDataCenter ? 'Data Center' : 'Original Leads'}</Typography>
                    <Switch checked={isDataCenter} onChange={e => setIsDataCenter(e.target.checked)} sx={{ '& .MuiSwitch-thumb':{bgcolor: isDataCenter ? C.accent : C.warning},'& .MuiSwitch-track':{bgcolor: isDataCenter ? C.accentSoft : 'rgba(247,144,9,0.3)'} }} />
                  </Box>
                </Box>
              </Box>










{/* ✅ Outsource switch — جديد */}
              <Box sx={{ mb:3, p:2.5, border:`1px solid ${C.border}`, borderRadius:'12px', bgcolor:C.bg }}>
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <Box>
                    <Typography sx={{ fontWeight:700, fontSize:'14px', color:C.text, fontFamily:"'DM Sans',sans-serif" }}>Outsource</Typography>
                    <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", mt:'2px' }}>Mark all imported leads as Outsource or not</Typography>
                  </Box>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
                    <Typography sx={{ fontSize:'13px', fontWeight:600, color: isOutsource ? C.success : C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{isOutsource ? 'Yes' : 'No'}</Typography>
                    <Switch checked={isOutsource} onChange={e => setIsOutsource(e.target.checked)} sx={{ '& .MuiSwitch-thumb':{bgcolor: isOutsource ? C.success : C.textMuted},'& .MuiSwitch-track':{bgcolor: isOutsource ? C.successSoft : 'rgba(123,130,154,0.2)'} }} />
                  </Box>
                </Box>
              </Box>



              <Box sx={{ mb:3 }}>
                <Typography sx={{ fontWeight:700, fontSize:'13px', color:C.text, fontFamily:"'DM Sans',sans-serif", mb:1.5 }}>📁 Upload Excel File</Typography>
                <Box onClick={() => document.getElementById('import-file-input').click()} sx={{ border:`2px dashed ${C.border}`, borderRadius:'12px', p:4, textAlign:'center', cursor:'pointer', transition:'all 0.2s', '&:hover':{borderColor:C.accent,bgcolor:C.accentSoft} }}>
                  <CloudUploadIcon sx={{ fontSize:44, color:C.textMuted, mb:1.5 }} />
                  <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontSize:'14px', color:C.textMuted, mb:1 }}>Click to upload <strong style={{color:C.accent}}>.xlsx / .xls</strong></Typography>
                  <input id="import-file-input" type="file" accept=".xlsx,.xls" style={{display:'none'}} onChange={handleFileSelect} />
                </Box>
              </Box>
              {fileImport && (
                <Box sx={{ mb:2, p:2, bgcolor:C.accentSoft, borderRadius:'10px', border:`1px solid rgba(26,62,207,0.2)`, display:'flex', alignItems:'center', gap:1.5 }}>
                  <Box sx={{ width:36, height:36, borderRadius:'8px', bgcolor:C.accent, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px' }}>📄</Box>
                  <Box>
                    <Typography sx={{ fontWeight:600, fontSize:'13px', color:C.text, fontFamily:"'DM Sans',sans-serif" }}>{fileImport.name}</Typography>
                    <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>{(fileImport.size/1024).toFixed(1)} KB · {previewData.length} rows</Typography>
                  </Box>
                </Box>
              )}
              {importResult && <Alert severity="success" sx={{ mb:2, borderRadius:'10px' }}>✅ Imported {importResult.insertedCount||importResult.importedCount||0} leads!</Alert>}
              {importError  && <Alert severity="error"   sx={{ mb:2, borderRadius:'10px' }}>{importError}</Alert>}
            </Box>
          )}
          {activeTab==='template' && (
            <Box sx={{ p:3 }}>
              <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
                <Typography sx={{ fontWeight:700, fontSize:'15px', color:C.text, fontFamily:"'DM Sans',sans-serif" }}>📋 Excel Template</Typography>
                <Button onClick={downloadExcelTemplate} startIcon={<SystemUpdateAltIcon />} size="small" sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'12px', bgcolor:C.accent, color:'#fff', borderRadius:'8px', textTransform:'none', px:'14px', '&:hover':{bgcolor:C.accentDark} }}>
                  Download Template
                </Button>
              </Box>
              <Box sx={{ p:2, bgcolor:'rgba(247,144,9,0.06)', border:`1px solid ${C.warning}`, borderRadius:'10px' }}>
                <Typography sx={{ fontWeight:700, fontSize:'13px', color:C.text, fontFamily:"'DM Sans',sans-serif", mb:1 }}>📌 Important Notes</Typography>
                {['Keep exact column names (case-sensitive)','project_name, sales_name, chanel_name, stage_name must match system values','Dates: YYYY-MM-DD format','Phone: Include country code (+971...)'].map((note,i) => (
                  <Box key={i} sx={{ display:'flex', alignItems:'flex-start', gap:1, mb:0.75 }}>
                    <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:C.warning, mt:'6px', flexShrink:0 }} />
                    <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", lineHeight:1.5 }}>{note}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}



                   {activeTab === 'checkDup' && (
  <Box sx={{ p:3 }}>
    <Typography sx={{ fontWeight:700, fontSize:'15px', color:C.text, fontFamily:"'DM Sans',sans-serif", mb:0.5 }}>
      Check Phones Before Upload
    </Typography>
    <Typography sx={{ fontSize:'13px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", mb:3 }}>
      Upload an Excel file with a <strong>phone</strong> column — we'll check which numbers already exist.
    </Typography>

    {/* Upload area */}
    <Box
      onClick={() => document.getElementById('check-phones-input').click()}
      sx={{
        border:`2px dashed ${C.border}`, borderRadius:'12px', p:4,
        textAlign:'center', cursor:'pointer', transition:'all 0.2s', mb:3,
        '&:hover':{ borderColor:C.accent, bgcolor:C.accentSoft },
      }}
    >
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={C.textMuted} strokeWidth="1.5" style={{ marginBottom:12 }}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="17 8 12 3 7 8"/>
        <line x1="12" y1="3" x2="12" y2="15"/>
      </svg>
      <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontSize:'14px', color:C.textMuted, mb:0.5 }}>
        Click to upload <strong style={{color:C.accent}}>.xlsx / .xls</strong>
      </Typography>
      <Typography sx={{ fontFamily:"'DM Sans',sans-serif", fontSize:'12px', color:C.textMuted }}>
        File must have a column containing the word <strong>phone</strong>
      </Typography>
      <input
        id="check-phones-input"
        type="file"
        accept=".xlsx,.xls"
        style={{ display:'none' }}
        onChange={async (e) => {
          const f = e.target.files[0];
          if (!f) return;
          setCheckFile(f);
          setCheckResults(null);
          setCheckError(null);
          setCheckPhones([]);

          const reader = new FileReader();
          reader.onload = async (ev) => {
            try {
              const wb = await XLSX.readAsync(ev.target.result);
              const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
              const phones = rows
                .map(row => {
                  const key = Object.keys(row).find(k => k.toLowerCase().includes('phone'));
                  return key ? String(row[key]).trim() : null;
                })
                .filter(p => p && p !== 'undefined' && p !== '');
              setCheckPhones(phones);
            } catch {
              setCheckError('Failed to read Excel file.');
            }
          };
          reader.readAsBinaryString(f);
          // reset input علشان لو نفس الفايل اتحط تاني يشتغل
          e.target.value = '';
        }}
      />
    </Box>

    {/* File info */}
    {checkFile && (
      <Box sx={{ mb:2, p:2, bgcolor:C.accentSoft, borderRadius:'10px', border:`1px solid rgba(26,62,207,0.2)`, display:'flex', alignItems:'center', gap:1.5 }}>
        <Box sx={{ width:36, height:36, borderRadius:'8px', bgcolor:C.accent, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px', flexShrink:0 }}>📄</Box>
        <Box>
          <Typography sx={{ fontWeight:600, fontSize:'13px', color:C.text, fontFamily:"'DM Sans',sans-serif" }}>{checkFile.name}</Typography>
          <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
            {(checkFile.size/1024).toFixed(1)} KB · <strong>{checkPhones.length}</strong> phone numbers found
          </Typography>
        </Box>
      </Box>
    )}

    {checkError && <Alert severity="error" sx={{ mb:2, borderRadius:'10px' }}>{checkError}</Alert>}

    {/* Check button */}
    {checkPhones.length > 0 && !checkResults && (
      <Button
        fullWidth variant="contained"
        disabled={checkLoading}
        onClick={async () => {
          setCheckLoading(true);
          setCheckError(null);
          try {
           const res = await axios.post(
  `${db_url}api/v1/users/check-phones-duplicate`,
  { phones: checkPhones },
  {
    headers: {
      Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token}`,
    },
  }
);
            setCheckResults(res.data);
          } catch(err) {
            setCheckError(err.response?.data?.message || 'Check failed');
          }
          setCheckLoading(false);
        }}
        startIcon={checkLoading ? <CircularProgress size={16} color="inherit"/> : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        )}
        sx={{
          bgcolor:C.accent, color:'#fff', fontFamily:"'DM Sans',sans-serif",
          fontWeight:700, fontSize:'14px', borderRadius:'10px',
          textTransform:'none', py:1.5, mb:2,
          '&:hover':{ bgcolor:C.accentDark },
          '&:disabled':{ bgcolor:C.border, color:C.textMuted },
        }}
      >
        {checkLoading ? `Checking ${checkPhones.length} numbers...` : `Check ${checkPhones.length} Phone Numbers`}
      </Button>
    )}

    {/* Results */}
    {checkResults && (
      <Box>
        {/* Summary */}
        <Box sx={{ display:'flex', gap:1.5, mb:2.5, flexWrap:'wrap' }}>
          {[
            { label:'Total',    value: checkResults.summary.total,    color: C.text,    bg: C.bg },
            { label:'Existing', value: checkResults.summary.found,    color: '#B54708', bg: 'rgba(247,144,9,0.08)' },
            { label:'New',      value: checkResults.summary.notFound, color: C.success, bg: C.successSoft },
          ].map(s => (
            <Box key={s.label} sx={{ flex:1, minWidth:90, bgcolor:s.bg, border:`1px solid ${s.color}30`, borderRadius:'10px', p:2, textAlign:'center' }}>
              <Typography sx={{ fontSize:'26px', fontWeight:800, color:s.color, fontFamily:"'DM Sans',sans-serif", lineHeight:1.2 }}>{s.value}</Typography>
              <Typography sx={{ fontSize:'11px', fontWeight:600, color:s.color, fontFamily:"'DM Sans',sans-serif", textTransform:'uppercase', letterSpacing:'0.06em', mt:'2px' }}>{s.label}</Typography>
            </Box>
          ))}
        </Box>

        {/* Table */}
        <Box sx={{ maxHeight:300, overflowY:'auto', border:`1px solid ${C.border}`, borderRadius:'10px', scrollbarWidth:'thin', mb:1.5 }}>
          <table style={{ width:'100%', borderCollapse:'collapse', fontFamily:"'DM Sans',sans-serif" }}>
            <thead>
              <tr style={{ background:C.bg, position:'sticky', top:0 }}>
                {['#','Phone','Status','Lead Name','Stage','Sales'].map(h => (
                  <th key={h} style={{ padding:'10px 12px', fontSize:'11px', fontWeight:700, color:C.textMuted, textTransform:'uppercase', letterSpacing:'0.06em', textAlign:'left', borderBottom:`1px solid ${C.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {checkResults.results.map((row, i) => (
                <tr key={i} style={{ background: i%2===0 ? '#fff' : C.bg, borderBottom:`1px solid ${C.border}` }}>
                  <td style={{ padding:'9px 12px', fontSize:'12px', color:C.textMuted }}>{i+1}</td>
                  <td style={{ padding:'9px 12px', fontSize:'13px', fontWeight:600, color:C.text, fontFamily:'monospace' }}>{row.phone}</td>
                  <td style={{ padding:'9px 12px' }}>
                    <span style={{
                      display:'inline-flex', alignItems:'center', gap:5,
                      padding:'3px 10px', borderRadius:20, fontSize:'11px', fontWeight:700,
                      background: row.exists ? 'rgba(247,144,9,0.12)' : 'rgba(18,183,106,0.1)',
                      color:      row.exists ? '#B54708'               : C.success,
                    }}>
                      {row.exists ? '⚠️ Exists' : '✅ New'}
                    </span>
                  </td>
                  <td style={{ padding:'9px 12px', fontSize:'13px', color:C.text }}>{row.leadData?.name  || '—'}</td>
                  <td style={{ padding:'9px 12px', fontSize:'12px', color:C.textMuted }}>{row.leadData?.stage || '—'}</td>
                  <td style={{ padding:'9px 12px', fontSize:'12px', color:C.textMuted }}>{row.leadData?.sales || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        {/* Buttons row */}
        <Box sx={{ display:'flex', gap:1, flexWrap:'wrap' }}>
          {/* Export الأرقام الموجودة بس */}
          {checkResults.summary.found > 0 && (
            <Button
              size="small"
              startIcon={<SystemUpdateAltIcon />}
              onClick={() => {
                const exportData = checkResults.results
                  .filter(r => r.exists)
                  .map((r,i) => ({
                    '#':         i+1,
                    Phone:       r.phone,
                    'Lead Name': r.leadData?.name    || '',
                    Stage:       r.leadData?.stage   || '',
                    Sales:       r.leadData?.sales   || '',
                    Project:     r.leadData?.project || '',
                  }));
                const ws = XLSX.utils.json_to_sheet(exportData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Existing Phones');
                XLSX.writeFile(wb, `Existing_Phones_${moment().format('YYYY-MM-DD')}.xlsx`);
                Notify('success', `Exported ${exportData.length} existing phones`, 'success');
              }}
              sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'12px', color:'#B54708', border:`1px solid rgba(247,144,9,0.3)`, borderRadius:'8px', textTransform:'none', px:'14px', bgcolor:'rgba(247,144,9,0.06)', '&:hover':{ bgcolor:'rgba(247,144,9,0.12)' } }}
            >
              Export Existing ({checkResults.summary.found})
            </Button>
          )}


{/* Export الأرقام الجديدة بس */}
{checkResults.summary.notFound > 0 && (
  <Button
    size="small"
    startIcon={<SystemUpdateAltIcon />}
    onClick={() => {
      const exportData = checkResults.results
        .filter(r => !r.exists)
        .map((r, i) => ({
          '#':   i + 1,
          Phone: r.phone,
        }));
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'New Phones');
      XLSX.writeFile(wb, `New_Phones_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', `Exported ${exportData.length} new phones`, 'success');
    }}
    sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'12px', color:C.success, border:`1px solid rgba(18,183,106,0.3)`, borderRadius:'8px', textTransform:'none', px:'14px', bgcolor:'rgba(18,183,106,0.06)', '&:hover':{ bgcolor:'rgba(18,183,106,0.12)' } }}
  >
    Export New ({checkResults.summary.notFound})
  </Button>
)}

          {/* Export كل النتايج */}
          <Button
            size="small"
            startIcon={<SystemUpdateAltIcon />}
            onClick={() => {
              const exportData = checkResults.results.map((r,i) => ({
                '#':         i+1,
                Phone:       r.phone,
                Status:      r.exists ? 'EXISTS' : 'NEW',
                'Lead Name': r.leadData?.name    || '',
                Stage:       r.leadData?.stage   || '',
                Sales:       r.leadData?.sales   || '',
                Project:     r.leadData?.project || '',
              }));
              const ws = XLSX.utils.json_to_sheet(exportData);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, 'Phone Check Results');
              XLSX.writeFile(wb, `Phone_Check_${moment().format('YYYY-MM-DD')}.xlsx`);
              Notify('success', `Exported ${exportData.length} results`, 'success');
            }}
            sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'12px', color:C.accent, border:`1px solid ${C.border}`, borderRadius:'8px', textTransform:'none', px:'14px', '&:hover':{ borderColor:C.accent, bgcolor:C.accentSoft } }}
          >
            Export All Results
          </Button>

          {/* Check another file */}
          <Button
            size="small"
            onClick={() => { setCheckFile(null); setCheckPhones([]); setCheckResults(null); setCheckError(null); }}
            sx={{ fontFamily:"'DM Sans',sans-serif", fontSize:'12px', color:C.textMuted, textTransform:'none', borderRadius:'8px' }}
          >
            Check Another File
          </Button>
        </Box>
      </Box>
    )}
  </Box>
)}
        </DialogContent>
        <DialogActions sx={{ px:3, py:2, borderTop:`1px solid ${C.border}`, bgcolor:C.bg, display:'flex', justifyContent:'space-between' }}>
          <Button onClick={() => setImportOpen(false)} sx={{ fontFamily:"'DM Sans',sans-serif", color:C.textMuted, textTransform:'none', borderRadius:'8px' }}>Cancel</Button>
          <Button onClick={doImport} disabled={importLoading||!fileImport} startIcon={importLoading ? <CircularProgress size={16} color="inherit"/> : <CloudUploadIcon/>}
            sx={{ fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:'13px', bgcolor:C.accent, color:'#fff', textTransform:'none', borderRadius:'8px', px:'20px', '&:hover':{bgcolor:C.accentDark}, '&:disabled':{bgcolor:C.border,color:C.textMuted} }}>
            {importLoading ? `Importing...` : `Import ${previewData.length>0?previewData.length:''} Leads`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Settings Drawer */}
      <Drawer anchor="right" open={settingsOpen} onClose={() => setSettingsOpen(false)} PaperProps={{ sx:{ width:380, bgcolor:'#F4F6FB !important', display:'flex', flexDirection:'column' } }}>
        <Box sx={{ px:2.5, py:2, bgcolor:C.white, borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', gap:1 }}>
          <IconButton onClick={() => setSettingsOpen(false)} size="small" sx={{ color:C.text, mr:0.5 }}><CloseIcon fontSize="small" /></IconButton>
          <Typography sx={{ fontWeight:700, fontSize:'17px', fontFamily:"'DM Sans',sans-serif", color:C.text, flex:1 }}>Export Options</Typography>
        </Box>
        <Box sx={{ flex:1, overflowY:'auto', scrollbarWidth:'none','&::-webkit-scrollbar':{display:'none'} }}>
          <Box sx={{ px:2.5, pt:2.5, pb:2, display:'flex', flexDirection:'column', gap:1.5 }}>
            {[{label:'Export to Excel with Last Comment',fn:exportExcel},{label:'Export with All Comments',fn:exportAllComments}].map(item => (
              <Box key={item.label} onClick={item.fn} sx={{ display:'flex', alignItems:'center', gap:2, px:2.5, py:2, bgcolor:C.accent, borderRadius:'14px', cursor:'pointer', transition:'all 0.15s', boxShadow:'0 4px 14px rgba(26,62,207,0.25)', '&:hover':{bgcolor:C.accentDark,transform:'translateY(-1px)'} }}>
                <Box sx={{ width:44, height:44, borderRadius:'10px', bgcolor:'rgba(255,255,255,0.15)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <SystemUpdateAltIcon sx={{ color:'#fff', fontSize:'22px' }} />
                </Box>
                <Typography sx={{ fontWeight:700, fontSize:'15px', color:'#fff', fontFamily:"'DM Sans',sans-serif", lineHeight:1.3 }}>{item.label}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={{ px:2.5, pb:3 }}>
            <Typography sx={{ fontSize:'12px', fontWeight:700, color:C.accent, letterSpacing:'0.1em', textTransform:'uppercase', fontFamily:"'DM Sans',sans-serif", mb:2 }}>Column Order &amp; Visibility</Typography>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="columns">
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ display:'flex', flexDirection:'column', gap:'10px' }}>
                    {colConfig.map((col, index) => (
                      <Draggable key={col.key} draggableId={col.key} index={index}>
                        {(provided, snapshot) => (
                          <Box ref={provided.innerRef} {...provided.draggableProps} sx={{ display:'flex', alignItems:'center', gap:1.5, px:2, py:1.5, bgcolor: snapshot.isDragging ? '#E8ECFF' : C.white, borderRadius:'14px', border:`1.5px solid ${snapshot.isDragging ? C.accent : C.border}`, boxShadow: snapshot.isDragging ? '0 8px 24px rgba(26,62,207,0.18)' : '0 1px 3px rgba(16,24,40,0.06)', userSelect:'none' }}>
                            <IconButton size="small" onClick={() => toggleColVisibility(col.key)} sx={{ width:34, height:34, borderRadius:'50%', flexShrink:0, color: col.visible ? C.accent : C.textMuted, bgcolor: col.visible ? C.accentSoft : 'rgba(123,130,154,0.08)' }}>
                              {col.visible ? <VisibilityIcon sx={{fontSize:'17px'}}/> : <VisibilityOffIcon sx={{fontSize:'17px'}}/>}
                            </IconButton>
                            <Box sx={{ flex:1, minWidth:0 }}>
                              <Typography sx={{ fontSize:'14px', fontWeight:600, color: col.visible ? C.text : C.textMuted, fontFamily:"'DM Sans',sans-serif", textDecoration: col.visible ? 'none' : 'line-through' }}>{col.label}</Typography>
                              <Typography sx={{ fontSize:'10.5px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif", letterSpacing:'0.05em', textTransform:'uppercase' }}>ID: {col.fieldId}</Typography>
                            </Box>
                            <Box sx={{ width:48, height:36, bgcolor:'#F0F2F9', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                              <input type="number" value={col.w} onChange={e => updateColWidth(col.key, e.target.value)} onClick={e => e.stopPropagation()} style={{ width:'100%', height:'100%', border:'none', outline:'none', background:'transparent', textAlign:'center', fontSize:'13px', fontWeight:600, color:C.text, fontFamily:"'DM Sans',sans-serif" }} />
                            </Box>
                            <Box {...provided.dragHandleProps} sx={{ display:'flex', flexDirection:'column', gap:'3px', cursor:'grab', px:'2px', flexShrink:0 }}>
                              {[0,1,2].map(r => <Box key={r} sx={{ display:'flex', gap:'3px' }}>{[0,1].map(c => <Box key={c} sx={{ width:4, height:4, borderRadius:'50%', bgcolor: snapshot.isDragging ? C.accent : C.textMuted, opacity:0.6 }} />)}</Box>)}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
        </Box>
        <Box sx={{ px:2.5, py:2, borderTop:`1px solid ${C.border}`, bgcolor:C.white, display:'flex', gap:1 }}>
          <Button fullWidth variant="outlined" onClick={() => setColConfig(DEFAULT_COLS)} sx={{ borderColor:C.border, color:C.textMuted, fontFamily:"'DM Sans',sans-serif", textTransform:'none', borderRadius:'10px', '&:hover':{borderColor:C.accent,color:C.accent} }}>Reset to Default</Button>
          <Button fullWidth variant="contained" onClick={() => setSettingsOpen(false)} sx={{ bgcolor:C.accent,'&:hover':{bgcolor:C.accentDark}, textTransform:'none', fontFamily:"'DM Sans',sans-serif", borderRadius:'10px', fontWeight:600 }}>Done</Button>
        </Box>
      </Drawer>
    </Box>
  );
};
